/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2199),
    getSymbols = __webpack_require__(4664),
    keys = __webpack_require__(5950);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 14:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(5389),
    baseUniq = __webpack_require__(5765);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 79:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3702),
    listCacheDelete = __webpack_require__(80),
    listCacheGet = __webpack_require__(4739),
    listCacheHas = __webpack_require__(8655),
    listCacheSet = __webpack_require__(1175);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 80:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 181:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 197:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'file';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f15b';
var svgPathData = 'M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.A4 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 260:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'sync';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f021';
var svgPathData = 'M500 8h-27.711c-6.739 0-12.157 5.548-11.997 12.286l2.347 98.575C418.212 52.043 342.256 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h28.576c5.674 0 10.542-3.982 11.737-9.529C83.441 126.128 161.917 60 256 60c79.545 0 147.942 47.282 178.676 115.302l-126.39-3.009c-6.737-.16-12.286 5.257-12.286 11.997V212c0 6.627 5.373 12 12 12h192c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-12.103 280h-28.576c-5.674 0-10.542 3.982-11.737 9.529C428.559 385.872 350.083 452 256 452c-79.546 0-147.942-47.282-178.676-115.302l126.39 3.009c6.737.16 12.286-5.257 12.286-11.997V300c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v192c0 6.627 5.373 12 12 12h27.711c6.739 0 12.157-5.548 11.997-12.286l-2.347-98.575C93.788 459.957 169.744 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.VN = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(7068),
    isObjectLike = __webpack_require__(346);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 289:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 317:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 392:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(7237),
    basePropertyDeep = __webpack_require__(7255),
    isKey = __webpack_require__(8586),
    toKey = __webpack_require__(7797);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(8077),
    hasPath = __webpack_require__(9326);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(6649),
    keys = __webpack_require__(5950);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'search';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f002';
var svgPathData = 'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Mj = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 756:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(756),
    keys = __webpack_require__(5950);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SendEmail_SendEmail; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SendEmail/SendEmail.vue?vue&type=template&id=112de3a2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.mail)?_c('div',{class:{
    'form-mail': true,
    'd-flex': true,
    'flex-column': true,
    'collapsed': _vm.value.mode === 'collapsed',
    'fullscreen': _vm.value.mode === 'fullscreen'
  }},[(_vm.inlineMode === false)?_c('b-form-row',{staticClass:"mail-header"},[_c('b-col',{staticClass:"mail-title",attrs:{"align-self":"center"}},[_vm._v(" "+_vm._s(_vm.mailTitle)+" ")]),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ placement: _vm.value.mode === 'collapsed' ? 'top' : 'bottom' }),expression:"{ placement: value.mode === 'collapsed' ? 'top' : 'bottom' }"}],attrs:{"variant":"icon","title":_vm.collapseTitle},on:{"click":function($event){$event.preventDefault();return _vm.collapse.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.collapseIcon}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],attrs:{"variant":"icon","title":_vm.fullscreenTitle},on:{"click":function($event){$event.preventDefault();return _vm.fullscreen.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.fullscreenIcon}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],attrs:{"variant":"icon","title":_vm.$t('communication.mail.form.saveClose')},on:{"click":function($event){$event.preventDefault();return _vm.close.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)],1)],1):_vm._e(),(_vm.value.mode !== 'collapsed')?_c('k-form',{staticClass:"d-flex flex-column",attrs:{"action":_vm.formAction,"method":"post","keepLoaderAfterSubmit":""},on:{"beforeSubmit":_vm.clearTimeout,"submitComplete":_vm.submitComplete,"submitError":_vm.submitError},model:{value:(_vm.formDatas),callback:function ($$v) {_vm.formDatas=$$v},expression:"formDatas"}},[_c('b-overlay',{staticClass:"d-flex flex-column",attrs:{"show":_vm.computedSenders.length === 0 || !_vm.initialized},scopedSlots:_vm._u([(!_vm.resendEmailValidationLoader && _vm.initialized)?{key:"overlay",fn:function(){return [_c('div',{staticClass:"text-center"},[(_vm.computedSenders.length === 0 && _vm.senders.length > 0)?[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.needValidSender'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.goToUserProfile.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.senderConfig'))+" ")])]:(_vm.user.email_validation)?[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.needValidSender'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.validSender'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.resendEmailValidation.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.resend'))+" ")])]:[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.needAddSender'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.goToUserProfile.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.senderConfig'))+" ")])]],2)]},proxy:true}:null],null,true)},[(_vm.showTopElements)?_c('b-input-group',{staticClass:"mb-2",attrs:{"prepend":_vm.$t('communication.mail.form.from'),"size":"sm"}},[_c('k-form-select',{attrs:{"clearable":false,"size":"sm","options":_vm.computedSenders,"getOptionLabel":opt => opt.name + ' <' + opt.address + '>'},model:{value:(_vm.mail.sender),callback:function ($$v) {_vm.$set(_vm.mail, "sender", $$v)},expression:"mail.sender"}})],1):_vm._e(),_c('b-form-row',[_c('b-col',[_c('b-input-group',{staticClass:"mb-2",attrs:{"prepend":_vm.$t('communication.mail.form.to'),"size":"sm"},on:{"click":function($event){_vm.showTopElements = true}}},[_c('k-form-select',_vm._g(_vm._b({staticClass:"recipients-select",attrs:{"dropdownShouldOpen":_vm.dropdownShouldOpen},model:{value:(_vm.mail.to),callback:function ($$v) {_vm.$set(_vm.mail, "to", $$v)},expression:"mail.to"}},'k-form-select',_vm.recipientsAttributes(true),false),_vm.recipientsEvents()))],1)],1),(_vm.showTopElements && !_vm.showCc)?_c('b-col',{staticClass:"p-0",attrs:{"cols":"auto"}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],attrs:{"size":"sm","variant":"link","title":_vm.$t('communication.mail.form.addCc')},on:{"click":function($event){$event.preventDefault();_vm.showCc = true}}},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.cc'))+" ")])],1):_vm._e(),(_vm.showTopElements && !_vm.showCci)?_c('b-col',{staticClass:"p-0",attrs:{"cols":"auto"}},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],attrs:{"size":"sm","variant":"link","title":_vm.$t('communication.mail.form.addCci')},on:{"click":function($event){$event.preventDefault();_vm.showCci = true}}},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.cci'))+" ")])],1):_vm._e()],1),(_vm.showCc)?_c('b-input-group',{staticClass:"mb-2",attrs:{"prepend":_vm.$t('communication.mail.form.cc'),"size":"sm"}},[_c('k-form-select',_vm._g(_vm._b({staticClass:"recipients-select",model:{value:(_vm.mail.cc),callback:function ($$v) {_vm.$set(_vm.mail, "cc", $$v)},expression:"mail.cc"}},'k-form-select',_vm.recipientsAttributes(true),false),_vm.recipientsEvents()))],1):_vm._e(),(_vm.showCci)?_c('b-input-group',{staticClass:"mb-2",attrs:{"prepend":_vm.$t('communication.mail.form.cci'),"size":"sm"}},[_c('k-form-select',_vm._g(_vm._b({staticClass:"recipients-select",model:{value:(_vm.mail.cci),callback:function ($$v) {_vm.$set(_vm.mail, "cci", $$v)},expression:"mail.cci"}},'k-form-select',_vm.recipientsAttributes(true),false),_vm.recipientsEvents()))],1):_vm._e(),_c('k-form-input',{staticClass:"input-subject mb-2",attrs:{"placeholder":_vm.$t('communication.mail.form.subject'),"name":"subject","size":"sm"},on:{"focus":_vm.cleanTopElements},model:{value:(_vm.mail.subject),callback:function ($$v) {_vm.$set(_vm.mail, "subject", $$v)},expression:"mail.subject"}}),_c('div',{staticClass:"mail-editor",on:{"click":_vm.cleanTopElements}},[(_vm.initialized)?_c('k-form-editor',{ref:"editor",attrs:{"name":"html","config":_vm.editorConfig,"required":"","size":"sm"},model:{value:(_vm.mail.html),callback:function ($$v) {_vm.$set(_vm.mail, "html", $$v)},expression:"mail.html"}}):_vm._e()],1),(_vm.mail.add_attachments.length > 0 || _vm.mail.attachments.length > 0 || _vm.mail.add_files.length > 0)?_c('div',{staticClass:"mail-attachments"},[(_vm.mail.attachments.length > 0)?_c('MailAttachments',{staticClass:"d-inline mr-1",attrs:{"baseUrl":"/mail/attachment","attachments":_vm.mail.attachments},on:{"remove":_vm.removeAttachment}}):_vm._e(),(_vm.mail.add_attachments.length > 0)?_c('MailAttachments',{staticClass:"d-inline mr-1",attrs:{"baseUrl":"/mail/attachment","attachments":_vm.mail.add_attachments}}):_vm._e(),(_vm.mail.add_files.length > 0)?_c('MailAttachments',{staticClass:"d-inline mr-1",attrs:{"attachments":_vm.mail.add_files}}):_vm._e()],1):_vm._e(),_c('b-form-row',{staticClass:"mail-menu mt-2"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button-group',[_c('b-button',{attrs:{"variant":"primary","size":"sm","type":"submit"}},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.send'))+" "),(_vm.waitDatetime)?_c('span',{staticClass:"text-lowercase"},[_vm._v(" "+_vm._s(_vm.datetime(_vm.waitDatetime))+" ")]):_vm._e()]),( false)?0:_vm._e()],2)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('k-form-file',{attrs:{"url":_vm.attachmentUrl,"datas":_vm.formDatas,"imagePreview":false,"removeUploadedFile":true,"name":'add_attachments[' + _vm.mail.add_attachments.length + ']',"multiple":"","onUploadStart":_vm.clearTimeout},on:{"onUpload":_vm.fileUploaded},scopedSlots:_vm._u([{key:"button",fn:function({ selectFile }){return [_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"variant":"icon","title":_vm.$t('communication.mail.form.addFiles')},on:{"click":function($event){$event.preventDefault();return selectFile.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'paperclip']}})],1)]}}],null,false,2498803877)})],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('LibraryListButton',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"variant":"icon","title":_vm.$t('communication.mail.form.filesLibrary'),"icon":['fas', 'book'],"label":null},on:{"added":_vm.addLibraryFile}})],1),(_vm.value.customer)?_c('b-col',{attrs:{"cols":"auto"}},[_c('CustomerLibraryButton',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"variant":"icon","title":_vm.$t('communication.mail.form.filesCustomer'),"icon":['fas', 'file-user'],"label":null,"customerId":_vm.value.customer.id},on:{"added":_vm.addLibraryFile}})],1):_vm._e(),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-overlay',{attrs:{"show":_vm.modelLoading}},[_c('b-dropdown',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],ref:"dropdown-models",staticClass:"pb-0",attrs:{"variant":"icon","title":_vm.$t('communication.mail.form.loadModel'),"no-caret":"","menu-class":"models-dropdown","dropup":""},on:{"shown":_vm.modelListOpenned,"hidden":function($event){_vm.searchModel = null}},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('font-awesome-icon',{attrs:{"icon":['fas', 'mail-bulk']}})]},proxy:true}],null,false,3266838376)},[_c('b-dropdown-group',[(_vm.models.length === 0)?_c('b-dropdown-text',[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.noModel'))+" ")]):_vm._e(),_vm._l((_vm.computedModels),function(model){return _c('b-dropdown-item',{key:model.id,on:{"click":function($event){$event.preventDefault();return _vm.applyModel(model)}}},[_vm._v(" "+_vm._s(model.name)+" ")])}),(_vm.searchModel !== null && _vm.computedModels.length === 0)?_c('b-dropdown-text',[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.noSearchModel'))+" ")]):_vm._e()],2),(_vm.models.length > 10)?_c('b-dropdown-form',{attrs:{"form-class":"pb-0"}},[_c('k-form-input',{ref:"models-search",attrs:{"type":"search","size":"sm","placeholder":_vm.$t('communication.mail.form.searchModel')},model:{value:(_vm.searchModel),callback:function ($$v) {_vm.searchModel=$$v},expression:"searchModel"}})],1):_vm._e()],1)],1)],1)],1)],1)],1):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.yes'),"cancel-title":_vm.$t('interface.no')},on:{"ok":function($event){return _vm.applyModel(_vm.usedModel)}},model:{value:(_vm.askApplyModel),callback:function ($$v) {_vm.askApplyModel=$$v},expression:"askApplyModel"}},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.contactUpdated'))+" ")]),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.close'),"ok-only":""},model:{value:(_vm.limitExceeded),callback:function ($$v) {_vm.limitExceeded=$$v},expression:"limitExceeded"}},[_c('div',{staticClass:"text-justify"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.limitExplain1'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('communication.mail.form.limitExplain2'))+" "),_c('router-link',{attrs:{"to":{ name: 'user-profile' }},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('communication.mail.form.limitExplain3')))]),_vm._v(" : "),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('communication.mail.form.limitExplain4')))]),_c('li',[_vm._v(_vm._s(_vm.$t('communication.mail.form.limitExplain5')))]),_c('li',[_vm._v(_vm._s(_vm.$t('communication.mail.form.limitExplain6')))])])],1)])],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(5364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(14);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./src/components/SendEmail/editorConfig.ts
var buttons = [
    'bold',
    'italic',
    'underline',
    '|',
    'fontSize',
    '|',
    'textColor',
    'backgroundColor',
    '|',
    'formatUL',
    'formatOL',
    'quote',
    '|',
    'insertImage',
    'insertTable',
    'insertHR',
    'insertLink',
    '|',
    'align'
];
var config = {
    useClasses: false,
    toolbarButtons: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 15
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: [],
            align: 'right',
            buttonsVisible: 0
        }
    },
    toolbarButtonsXS: {
        moreText: {
            buttons: buttons,
            buttonsVisible: 8
        }
    },
    tableEditButtons: [
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableBorder',
        'tableBackground',
        '-',
        'tableCells',
        'tableCellBackground',
        'tableCellBorder',
        'tableCellHorizontalAlign'
    ],
    imageInsertButtons: ['imageByURL'],
    events: {
        'initialized': function () {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.$el[0].classList.remove('fr-view');
        }
    }
};
/* harmony default export */ var editorConfig = (config);

// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var index_es = __webpack_require__(1273);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/LibraryListButton/LibraryListButton.vue + 3 modules
var LibraryListButton = __webpack_require__(8546);
// EXTERNAL MODULE: ./src/components/CustomerLibraryButton/CustomerLibraryButton.vue + 3 modules
var CustomerLibraryButton = __webpack_require__(4831);
// EXTERNAL MODULE: ./src/components/Attachments/Attachments.vue + 3 modules
var Attachments = __webpack_require__(4321);
// EXTERNAL MODULE: ./src/components/EmailDelete/EmailDelete.vue + 3 modules
var EmailDelete = __webpack_require__(3070);
// EXTERNAL MODULE: ./src/mixins/VariablesMixin.ts
var VariablesMixin = __webpack_require__(3717);
// EXTERNAL MODULE: ./src/components/MailboxLater/MailboxLater.vue + 3 modules
var MailboxLater = __webpack_require__(5757);
// EXTERNAL MODULE: ./src/fetchDatas/mailModel.ts
var mailModel = __webpack_require__(3644);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SendEmail/SendEmail.ts?vue&type=script&lang=ts&external

















var SendEmail = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SendEmail, _super);
    function SendEmail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Local email
        _this.mail = {
            subject: null,
            html: null,
            text: null,
            to: [],
            cc: [],
            cci: [],
            elements: [],
            add_files: [],
            attachments: [],
            add_attachments: [],
            remove_attachments: [],
            wait_datetime: null
        };
        _this.initialized = false;
        _this.contacts = [];
        _this.showTopElements = null;
        _this.showCc = false;
        _this.showCci = false;
        _this.searchedRecipients = [];
        _this.searchedTimeout = null;
        _this.resendEmailValidationLoader = false;
        _this.usedModel = null;
        _this.askApplyModel = false;
        _this.searchModel = null;
        _this.limitExceeded = false;
        _this.modelLoading = false;
        _this.timeoutSave = null;
        _this.waitDatetime = null;
        return _this;
    }
    SendEmail.prototype.mounted = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.loadSenders()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.loadModels()];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, this.watchValue(this.value)];
                    case 4:
                        _b.sent();
                        if (!(this.preload && !((_a = this.mail) === null || _a === void 0 ? void 0 : _a.id) && this.teamConfigs['communication_model_' + this.preload])) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.applyModel(this.teamConfigs['communication_model_' + this.preload])];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        this.applySignature();
                        _b.label = 7;
                    case 7:
                        this.$nextTick(function () {
                            _this.initialized = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    SendEmail.prototype.beforeDestroy = function () {
        this.clearTimeout();
    };
    Object.defineProperty(SendEmail.prototype, "computedModels", {
        get: function () {
            var _this = this;
            if (!this.searchModel) {
                return this.models;
            }
            return this.models.filter(function (model) { var _a; return model.name.toLowerCase().indexOf((_a = _this.searchModel) === null || _a === void 0 ? void 0 : _a.toLowerCase()) >= 0; });
        },
        enumerable: false,
        configurable: true
    });
    SendEmail.prototype.watchComputedModels = function () {
        var dropdown = this.$refs['dropdown-models'];
        var popper = dropdown.$_popper;
        if (popper) {
            popper.update();
        }
    };
    Object.defineProperty(SendEmail.prototype, "computedSenders", {
        get: function () {
            var _this = this;
            var _a;
            return ((_a = this.senders) !== null && _a !== void 0 ? _a : [])
                .filter(function (sender) { return sender.status.active && sender.is_validated; })
                .map(function (sender) {
                if (!sender.name) {
                    sender.name = _this.user.fullname;
                }
                return sender;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "computedDefaultSender", {
        get: function () {
            var _a, _b;
            var sender = (_b = (_a = this.defaultSender) !== null && _a !== void 0 ? _a : this.computedSenders[0]) !== null && _b !== void 0 ? _b : null;
            if (sender && !sender.name) {
                sender.name = this.user.fullname;
            }
            return sender;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "editorConfig", {
        // return editor configuration
        get: function () {
            return merge_default()(editorConfig, {
                height: this.inlineMode === false ? 'calc(100% - 32px)' : null
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "formAction", {
        // Form url
        get: function () {
            if (this.mail.id) {
                return '/mail/draft/' + this.mail.id + '/' + (this.waitDatetime ? 'program' : 'send');
            }
            return '/mail/' + (this.waitDatetime ? 'send/program' : 'send');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "attachmentUrl", {
        // Url for file upload (draft)
        get: function () {
            var url = '/mail/draft';
            if (this.mail.id) {
                url += '/' + this.mail.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "formDatas", {
        // Return form data
        get: function () {
            var _a, _b;
            var mapRecipient = function (recipient) {
                var _a, _b;
                return ({
                    type: (_a = recipient.type) !== null && _a !== void 0 ? _a : null,
                    id: (_b = recipient.id) !== null && _b !== void 0 ? _b : null,
                    email: recipient.mail,
                });
            };
            var mail = this.mail;
            var datas = {
                thread: (_a = mail.thread_id) !== null && _a !== void 0 ? _a : null,
                sender: mail.sender ? mail.sender.id : null,
                subject: mail.subject,
                html: mail.html,
                to: mail.to.map(mapRecipient),
                cc: mail.cc.map(mapRecipient),
                cci: mail.cci.map(mapRecipient),
                elements: mail.elements ? mail.elements.map(function (element) { return ({ id: element.id, type: element.type }); }) : null,
                is_reminder: (_b = mail.is_reminder) !== null && _b !== void 0 ? _b : false
            };
            if (this.waitDatetime) {
                datas.wait_datetime = this.waitDatetime;
            }
            if (mail.add_files.length > 0) {
                datas.add_files = mail.add_files.map(function (file) { return file.id; });
            }
            if (mail.attachments.length > 0) {
                datas.attachments = mail.attachments.map(function (file) { return file.id; });
            }
            if (mail.add_attachments.length > 0) {
                datas.add_attachments = mail.add_attachments.map(function (file) { return file.id; });
            }
            if (mail.remove_attachments.length > 0) {
                datas.remove_attachments = mail.remove_attachments.map(function (file) { return file.id; });
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "collapseIcon", {
        // Collapse button icon
        get: function () {
            return ['far', 'window-' + (this.value.mode === 'collapsed' ? 'maximize' : 'minimize')];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "collapseTitle", {
        // Collapse button title
        get: function () {
            return this.value.mode === 'collapsed' ? this.$t('communication.mail.form.enlarge') : this.$t('communication.mail.form.reduce');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "fullscreenIcon", {
        // Fullscreen button icon
        get: function () {
            return ['fas', this.value.mode === 'fullscreen' ? 'compress-alt' : 'expand-alt'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "fullscreenTitle", {
        // Fullscreen button title
        get: function () {
            return this.value.mode === 'fullscreen' ? this.$t('communication.mail.form.fullscreenOut') : this.$t('communication.mail.form.fullscreen');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "mailTitle", {
        // Mail title
        get: function () {
            return this.mail.subject ? this.mail.subject : this.$t('communication.mail.form.newMessage');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "dropdownShouldOpen", {
        // if recipients dropdown should be open
        get: function () {
            var _this = this;
            return function (select) {
                if (!_this.showTopElements) {
                    select.open = false;
                    return false;
                }
                return select.noDrop ? false : select.open && !select.mutableLoading;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmail.prototype, "recipients", {
        // Return recipients options
        get: function () {
            var recipients = [];
            if (this.searchedRecipients.length > 0) {
                this.searchedRecipients
                    .filter(function (contact) { return contact.email != ''; })
                    .forEach(function (contact) {
                    recipients.push({
                        type: 'contact',
                        id: contact.id,
                        name: contact.fullname,
                        mail: contact.email,
                        data: contact
                    });
                });
                return uniqBy_default()(recipients, 'mail');
            }
            var customer = this.value.customer;
            var contact = this.value.contact;
            var contacts = this.contacts.filter(function (contact) { return contact.email != ''; });
            if ((customer && customer.email) || contacts.length > 0) {
                recipients.push({
                    name: this.$t('communication.mail.form.tiers'),
                    disabled: true
                });
                if (customer && customer.email) {
                    recipients.push({
                        type: 'customer',
                        id: customer.id,
                        name: customer.name,
                        mail: customer.email,
                        data: customer
                    });
                }
                this.contacts.filter(function (contact) { return contact.email != ''; })
                    .forEach(function (contact) {
                    recipients.push({
                        type: 'contact',
                        id: contact.id,
                        name: contact.fullname,
                        mail: contact.email,
                        data: contact
                    });
                });
            }
            else if (contact && contact.email) {
                recipients.push({
                    name: this.$t('communication.mail.form.contact'),
                    disabled: true
                });
                recipients.push({
                    type: 'contact',
                    id: contact.id,
                    name: contact.fullname,
                    mail: contact.email,
                    data: contact
                });
            }
            recipients.push({
                name: this.$t('communication.mail.form.user'),
                disabled: true
            });
            this.activeTeamUsers.forEach(function (teamUser) {
                recipients.push({
                    type: 'teamUser',
                    id: teamUser.id,
                    name: teamUser.fullname,
                    mail: teamUser.email,
                    data: teamUser
                });
            });
            return recipients.filter(function (value, index, self) {
                return !('mail' in value) || self.findIndex(function (recipient) { return 'mail' in recipient && recipient.mail && recipient.mail === value.mail; }) === index;
            });
        },
        enumerable: false,
        configurable: true
    });
    // Return recipient k-form-select attributes
    SendEmail.prototype.recipientsAttributes = function (required) {
        if (required === void 0) { required = false; }
        return {
            multiple: true,
            taggable: true,
            validate: { required: required, arrayOf: { items: 'mailRecipient' } },
            size: 'sm',
            options: this.recipients,
            label: 'mail',
            getOptionKey: function (opt) { return opt.mail; },
            getOptionLabel: function (opt) {
                if (opt.name && opt.mail) {
                    return opt.name + ' <' + opt.mail + '>';
                }
                else if (opt.name) {
                    return opt.name;
                }
                else {
                    return opt.mail;
                }
            }
        };
    };
    // Return recipient k-form-select events
    SendEmail.prototype.recipientsEvents = function () {
        return {
            search: this.searchRecipients,
            close: this.closeRecipients
        };
    };
    SendEmail.prototype.watchSender = function () {
        if (!this.initialized) {
            return;
        }
        this.applySignature();
    };
    SendEmail.prototype.watchMailTo = function (value, oldValue) {
        if (JSON.stringify(value) === JSON.stringify(oldValue) || this.mail.to.length === 0) {
            return;
        }
        if (this.usedModel && this.usedModel.html.includes('data-variable="CONTACT-')) {
            var content = this.getModelContents(this.usedModel);
            var clean = function (content) {
                if (!content) {
                    content = '';
                }
                content = content.replaceAll(/\n|\r/g, '')
                    .replaceAll(/<br \/>|<br\/>/g, '<br>')
                    .replaceAll('&nbsp;', ' ')
                    .replaceAll(/>\s+</g, '><');
                return content;
            };
            if (this.mail.subject !== content.subject || clean(this.mail.html) !== clean(content.html + this.getSignature())) {
                this.askApplyModel = true;
            }
        }
    };
    SendEmail.prototype.applySignature = function () {
        var _a;
        var sender = this.mail.sender;
        if (!sender || !sender.signature) {
            return;
        }
        var div = document.createElement('div');
        div.innerHTML = (_a = this.mail.html) !== null && _a !== void 0 ? _a : '';
        var existingSignature = div.querySelector('div.mail_signature');
        if (existingSignature) {
            existingSignature.remove();
        }
        if (div.innerHTML === '') {
            div.innerHTML = '<div><br/></div>';
        }
        var signature = document.createElement('div');
        signature.innerHTML = sender.signature;
        signature.classList.add('mail_signature');
        var quote = div.querySelector('.kwixeo-blockquote');
        if (quote) {
            signature.innerHTML += '<br/><br/>';
        }
        div.insertBefore(signature, quote);
        this.mail.html = div.innerHTML;
    };
    // Return signature datas
    SendEmail.prototype.getSignature = function () {
        var sender = this.mail.sender;
        if (!sender || !sender.signature) {
            return '';
        }
        return '<div class="mail_signature">' + sender.signature + '</div>';
    };
    // Watch external value change
    SendEmail.prototype.watchValue = function (value, old) {
        var _a, _b, _c, _d;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var customer, contact;
            return (0,tslib_es6/* __generator */.YH)(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.applyLocalMail(value.mail);
                        if (this.initialized) {
                            return [2 /*return*/];
                        }
                        customer = value.customer;
                        if (customer) {
                            (_a = this.mail.elements) === null || _a === void 0 ? void 0 : _a.push({
                                type: 'customer',
                                id: customer.id,
                                title: customer.name,
                                data: customer
                            });
                        }
                        contact = value.contact;
                        if (contact && contact.email && this.mail.to.find(function (to) { return to.mail === contact.email; }) === undefined) {
                            if (this.mail.to.findIndex(function (to) { return to.mail === contact.email; }) === -1) {
                                this.mail.to.push({
                                    id: contact.id,
                                    type: 'contact',
                                    mail: contact.email,
                                    name: contact.fullname,
                                    element: {
                                        type: 'contact',
                                        id: contact.id
                                    },
                                    data: contact
                                });
                            }
                        }
                        else {
                            if (customer && customer.email && this.mail.to.find(function (to) { return to.mail === customer.email; }) === undefined) {
                                if (this.mail.to.findIndex(function (to) { return to.mail === customer.email; }) === -1) {
                                    this.mail.to.push({
                                        id: customer.id,
                                        type: 'customer',
                                        mail: customer.email,
                                        name: customer.name,
                                        element: {
                                            type: 'customer',
                                            id: customer.id
                                        },
                                        data: customer
                                    });
                                }
                            }
                        }
                        if (!(value.mail && ((_b = value.customer) === null || _b === void 0 ? void 0 : _b.id) !== ((_c = old === null || old === void 0 ? void 0 : old.customer) === null || _c === void 0 ? void 0 : _c.id))) return [3 /*break*/, 3];
                        if (!((_d = value.customer) === null || _d === void 0 ? void 0 : _d.contacts)) return [3 /*break*/, 1];
                        this.contacts = value.customer.contacts;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.loadContacts()];
                    case 2:
                        _e.sent();
                        _e.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Apply external change
    SendEmail.prototype.applyLocalMail = function (mail) {
        if (JSON.stringify(mail) === JSON.stringify(this.mail)) {
            return;
        }
        this.mail = this.setDefaultValues(JSON.parse(JSON.stringify(mail)));
    };
    // Watch local value change
    /*
    @Watch('mail', { deep: true })
    private watchLocalValue (value: KwixeoCommunication.FormMail): void {
      if (!this.initialized) {
        return
      }
  
      this.$emit('input', Object.assign(this.value, {
        mail: JSON.parse(JSON.stringify(value))
      }))
  
      this.clearTimeout()
      this.timeoutSave = setTimeout(this.saveDraft, 3000)
    }
    */
    SendEmail.prototype.saveDraft = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwCommunication.axios.post(this.attachmentUrl, this.formDatas)
                            .then(function (response) {
                            _this.mail.id = response.data.id;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Set default local values
    SendEmail.prototype.setDefaultValues = function (mail) {
        return Object.assign({
            sender: this.computedDefaultSender,
            to: [],
            cc: [],
            cci: [],
            subject: null,
            html: null,
            text: null,
            add_files: [],
            attachments: [],
            add_attachments: [],
            remove_attachments: [],
            elements: []
        }, mail);
    };
    // Clean top form elements
    SendEmail.prototype.cleanTopElements = function () {
        this.showTopElements = false;
        this.showCc = this.mail.cc.length > 0;
        this.showCci = this.mail.cci.length > 0;
    };
    // Close mail form
    SendEmail.prototype.close = function () {
        this.$emit('close');
    };
    SendEmail.prototype.deleted = function () {
        this.close();
    };
    SendEmail.prototype.clearTimeout = function () {
        if (this.timeoutSave) {
            clearTimeout(this.timeoutSave);
            this.timeoutSave = null;
        }
    };
    // Collapse the mail form
    SendEmail.prototype.collapse = function () {
        if (this.value.mode !== 'collapsed') {
            this.value.mode = 'collapsed';
            this.$emit('collapse');
        }
        else {
            this.value.mode = 'normal';
            this.$emit('uncollapse');
        }
    };
    // Active the fullscreen mode
    SendEmail.prototype.fullscreen = function () {
        if (this.value.mode !== 'fullscreen') {
            this.value.mode = 'fullscreen';
            this.$emit('fullscreen');
        }
        else {
            this.value.mode = 'normal';
            this.$emit('exitFullscreen');
        }
    };
    // Add a file from library
    SendEmail.prototype.addLibraryFile = function (file) {
        var waiting = this.mail.add_files && this.mail.add_files.find(function (attachment) { return 'id' in attachment && attachment.id === file.id; });
        if (!waiting) {
            this.mail.add_files.push(file);
        }
    };
    // When a file is uploaded
    SendEmail.prototype.fileUploaded = function (mail) {
        var _this = this;
        this.initialized = false;
        this.applyLocalMail(mail);
        this.$nextTick(function () {
            _this.initialized = true;
        });
    };
    // When the mail is send
    SendEmail.prototype.submitComplete = function (response) {
        var mail = response.data;
        if (this.value.mail && this.value.mail.id) {
            interface_vue_.emitter.emit('mailUpdated', {
                old: JSON.parse(JSON.stringify(this.value.mail)),
                new: mail
            });
        }
        else {
            interface_vue_.emitter.emit('mailCreated', mail);
        }
        this.applyLocalMail(mail);
        this.close();
    };
    SendEmail.prototype.submitError = function (error) {
        var _a;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 429) {
            this.limitExceeded = true;
        }
    };
    // Apply a model
    SendEmail.prototype.applyModel = function (model) {
        var _a, _b, _c, _d;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var content;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.modelLoading = true;
                        return [4 /*yield*/, (0,mailModel/* fetchMailModel */.xo)(model.id)];
                    case 1:
                        model = _e.sent();
                        this.modelLoading = false;
                        this.usedModel = model;
                        content = this.getModelContents(model);
                        lib/* Vue */.lD.set(this.mail, 'subject', content.subject);
                        lib/* Vue */.lD.set(this.mail, 'html', content.html);
                        this.applySignature();
                        this.mail.add_files = [];
                        (_b = (_a = this.value.mail) === null || _a === void 0 ? void 0 : _a.add_files) === null || _b === void 0 ? void 0 : _b.forEach(function (file) { return _this.addLibraryFile(file); });
                        (_c = model.library_files) === null || _c === void 0 ? void 0 : _c.forEach(function (file) { return _this.addLibraryFile(file); });
                        (_d = model.attachments) === null || _d === void 0 ? void 0 : _d.forEach(function (file) { return _this.addLibraryFile(file); });
                        return [2 /*return*/];
                }
            });
        });
    };
    // Return model datas
    SendEmail.prototype.getModelContents = function (model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var elements = (_a = this.mail.elements) !== null && _a !== void 0 ? _a : [];
        var contact = (_d = (_c = (_b = this.mail.to) === null || _b === void 0 ? void 0 : _b.find(function (recipient) { return recipient.type === 'contact'; })) === null || _c === void 0 ? void 0 : _c.data) !== null && _d !== void 0 ? _d : null;
        if (!contact) { // If customer
            contact = (_g = (_f = (_e = this.mail.to) === null || _e === void 0 ? void 0 : _e.find(function (recipient) { return recipient.type === 'customer'; })) === null || _f === void 0 ? void 0 : _f.data) !== null && _g !== void 0 ? _g : null;
        }
        if (!contact) { // If team user
            contact = (_k = (_j = (_h = this.mail.to) === null || _h === void 0 ? void 0 : _h.find(function (recipient) { return recipient.type === 'teamUser'; })) === null || _j === void 0 ? void 0 : _j.data) !== null && _k !== void 0 ? _k : null;
        }
        return {
            html: this.replaceVariables((_l = model.html) !== null && _l !== void 0 ? _l : '', elements, contact),
            subject: this.htmltoText(this.replaceVariables((_m = model.subject) !== null && _m !== void 0 ? _m : '', elements, contact))
        };
    };
    // Search a recipient
    SendEmail.prototype.searchRecipients = function (term, loading) {
        var _this = this;
        if (term == '') {
            this.closeRecipients();
            return;
        }
        if (this.searchedTimeout) {
            clearTimeout(this.searchedTimeout);
        }
        this.searchedTimeout = setTimeout(function () {
            loading(true);
            _this.searchContacts(term)
                .finally(function () { return loading(false); });
        }, 500);
    };
    // Close a recipient list
    SendEmail.prototype.closeRecipients = function () {
        this.searchedRecipients = [];
    };
    // Load customer's contacts
    SendEmail.prototype.loadContacts = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.$kwCommunication.axios.get('/customer/contact', {
                            params: {
                                per_page: 500,
                                sort: 'fullname',
                                filter: {
                                    with_customer: (_a = this.value.customer) === null || _a === void 0 ? void 0 : _a.id,
                                    have_email_address: true
                                }
                            }
                        })
                            .then(function (response) {
                            _this.contacts = response.data.data;
                        })
                            .catch(function (error) {
                            throw new Error(error);
                        })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Search in contacts
    SendEmail.prototype.searchContacts = function (term) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$kwCommunication.axios.get('/customer/contact', {
                            params: {
                                per_page: 50,
                                sort: 'fullname',
                                search: '%' + term + '%',
                                filter: {
                                    have_email_address: true
                                }
                            }
                        })
                            .then(function (response) {
                            _this.searchedRecipients = response.data.data;
                        })
                            .catch(function (error) {
                            throw new Error(error);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SendEmail.prototype.goToUserProfile = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({ name: 'user-profile' })];
                    case 1:
                        _a.sent();
                        this.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    SendEmail.prototype.resendEmailValidation = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resendEmailValidationLoader = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.post('/user/email-validation/resend')
                                .then(function () {
                                _this.resendEmailValidationLoader = false;
                                _this.close();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SendEmail.prototype.removeAttachment = function (files) {
        var _a;
        if (!this.mail.id) {
            return;
        }
        (_a = this.mail.remove_attachments).push.apply(_a, files);
    };
    SendEmail.prototype.modelListOpenned = function () {
        var _a;
        var component = this.$refs['models-search'];
        if (component) {
            (_a = component.$el.querySelector('input')) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SendEmail.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SendEmail.prototype, "preload", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SendEmail.prototype, "inlineMode", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('computedModels')
    ], SendEmail.prototype, "watchComputedModels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('mail.sender', { deep: true })
    ], SendEmail.prototype, "watchSender", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('mail.to')
    ], SendEmail.prototype, "watchMailTo", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { deep: true })
    ], SendEmail.prototype, "watchValue", null);
    SendEmail = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('communication', ['senders', 'models'])), (0,external_vuex_.mapGetters)('communication', ['defaultSender'])), (0,external_vuex_.mapGetters)('globalDatas', ['activeTeamUsers'])), (0,external_vuex_.mapGetters)('user', ['teamConfigs'])), (0,external_vuex_.mapState)('user', ['user'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['loadSenders', 'loadModels'])), (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            components: {
                BDropdownItemButton: external_bootstrap_vue_.BDropdownItemButton,
                KFormDatepicker: form_vue_.KFormDatepicker,
                KFormTimepicker: form_vue_.KFormTimepicker,
                LibraryListButton: LibraryListButton/* default */.A,
                CustomerLibraryButton: CustomerLibraryButton/* default */.A,
                MailAttachments: Attachments/* default */.A,
                EmailDelete: EmailDelete/* default */.A,
                MailboxLater: MailboxLater/* default */.A,
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BInputGroup: external_bootstrap_vue_.BInputGroup, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItem: external_bootstrap_vue_.BDropdownItem, BDropdownText: external_bootstrap_vue_.BDropdownText, BOverlay: external_bootstrap_vue_.BOverlay, BModal: external_bootstrap_vue_.BModal, BDropdownForm: external_bootstrap_vue_.BDropdownForm, BDropdownGroup: external_bootstrap_vue_.BDropdownGroup, BButtonGroup: external_bootstrap_vue_.BButtonGroup,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormInput: form_vue_.KFormInput, KFormEditor: form_vue_.KFormEditor, KFormFile: form_vue_.KFormFileUpload,
                FontAwesomeIcon: index_es/* FontAwesomeIcon */.gc
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], SendEmail);
    return SendEmail;
}((0,lib/* Mixins */.Xe)(VariablesMixin/* default */.A)));
/* harmony default export */ var SendEmailvue_type_script_lang_ts_external = (SendEmail);

;// ./src/components/SendEmail/SendEmail.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SendEmail_SendEmailvue_type_script_lang_ts_external = (SendEmailvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/SendEmail/SendEmail.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SendEmail_SendEmailvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SendEmail_SendEmail = (component.exports);

/***/ }),

/***/ 867:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'expand-alt';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f424';
var svgPathData = 'M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.vQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 906:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f067';
var svgPathData = 'M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.QL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    createBaseEach = __webpack_require__(8329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 938:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223),
    MapCache = __webpack_require__(3661);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRest = __webpack_require__(9302),
    isIterateeCall = __webpack_require__(6800);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ 1033:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 1042:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 1146:
/***/ (function(module) {

"use strict";
module.exports = require("moment");

/***/ }),

/***/ 1175:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 1273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   gc: function() { return /* binding */ FontAwesomeIcon; }
/* harmony export */ });
/* unused harmony exports FontAwesomeLayers, FontAwesomeLayersText */
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7342);
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

var humps$1 = {exports: {}};

(function (module) {
(function(global) {

	  var _processKeys = function(convert, obj, options) {
	    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
	      return obj;
	    }

	    var output,
	        i = 0,
	        l = 0;

	    if(_isArray(obj)) {
	      output = [];
	      for(l=obj.length; i<l; i++) {
	        output.push(_processKeys(convert, obj[i], options));
	      }
	    }
	    else {
	      output = {};
	      for(var key in obj) {
	        if(Object.prototype.hasOwnProperty.call(obj, key)) {
	          output[convert(key, options)] = _processKeys(convert, obj[key], options);
	        }
	      }
	    }
	    return output;
	  };

	  // String conversion methods

	  var separateWords = function(string, options) {
	    options = options || {};
	    var separator = options.separator || '_';
	    var split = options.split || /(?=[A-Z])/;

	    return string.split(split).join(separator);
	  };

	  var camelize = function(string) {
	    if (_isNumerical(string)) {
	      return string;
	    }
	    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	    // Ensure 1st char is always lowercase
	    return string.substr(0, 1).toLowerCase() + string.substr(1);
	  };

	  var pascalize = function(string) {
	    var camelized = camelize(string);
	    // Ensure 1st char is always uppercase
	    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
	  };

	  var decamelize = function(string, options) {
	    return separateWords(string, options).toLowerCase();
	  };

	  // Utilities
	  // Taken from Underscore.js

	  var toString = Object.prototype.toString;

	  var _isFunction = function(obj) {
	    return typeof(obj) === 'function';
	  };
	  var _isObject = function(obj) {
	    return obj === Object(obj);
	  };
	  var _isArray = function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	  var _isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	  };
	  var _isRegExp = function(obj) {
	    return toString.call(obj) == '[object RegExp]';
	  };
	  var _isBoolean = function(obj) {
	    return toString.call(obj) == '[object Boolean]';
	  };

	  // Performant way to determine if obj coerces to a number
	  var _isNumerical = function(obj) {
	    obj = obj - 0;
	    return obj === obj;
	  };

	  // Sets up function which handles processing keys
	  // allowing the convert function to be modified by a callback
	  var _processor = function(convert, options) {
	    var callback = options && 'process' in options ? options.process : options;

	    if(typeof(callback) !== 'function') {
	      return convert;
	    }

	    return function(string, options) {
	      return callback(string, convert, options);
	    }
	  };

	  var humps = {
	    camelize: camelize,
	    decamelize: decamelize,
	    pascalize: pascalize,
	    depascalize: decamelize,
	    camelizeKeys: function(object, options) {
	      return _processKeys(_processor(camelize, options), object);
	    },
	    decamelizeKeys: function(object, options) {
	      return _processKeys(_processor(decamelize, options), object, options);
	    },
	    pascalizeKeys: function(object, options) {
	      return _processKeys(_processor(pascalize, options), object);
	    },
	    depascalizeKeys: function () {
	      return this.decamelizeKeys.apply(this, arguments);
	    }
	  };

	  if (module.exports) {
	    module.exports = humps;
	  } else {
	    global.humps = humps;
	  }

	})(commonjsGlobal);
} (humps$1));

var humps = humps$1.exports;

var _excluded = ["class", "style", "attrs"];

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = humps.camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    acc[prop] = value;
    return acc;
  }, {});
}

function classToObject(cls) {
  return cls.split(/\s+/).reduce(function (acc, c) {
    acc[c] = true;
    return acc;
  }, {});
}

function combineClassObjects() {
  for (var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }

  return objs.reduce(function (acc, obj) {
    if (Array.isArray(obj)) {
      acc = acc.concat(obj);
    } else {
      acc.push(obj);
    }

    return acc;
  }, []);
}

function convert(h, element) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var children = (element.children || []).map(convert.bind(null, h));
  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc['class'] = classToObject(val);
        break;

      case 'style':
        acc['style'] = styleToObject(val);
        break;

      default:
        acc.attrs[key] = val;
    }

    return acc;
  }, {
    'class': {},
    style: {},
    attrs: {}
  });

  var _data$class = data.class,
      dClass = _data$class === void 0 ? {} : _data$class,
      _data$style = data.style,
      dStyle = _data$style === void 0 ? {} : _data$style,
      _data$attrs = data.attrs,
      dAttrs = _data$attrs === void 0 ? {} : _data$attrs,
      remainingData = _objectWithoutProperties(data, _excluded);

  if (typeof element === 'string') {
    return element;
  } else {
    return h(element.tag, _objectSpread2(_objectSpread2({
      class: combineClassObjects(mixins.class, dClass),
      style: _objectSpread2(_objectSpread2({}, mixins.style), dStyle),
      attrs: _objectSpread2(_objectSpread2({}, mixins.attrs), dAttrs)
    }, remainingData), {}, {
      props: props
    }), children);
  }
}

var PRODUCTION = false;

try {
  PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}
function classList(props) {
  var _classes;

  var classes = (_classes = {
    'fa-spin': props.spin,
    'fa-spin-pulse': props.spinPulse,
    'fa-spin-reverse': props.spinReverse,
    'fa-pulse': props.pulse,
    'fa-beat': props.beat,
    'fa-fade': props.fade,
    'fa-flash': props.flash,
    'fa-fw': props.fixedWidth,
    'fa-border': props.border,
    'fa-li': props.listItem,
    'fa-inverse': props.inverse,
    'fa-flip': props.flip === true,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
  }, _defineProperty(_classes, "fa-".concat(props.size), props.size !== null), _defineProperty(_classes, "fa-rotate-".concat(props.rotation), props.rotation !== null), _defineProperty(_classes, "fa-pull-".concat(props.pull), props.pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _defineProperty(_classes, 'fa-bounce', props.bounce), _defineProperty(_classes, 'fa-shake', props.shake), _defineProperty(_classes, 'fa-beat-fade', props.beatFade), _classes);
  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}
function addStaticClass(to, what) {
  var val = (to || '').length === 0 ? [] : [to];
  return val.concat(what).join(' ');
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.parse.icon) {
    return _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.parse.icon(icon);
  }

  if (icon === null) {
    return null;
  }

  if (_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  }

  if (Array.isArray(icon) && icon.length === 2) {
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  }

  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

var FontAwesomeIcon = {
  name: 'FontAwesomeIcon',
  functional: true,
  props: {
    beat: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    fade: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Boolean,
      default: false
    },
    flash: {
      type: Boolean,
      default: false
    },
    flip: {
      type: [Boolean, String],
      default: false,
      validator: function validator(value) {
        return [true, false, 'horizontal', 'vertical', 'both'].indexOf(value) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: true
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    listItem: {
      type: Boolean,
      default: false
    },
    pull: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['right', 'left'].indexOf(value) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: false
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function validator(value) {
        return [90, 180, 270].indexOf(parseInt(value, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'].indexOf(value) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: false
    },
    spinPulse: {
      type: Boolean,
      default: false
    },
    spinReverse: {
      type: Boolean,
      default: false
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: false
    },
    bounce: {
      type: Boolean,
      default: false
    },
    shake: {
      type: Boolean,
      default: false
    },
    beatFade: {
      type: Boolean,
      default: false
    }
  },
  render: function render(createElement, context) {
    var props = context.props;
    var iconArgs = props.icon,
        maskArgs = props.mask,
        symbol = props.symbol,
        title = props.title;
    var icon$1 = normalizeIconArgs(iconArgs);
    var classes = objectWithKey('classes', classList(props));
    var transform = objectWithKey('transform', typeof props.transform === 'string' ? _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.parse.transform(props.transform) : props.transform);
    var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
    var renderedIcon = (0,_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.icon)(icon$1, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
      symbol: symbol,
      title: title
    }));

    if (!renderedIcon) {
      return log('Could not find one or more icon(s)', icon$1, mask);
    }

    var abstract = renderedIcon.abstract;
    var convertCurry = convert.bind(null, createElement);
    return convertCurry(abstract[0], {}, context.data);
  }
};

var FontAwesomeLayers = {
  name: 'FontAwesomeLayers',
  functional: true,
  props: {
    fixedWidth: {
      type: Boolean,
      default: false
    }
  },
  render: function render(createElement, context) {
    var familyPrefix = _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.config.familyPrefix;
    var staticClass = context.data.staticClass;
    var classes = ["".concat(familyPrefix, "-layers")].concat(_toConsumableArray(context.props.fixedWidth ? ["".concat(familyPrefix, "-fw")] : []));
    return createElement('div', _objectSpread2(_objectSpread2({}, context.data), {}, {
      staticClass: addStaticClass(staticClass, classes)
    }), context.children);
  }
};

var FontAwesomeLayersText = {
  name: 'FontAwesomeLayersText',
  functional: true,
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: null,
      validator: function validator(value) {
        return ['bottom-left', 'bottom-right', 'top-left', 'top-right'].indexOf(value) > -1;
      }
    }
  },
  render: function render(createElement, context) {
    var familyPrefix = _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.config.familyPrefix;
    var props = context.props;
    var classes = objectWithKey('classes', [].concat(_toConsumableArray(props.counter ? ["".concat(familyPrefix, "-layers-counter")] : []), _toConsumableArray(props.position ? ["".concat(familyPrefix, "-layers-").concat(props.position)] : [])));
    var transform = objectWithKey('transform', typeof props.transform === 'string' ? _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.parse.transform(props.transform) : props.transform);
    var renderedText = (0,_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.text)(props.value.toString(), _objectSpread2(_objectSpread2({}, transform), classes));
    var abstract = renderedText.abstract;

    if (props.counter) {
      abstract[0].attributes.class = abstract[0].attributes.class.replace('fa-layers-text', '');
    }

    var convertCurry = convert.bind(null, createElement);
    return convertCurry(abstract[0], {}, context.data);
  }
};




/***/ }),

/***/ 1277:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'exclamation-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f06a';
var svgPathData = 'M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.tU = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    getPrototype = __webpack_require__(8879),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 1380:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 1420:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 1439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerLibrary_CustomerLibrary; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerLibrary/CustomerLibrary.vue?vue&type=template&id=e6d352ea
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-table',{attrs:{"url":_vm.ajaxUrl,"ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"onlyTopFilters":""}}),_c('b-toast',{attrs:{"auto-hide-delay":1000,"toast-class":"communication-confirm-toast","variant":"success","toaster":"b-toaster-top-center b-toaster-communication","solid":""},model:{value:(_vm.showConfirm),callback:function ($$v) {_vm.showConfirm=$$v},expression:"showConfirm"}},[_vm._v(" Fichier ajouté ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerLibrary/CustomerLibrary.ts?vue&type=script&lang=ts&external




var CustomerLibrary = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerLibrary, _super);
    function CustomerLibrary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.types = [];
        _this.showConfirm = false;
        return _this;
    }
    Object.defineProperty(CustomerLibrary.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('interface.add'),
                    variant: 'primary',
                    click: function (file) {
                        _this.$emit('add', file);
                        _this.showConfirm = true;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerLibrary.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    data: 'attachable',
                    name: this.$t('communication.files.list.linkedElement'),
                    render: function (linkedElement, row) {
                        switch (row.element_type) {
                            case 'customer':
                                return linkedElement.name;
                            case 'contact':
                                return linkedElement.fullname;
                            case 'contract':
                                return _this.$t('sales.contract.reference', { reference: linkedElement.reference });
                            case 'quotation':
                                return _this.$t('sales.quotation.reference', { reference: linkedElement.reference });
                            case 'command':
                                return _this.$t('sales.command.reference', { reference: linkedElement.reference });
                            case 'delivery':
                                return _this.$t('sales.delivery.reference', { reference: linkedElement.reference });
                            case 'proforma':
                                return _this.$t('sales.proforma.reference', { reference: linkedElement.reference });
                            case 'invoice':
                                return _this.$t('sales.invoice.reference', { reference: linkedElement.reference });
                            case 'credit':
                                return _this.$t('sales.credit.reference', { reference: linkedElement.reference });
                            case 'opportunity':
                                return _this.$t('opportunities.opportunities.reference', { reference: linkedElement.reference });
                            case 'affair':
                                return _this.$t('sales.affair.reference', { reference: linkedElement.reference });
                            case 'providerCommand':
                                return _this.$t('catalog.stock.types.providerCommand', { reference: linkedElement.reference });
                            case 'charge':
                                return _this.$t('charges.charges.reference', { reference: linkedElement.reference });
                            default:
                                return '';
                        }
                    },
                    sortable: false,
                },
                {
                    data: 'filename',
                    name: this.$t('communication.files.list.filename')
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    render: 'datetime',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerLibrary.prototype, "filters", {
        get: function () {
            return [
                {
                    name: 'types',
                    type: 'select',
                    label: this.$t('communication.files.linkedType'),
                    options: [
                        { value: 'quotation', label: this.$t('sales.quotation.label') },
                        { value: 'command', label: this.$t('sales.command.label') },
                        { value: 'delivery', label: this.$t('sales.delivery.label') },
                        { value: 'proforma', label: this.$t('sales.proforma.label') },
                        { value: 'invoice', label: this.$t('sales.invoice.label') },
                        { value: 'credit', label: this.$t('sales.credit.label') },
                        { value: 'opportunity', label: this.$t('opportunities.opportunities.label') },
                        { value: 'contract', label: this.$t('sales.contract.label') },
                        { value: 'charge', label: this.$t('charges.charges.label') }
                    ],
                    multiple: true,
                    optionLabel: 'label',
                    value: 'value'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerLibrary.prototype, "ajaxUrl", {
        get: function () {
            return '/customer/' + this.customerId + '/file';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerLibrary.prototype, "ajaxDatas", {
        get: function () {
            var data = {};
            if (this.types.length > 0) {
                data.types = this.types;
            }
            return data;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerLibrary.prototype, "customerId", void 0);
    CustomerLibrary = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KTable: table_vue_.KTable,
                BToast: external_bootstrap_vue_.BToast
            }
        })
    ], CustomerLibrary);
    return CustomerLibrary;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerLibraryvue_type_script_lang_ts_external = (CustomerLibrary);

;// ./src/components/CustomerLibrary/CustomerLibrary.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerLibrary_CustomerLibraryvue_type_script_lang_ts_external = (CustomerLibraryvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerLibrary/CustomerLibrary.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerLibrary_CustomerLibraryvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerLibrary_CustomerLibrary = (component.exports);

/***/ }),

/***/ 1459:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 1549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(2032),
    hashDelete = __webpack_require__(3862),
    hashGet = __webpack_require__(6721),
    hashHas = __webpack_require__(2749),
    hashSet = __webpack_require__(5749);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1658:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'trash';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f1f8';
var svgPathData = 'M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.yL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1769:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isKey = __webpack_require__(8586),
    stringToPath = __webpack_require__(1802),
    toString = __webpack_require__(3222);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 1790:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'star';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f005';
var svgPathData = 'M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.yy = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(6547),
    baseAssignValue = __webpack_require__(3360);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 1793:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chevron-left';
var width = 256;
var height = 512;
var ligatures = [];
var unicode = 'f053';
var svgPathData = 'M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Wz = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1799:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    baseIsEqual = __webpack_require__(270);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 1802:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2224);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 1811:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1928:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'check-square';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f14a';
var svgPathData = 'M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.rQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1961:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(9653);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 1986:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    Uint8Array = __webpack_require__(7828),
    eq = __webpack_require__(5288),
    equalArrays = __webpack_require__(5911),
    mapToArray = __webpack_require__(317),
    setToArray = __webpack_require__(4247);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 2025:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'mail-bulk';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f674';
var svgPathData = 'M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.$8 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2032:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 2040:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'minus-square';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f146';
var svgPathData = 'M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.xb = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_LetterParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/LetterParamsView.vue?vue&type=template&id=71df05c9
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LetterParams')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/LetterParams/LetterParams.vue + 3 modules
var LetterParams = __webpack_require__(5341);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/LetterParamsView.vue?vue&type=script&lang=ts



var LetterParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LetterParamsView, _super);
    function LetterParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LetterParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                LetterParams: LetterParams/* default */.A
            }
        })
    ], LetterParamsView);
    return LetterParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var LetterParamsViewvue_type_script_lang_ts = (LetterParamsView);

;// ./src/views/LetterParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_LetterParamsViewvue_type_script_lang_ts = (LetterParamsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/LetterParamsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_LetterParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_LetterParamsView = (component.exports);

/***/ }),

/***/ 2193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(8984),
    getTag = __webpack_require__(5861),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isArrayLike = __webpack_require__(4894),
    isBuffer = __webpack_require__(3656),
    isPrototype = __webpack_require__(5527),
    isTypedArray = __webpack_require__(7167);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 2199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(4528),
    isArray = __webpack_require__(6449);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 2224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(104);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 2392:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'hourglass-start';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f251';
var svgPathData = 'M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.et = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 2523:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 2651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(4218);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 2652:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/interface-vue");

/***/ }),

/***/ 2749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 2804:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 2824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(7805),
    cloneBuffer = __webpack_require__(3290),
    cloneTypedArray = __webpack_require__(1961),
    copyArray = __webpack_require__(3007),
    initCloneObject = __webpack_require__(5529),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isArrayLikeObject = __webpack_require__(3693),
    isBuffer = __webpack_require__(3656),
    isFunction = __webpack_require__(1882),
    isObject = __webpack_require__(3805),
    isPlainObject = __webpack_require__(1331),
    isTypedArray = __webpack_require__(7167),
    safeGet = __webpack_require__(4974),
    toPlainObject = __webpack_require__(9884);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 2865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(9570),
    shortOut = __webpack_require__(1811);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 2903:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805),
    isPrototype = __webpack_require__(5527),
    nativeKeysIn = __webpack_require__(181);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 2949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 2986:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'times';
var width = 352;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3007:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 3040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1549),
    ListCache = __webpack_require__(79),
    Map = __webpack_require__(8223);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ EmailDelete_EmailDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/EmailDelete/EmailDelete.vue?vue&type=template&id=32f3a39c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.$t('communication.mail.deleteMsg')))])]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/EmailDelete/EmailDelete.ts?vue&type=script&lang=ts&external




var EmailDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(EmailDelete, _super);
    function EmailDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(EmailDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    EmailDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    EmailDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    EmailDelete.prototype.process = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.delete('/mail/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.deleted();
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EmailDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    EmailDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    EmailDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('mailDeleted', this.value);
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], EmailDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], EmailDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], EmailDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], EmailDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], EmailDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], EmailDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], EmailDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], EmailDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], EmailDelete.prototype, "watchModalState", null);
    EmailDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], EmailDelete);
    return EmailDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var EmailDeletevue_type_script_lang_ts_external = (EmailDelete);

;// ./src/components/EmailDelete/EmailDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var EmailDelete_EmailDeletevue_type_script_lang_ts_external = (EmailDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/EmailDelete/EmailDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  EmailDelete_EmailDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var EmailDelete_EmailDelete = (component.exports);

/***/ }),

/***/ 3176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LibraryList_LibraryList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LibraryList/LibraryList.vue?vue&type=template&id=1340e3e3
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-table"},[(_vm.modalMode === false)?_c('PageHeader',{attrs:{"page-title":_vm.$t('communication.files.pageTitle'),"buttons":_vm.headerButtons}}):_vm._e(),_c('b-overlay',{staticClass:"h-100",attrs:{"show":_vm.loadingFile}},[_c('k-table',{ref:"table",attrs:{"url":"/mail/library","columns":_vm.columns,"rowActions":_vm.rowActions}}),(_vm.modalMode !== false)?_c('b-toast',{attrs:{"auto-hide-delay":1000,"toast-class":"communication-confirm-toast","variant":"success","toaster":"b-toaster-top-center b-toaster-communication","solid":""},model:{value:(_vm.showConfirm),callback:function ($$v) {_vm.showConfirm=$$v},expression:"showConfirm"}},[_vm._v(" "+_vm._s(_vm.$t('communication.files.fileAdded'))+" ")]):_vm._e()],1),_c('LibraryForm',{attrs:{"show":_vm.edited !== null},on:{"submitted":_vm.submitted,"hidden":_vm.cancelEdited},model:{value:(_vm.edited),callback:function ($$v) {_vm.edited=$$v},expression:"edited"}}),_c('LibraryDelete',{on:{"deleted":_vm.deleted},model:{value:(_vm.deleteId),callback:function ($$v) {_vm.deleteId=$$v},expression:"deleteId"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/LibraryForm/LibraryForm.vue + 3 modules
var LibraryForm = __webpack_require__(3852);
// EXTERNAL MODULE: ./src/components/LibraryDelete/LibraryDelete.vue + 3 modules
var LibraryDelete = __webpack_require__(6463);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LibraryList/LibraryList.ts?vue&type=script&lang=ts&external







var LibraryList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LibraryList, _super);
    function LibraryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingFile = false;
        _this.showConfirm = false;
        _this.edited = null;
        _this.editedIndex = null;
        _this.deleteId = null;
        _this.deleteIndex = null;
        _this.headerButtons = [
            {
                label: _this.$t('communication.files.newLabel'),
                click: function () {
                    _this.toEdit();
                }
            }
        ];
        _this.columns = [
            {
                data: 'name',
                name: _this.$t('communication.files.list.name')
            },
            {
                data: 'filename',
                name: _this.$t('communication.files.list.filename')
            },
            {
                data: 'created_at',
                name: _this.$t('interface.list.createdAt'),
                render: 'datetime'
            },
            {
                data: 'updated_at',
                name: _this.$t('interface.list.updatedAt'),
                render: 'datetime'
            }
        ];
        return _this;
    }
    Object.defineProperty(LibraryList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            if (this.modalMode !== false) {
                return [
                    {
                        label: this.$t('interface.add'),
                        variant: 'primary',
                        click: function (file) {
                            _this.$emit('add', file);
                            _this.showConfirm = true;
                        }
                    }
                ];
            }
            return [
                {
                    label: this.$t('interface.download'),
                    variant: 'secondary',
                    click: this.download
                },
                {
                    label: this.$t('interface.edit'),
                    variant: 'primary',
                    click: this.toEdit
                },
                {
                    label: this.$t('interface.delete'),
                    variant: 'secondary',
                    click: function (file, index) {
                        _this.toDelete(file.id, index);
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    LibraryList.prototype.download = function (file) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loadingFile = true;
                this.$kwCommunication.axios.get('/mail/library/' + file.id + '?with_file=1')
                    .then(function (response) {
                    var file = response.data;
                    _this.downloadFile(file.file, file.filename);
                })
                    .catch(function (error) {
                    throw new Error(error);
                })
                    .finally(function () { return _this.loadingFile = false; });
                return [2 /*return*/];
            });
        });
    };
    LibraryList.prototype.toEdit = function (file, index) {
        if (file === void 0) { file = null; }
        if (index === void 0) { index = null; }
        this.edited = file !== null && file !== void 0 ? file : {};
        this.editedIndex = index;
    };
    LibraryList.prototype.submitted = function (file) {
        var table = this.$refs.table;
        if (this.editedIndex !== null && this.editedIndex >= 0) {
            table.updateRow(this.editedIndex, file);
            this.editedIndex = null;
        }
        else {
            table.addRow(file);
        }
        this.edited = null;
    };
    LibraryList.prototype.cancelEdited = function () {
        this.editedIndex = null;
        this.edited = null;
    };
    LibraryList.prototype.toDelete = function (id, index) {
        this.deleteId = id;
        this.deleteIndex = index;
    };
    LibraryList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.deleteId = null;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], LibraryList.prototype, "modalMode", void 0);
    LibraryList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PageHeader: interface_vue_.PageHeader,
                LibraryForm: LibraryForm/* default */.A,
                LibraryDelete: LibraryDelete/* default */.A,
                KTable: table_vue_.KTable,
                BOverlay: external_bootstrap_vue_.BOverlay,
                BToast: external_bootstrap_vue_.BToast
            }
        })
    ], LibraryList);
    return LibraryList;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var LibraryListvue_type_script_lang_ts_external = (LibraryList);

;// ./src/components/LibraryList/LibraryList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LibraryList_LibraryListvue_type_script_lang_ts_external = (LibraryListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LibraryList/LibraryList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LibraryList_LibraryListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LibraryList_LibraryList = (component.exports);

/***/ }),

/***/ 3221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 3222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(7556);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 3243:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 3290:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 3345:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 3360:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(3243);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 3605:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 3607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommunicationParams_CommunicationParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommunicationParams/CommunicationParams.vue?vue&type=template&id=574b0896
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',[_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.formSubmitted}},[_c('div',{staticClass:"mb-4"},[_vm._v(" "+_vm._s(_vm.$t('communication.params.explain'))+"} ")]),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromProspect')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_prospect]"},domProps:{"value":_vm.localConfig.communication_model_prospect ? _vm.localConfig.communication_model_prospect.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_prospect),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_prospect", $$v)},expression:"localConfig.communication_model_prospect"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromCustomer')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_customer]"},domProps:{"value":_vm.localConfig.communication_model_customer ? _vm.localConfig.communication_model_customer.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_customer),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_customer", $$v)},expression:"localConfig.communication_model_customer"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromProvider')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_provider]"},domProps:{"value":_vm.localConfig.communication_model_provider ? _vm.localConfig.communication_model_provider.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_provider),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_provider", $$v)},expression:"localConfig.communication_model_provider"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromSubcontractor')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_subcontractor]"},domProps:{"value":_vm.localConfig.communication_model_subcontractor ? _vm.localConfig.communication_model_subcontractor.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_subcontractor),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_subcontractor", $$v)},expression:"localConfig.communication_model_subcontractor"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromQuotation')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_quotation]"},domProps:{"value":_vm.localConfig.communication_model_quotation ? _vm.localConfig.communication_model_quotation.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_quotation),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_quotation", $$v)},expression:"localConfig.communication_model_quotation"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromCommand')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_command]"},domProps:{"value":_vm.localConfig.communication_model_command ? _vm.localConfig.communication_model_command.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_command),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_command", $$v)},expression:"localConfig.communication_model_command"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromProforma')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_proforma]"},domProps:{"value":_vm.localConfig.communication_model_proforma ? _vm.localConfig.communication_model_proforma.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_proforma),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_proforma", $$v)},expression:"localConfig.communication_model_proforma"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromDelivery')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_delivery]"},domProps:{"value":_vm.localConfig.communication_model_delivery ? _vm.localConfig.communication_model_delivery.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_delivery),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_delivery", $$v)},expression:"localConfig.communication_model_delivery"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromInvoice')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_invoice]"},domProps:{"value":_vm.localConfig.communication_model_invoice ? _vm.localConfig.communication_model_invoice.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_invoice),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_invoice", $$v)},expression:"localConfig.communication_model_invoice"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromCredit')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_credit]"},domProps:{"value":_vm.localConfig.communication_model_credit ? _vm.localConfig.communication_model_credit.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_credit),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_credit", $$v)},expression:"localConfig.communication_model_credit"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.params.fromProviderCommand')}},[_c('input',{attrs:{"type":"hidden","name":"configs[communication_model_provider_command]"},domProps:{"value":_vm.localConfig.communication_model_provider_command ? _vm.localConfig.communication_model_provider_command.id : null}}),_c('k-form-select',{attrs:{"options":_vm.models,"label":"name"},model:{value:(_vm.localConfig.communication_model_provider_command),callback:function ($$v) {_vm.$set(_vm.localConfig, "communication_model_provider_command", $$v)},expression:"localConfig.communication_model_provider_command"}})],1),_c('k-form-sticky-bar',{attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-3",attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.$t('interface.save')))]),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))])],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommunicationParams/CommunicationParams.ts?vue&type=script&lang=ts&external






var CommunicationParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommunicationParams, _super);
    function CommunicationParams() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommunicationParams.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadModels()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommunicationParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormStickyBar: form_vue_.KFormStickyBar
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('communication', ['models'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['loadModels']))
        })
    ], CommunicationParams);
    return CommunicationParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var CommunicationParamsvue_type_script_lang_ts_external = (CommunicationParams);

;// ./src/components/CommunicationParams/CommunicationParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommunicationParams_CommunicationParamsvue_type_script_lang_ts_external = (CommunicationParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommunicationParams/CommunicationParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommunicationParams_CommunicationParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommunicationParams_CommunicationParams = (component.exports);

/***/ }),

/***/ 3644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   xo: function() { return /* binding */ fetchMailModel; }
/* harmony export */ });
/* unused harmony exports mailModelRelations, needFetchMailModel */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var mailModelRelations = [
    'attachments'
];
var needFetchMailModel = function (model) {
    return !mailModelRelations.every(function (relation) { return relation in model; });
};
var fetchMailModel = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwCommunication.axios.get('/mail/model/' + id, {
                    params: {
                        include: mailModelRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3661:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(3040),
    mapCacheDelete = __webpack_require__(7670),
    mapCacheGet = __webpack_require__(289),
    mapCacheHas = __webpack_require__(4509),
    mapCacheSet = __webpack_require__(2949);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 3663:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1799),
    getMatchData = __webpack_require__(776),
    matchesStrictComparable = __webpack_require__(7197);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 3693:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894),
    isObjectLike = __webpack_require__(346);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 3702:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 3717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1146);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);





var VariablesMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__extends */ .C6)(VariablesMixin, _super);
    function VariablesMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VariablesMixin.prototype.htmltoText = function (html) {
        var tempDivElement = document.createElement('div');
        tempDivElement.innerHTML = html;
        return tempDivElement.textContent || tempDivElement.innerText || '';
    };
    VariablesMixin.prototype.replaceVariables = function (content, elements, contact) {
        var _this = this;
        var _a;
        (_a = content.match(/<variable(.*?)<\/variable>/gs)) === null || _a === void 0 ? void 0 : _a.forEach(function (variable) {
            // Get variable identifier
            var findIdent = variable.match(/data-variable="(.*?)"/s);
            if (!findIdent) {
                return;
            }
            var ident = findIdent[1];
            if (ident === 'SIGN-LINK') {
                return;
            }
            var findConditionnal = variable.match(/data-conditional-show="(.*?)"/s);
            var conditionnal = findConditionnal ? findConditionnal[1] === 'true' : false;
            var previewValue = _this.previewValues(elements, contact)[ident];
            if (previewValue === undefined || previewValue === null) {
                previewValue = '';
            }
            if (previewValue === '' && conditionnal) {
                content = content.replace(variable, '');
                return;
            }
            var replace = '';
            var findSpaceBeforePrefix = variable.match(/data-prefix-space-before="(.*?)"/s);
            var spaceBeforePrefix = findSpaceBeforePrefix ? findSpaceBeforePrefix[1] === 'true' : false;
            if (spaceBeforePrefix) {
                replace += '<br>';
            }
            var findPrefix = variable.match(/data-prefix="(.*?)"/s);
            if (findPrefix) {
                replace += findPrefix[1];
            }
            var findSpaceAfterPrefix = variable.match(/data-prefix-space-after="(.*?)"/s);
            var spaceAfterPrefix = findSpaceAfterPrefix ? findSpaceAfterPrefix[1] === 'true' : false;
            if (spaceAfterPrefix) {
                replace += '<br>';
            }
            replace += previewValue;
            var findSpaceBeforeSuffix = variable.match(/data-suffix-space-before="(.*?)"/s);
            var spaceBeforeSuffix = findSpaceBeforeSuffix ? findSpaceBeforeSuffix[1] === 'true' : false;
            if (spaceBeforeSuffix) {
                replace += '<br>';
            }
            var findSuffix = variable.match(/data-suffix="(.*?)"/s);
            if (findSuffix) {
                replace += findSuffix[1];
            }
            var findSpaceAfterSuffix = variable.match(/data-suffix-space-after="(.*?)"/s);
            var spaceAfterSuffix = findSpaceAfterSuffix ? findSpaceAfterSuffix[1] === 'true' : false;
            if (spaceAfterSuffix) {
                replace += '<br>';
            }
            content = content.replace(variable, replace);
        });
        return content;
    };
    Object.defineProperty(VariablesMixin.prototype, "getCustomer", {
        get: function () {
            return function (elements) { var _a; return (_a = elements.find(function (el) { return el.type === 'customer'; })) === null || _a === void 0 ? void 0 : _a.data; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "getContact", {
        get: function () {
            return function (elements) { var _a; return (_a = elements.find(function (el) { return el.type === 'contact'; })) === null || _a === void 0 ? void 0 : _a.data; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "getConstruction", {
        get: function () {
            return function (elements) { var _a; return (_a = elements.find(function (el) { return el.type === 'construction'; })) === null || _a === void 0 ? void 0 : _a.data; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "getPlanification", {
        get: function () {
            return function (elements) { var _a; return (_a = elements.find(function (el) { return el.type === 'planification'; })) === null || _a === void 0 ? void 0 : _a.data; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "getDocument", {
        get: function () {
            return function (elements) {
                var _a;
                return (_a = elements.find(function (el) {
                    return ['quotation', 'command', 'proforma', 'delivery', 'invoice', 'credit', 'providerCommand'].includes(el.type);
                })) === null || _a === void 0 ? void 0 : _a.data;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "getAddress", {
        get: function () {
            return function (address) {
                var _a;
                if (!address) {
                    return '';
                }
                var value = [
                    address.road,
                    address.road2,
                    address.road3,
                    address.postal_code,
                    address.city,
                    (_a = address.country) === null || _a === void 0 ? void 0 : _a.name,
                ];
                return value.filter(function (val) { return val !== '' && val !== null && val !== undefined; }).join(' ');
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VariablesMixin.prototype, "previewValues", {
        get: function () {
            var _this = this;
            return function (elements, contact) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
                if (contact === void 0) { contact = null; }
                var team = _this.team;
                var customer = _this.getCustomer(elements);
                // const contact = this.getContact(elements)
                contact = contact;
                var document = _this.getDocument(elements);
                var construction = _this.getConstruction(elements);
                var planification = _this.getPlanification(elements);
                var dayNumber = moment__WEBPACK_IMPORTED_MODULE_3___default()().isoWeekday();
                var monthNumber = moment__WEBPACK_IMPORTED_MODULE_3___default()().format('M');
                return {
                    'COMPANY-NAME': team.company_name,
                    'COMPANY-ROAD': (_a = team.road1) !== null && _a !== void 0 ? _a : '',
                    'COMPANY-ROAD2': (_b = team.road2) !== null && _b !== void 0 ? _b : '',
                    'COMPANY-ROAD3': (_c = team.road3) !== null && _c !== void 0 ? _c : '',
                    'COMPANY-POSTAL': (_d = team.postal_code) !== null && _d !== void 0 ? _d : '',
                    'COMPANY-TOWN': (_e = team.town) !== null && _e !== void 0 ? _e : '',
                    'COMPANY-COUNTRY': (_g = (_f = team.country) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : '',
                    'COMPANY-PHONE': (_h = team.phone) !== null && _h !== void 0 ? _h : '',
                    'COMPANY-MOBILE': (_j = team.mobile) !== null && _j !== void 0 ? _j : '',
                    'COMPANY-FAX': (_k = team.fax) !== null && _k !== void 0 ? _k : '',
                    'COMPANY-EMAIL': (_l = team.email) !== null && _l !== void 0 ? _l : '',
                    'COMPANY-WEBSITE': (_m = team.website) !== null && _m !== void 0 ? _m : '',
                    'COMPANY-TYPE': (_o = team.company_type) !== null && _o !== void 0 ? _o : '',
                    'COMPANY-SIRET': (_p = team.company_siret) !== null && _p !== void 0 ? _p : '',
                    'COMPANY-RCS': (_q = team.company_rcs) !== null && _q !== void 0 ? _q : '',
                    'COMPANY-TVA': (_r = team.company_vatrate) !== null && _r !== void 0 ? _r : '',
                    'COMPANY-NAF': (_s = team.company_naf) !== null && _s !== void 0 ? _s : '',
                    'COMPANY-CAPITAL': (_t = team.company_capital) !== null && _t !== void 0 ? _t : '',
                    'TIERS-CODE': (_x = (_v = (_u = customer === null || customer === void 0 ? void 0 : customer.reference) === null || _u === void 0 ? void 0 : _u.customer) !== null && _v !== void 0 ? _v : (_w = customer === null || customer === void 0 ? void 0 : customer.reference) === null || _w === void 0 ? void 0 : _w.prospect) !== null && _x !== void 0 ? _x : '',
                    'TIERS-NAME': customer === null || customer === void 0 ? void 0 : customer.name,
                    'TIERS-ROAD': (_y = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _y === void 0 ? void 0 : _y.road1,
                    'TIERS-ROAD2': (_z = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _z === void 0 ? void 0 : _z.road2,
                    'TIERS-ROAD3': (_0 = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _0 === void 0 ? void 0 : _0.road3,
                    'TIERS-POSTAL': (_1 = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _1 === void 0 ? void 0 : _1.postal_code,
                    'TIERS-TOWN': (_2 = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _2 === void 0 ? void 0 : _2.town,
                    'TIERS-COUNTRY': (_4 = (_3 = customer === null || customer === void 0 ? void 0 : customer.address_invoice) === null || _3 === void 0 ? void 0 : _3.country) === null || _4 === void 0 ? void 0 : _4.name,
                    'TIERS-PHONE': customer === null || customer === void 0 ? void 0 : customer.phone,
                    'TIERS-MOBILE': customer === null || customer === void 0 ? void 0 : customer.mobile,
                    'TIERS-FAX': customer === null || customer === void 0 ? void 0 : customer.fax,
                    'TIERS-EMAIL': customer === null || customer === void 0 ? void 0 : customer.email,
                    'TIERS-WEBSITE': customer === null || customer === void 0 ? void 0 : customer.website,
                    'TIERS-SIRET': customer === null || customer === void 0 ? void 0 : customer.company_siret,
                    'TIERS-TVA': customer === null || customer === void 0 ? void 0 : customer.company_vatrate,
                    'TIERS-COMMERCIAL': (_5 = customer === null || customer === void 0 ? void 0 : customer.team_user) === null || _5 === void 0 ? void 0 : _5.fullname,
                    'CONTACT-CIVILITY': (_6 = contact === null || contact === void 0 ? void 0 : contact.civility) === null || _6 === void 0 ? void 0 : _6.short_name,
                    'CONTACT-CIVILITY-FULL': (_7 = contact === null || contact === void 0 ? void 0 : contact.civility) === null || _7 === void 0 ? void 0 : _7.name,
                    'CONTACT-FULLNAME': contact === null || contact === void 0 ? void 0 : contact.fullname,
                    'CONTACT-FIRSTNAME': contact === null || contact === void 0 ? void 0 : contact.firstname,
                    'CONTACT-LASTNAME': contact === null || contact === void 0 ? void 0 : contact.lastname,
                    'CONTACT-ROAD': contact === null || contact === void 0 ? void 0 : contact.road1,
                    'CONTACT-ROAD2': contact === null || contact === void 0 ? void 0 : contact.road2,
                    'CONTACT-ROAD3': contact === null || contact === void 0 ? void 0 : contact.road3,
                    'CONTACT-POSTAL': contact === null || contact === void 0 ? void 0 : contact.postal_code,
                    'CONTACT-TOWN': contact === null || contact === void 0 ? void 0 : contact.town,
                    'CONTACT-COUNTRY': (_8 = contact === null || contact === void 0 ? void 0 : contact.country) === null || _8 === void 0 ? void 0 : _8.name,
                    'CONTACT-PHONE': contact === null || contact === void 0 ? void 0 : contact.phone,
                    'CONTACT-MOBILE': contact === null || contact === void 0 ? void 0 : contact.mobile,
                    'CONTACT-FAX': contact === null || contact === void 0 ? void 0 : contact.fax,
                    'CONTACT-EMAIL': contact === null || contact === void 0 ? void 0 : contact.email,
                    'CONTACT-WEBSITE': contact === null || contact === void 0 ? void 0 : contact.website,
                    'DOC-NUM': document === null || document === void 0 ? void 0 : document.reference,
                    'EXP-DATE': (document === null || document === void 0 ? void 0 : document.expire_at) ? _this.date(document.expire_at) : '',
                    'DATE': (document === null || document === void 0 ? void 0 : document.date) ? _this.date(document.date) : '',
                    'BDC-TIERS': document === null || document === void 0 ? void 0 : document.customer_command_reference,
                    'INVOICE-ADDRESS': _this.getAddress(document === null || document === void 0 ? void 0 : document.billing_address),
                    'DELIVERY-ADDRESS': _this.getAddress(document === null || document === void 0 ? void 0 : document.delivery_address),
                    'TITLE': document === null || document === void 0 ? void 0 : document.title,
                    'ACOMPTE-AMOUNT': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.advance_payment_amount),
                    'ESCOMPTE': _this.number(document === null || document === void 0 ? void 0 : document.escompte_rate) + '%',
                    'ESCOMPTE-AM0UNT-HT': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.escompte_amount_ht),
                    'ESCOMPTE-AM0UNT-TVA': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.escompte_amount_tva),
                    'ESCOMPTE-AM0UNT-TTC': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.escompte_amount_ttc),
                    'PENALTY-RATE': _this.number(document === null || document === void 0 ? void 0 : document.penalty_rate) + '%',
                    'PAYMENT-TERM': (_9 = document === null || document === void 0 ? void 0 : document.payment_term) === null || _9 === void 0 ? void 0 : _9.label,
                    'TOTAL-HT': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.total_ht),
                    'TOTAL-TVA': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.total_tva),
                    'TOTAL-TTC': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.total_ttc),
                    'TO-PAID': _this.formattedNumber(120),
                    'ALREADY-PAID': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.already_paid),
                    'STAY-TO-PAID': _this.formattedNumber(document === null || document === void 0 ? void 0 : document.stay_to_pay),
                    'TODAY': moment__WEBPACK_IMPORTED_MODULE_3___default()().format('DD-MM-YYYY'),
                    'TODAY-DAY': _this.$t('communication.today.days.' + dayNumber),
                    'TODAY-DAY-NUMBER': dayNumber,
                    'TODAY-MONTH': _this.$t('communication.today.months.' + monthNumber),
                    'TODAY-MONTH-NUMBER': monthNumber,
                    'TODAY-YEAR': moment__WEBPACK_IMPORTED_MODULE_3___default()().format('YYYY'),
                    'DELIVERY-TRACKING': document === null || document === void 0 ? void 0 : document.delivery_tracking,
                    'CONSTRUCTION-REFERENCE': construction === null || construction === void 0 ? void 0 : construction.reference,
                    'CONSTRUCTION-TITLE': construction === null || construction === void 0 ? void 0 : construction.title,
                    'CONSTRUCTION-CONTACT': (_10 = construction === null || construction === void 0 ? void 0 : construction.contact) === null || _10 === void 0 ? void 0 : _10.fullname,
                    'CONSTRUCTION-ADDRESS': construction === null || construction === void 0 ? void 0 : construction.full_address,
                    'PLANIFICATION-BEGIN': planification ? moment__WEBPACK_IMPORTED_MODULE_3___default()(planification.begin).format('DD-MM-YYYY HH:mm') : null,
                    'PLANIFICATION-END': planification ? moment__WEBPACK_IMPORTED_MODULE_3___default()(planification.end).format('DD-MM-YYYY HH:mm') : null,
                };
            };
        },
        enumerable: false,
        configurable: true
    });
    VariablesMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapGetters)('user', ['team']))
        })
    ], VariablesMixin);
    return VariablesMixin;
}((0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Mixins */ .Xe)(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__.DateMixin, _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__.NumberMixin)));
/* harmony default export */ __webpack_exports__.A = (VariablesMixin);


/***/ }),

/***/ 3729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 3852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LibraryForm_LibraryForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LibraryForm/LibraryForm.vue?vue&type=template&id=4c1f8301
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.title,"visible":_vm.show,"ok-title":_vm.$t('interface.save'),"cancel-title":_vm.$t('interface.cancel'),"body-class":"pb-0","no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"busy":_vm.loading},on:{"ok":_vm.onOk,"hidden":_vm.onHidden}},[(_vm.errorMsg)?_c('b-alert',{attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):_vm._e(),_c('k-form',{ref:"form",attrs:{"action":_vm.formAction,"method":"POST"},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.files.form.name'),"description":_vm.$t('communication.files.form.nameExplain')}},[_c('k-form-input',{attrs:{"name":"name"},model:{value:(_vm.localValue.name),callback:function ($$v) {_vm.$set(_vm.localValue, "name", $$v)},expression:"localValue.name"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.files.form.file')}},[(_vm.localValue.id)?_c('k-form-checkbox',{staticClass:"mb-2 mt-1",model:{value:(_vm.updateFile),callback:function ($$v) {_vm.updateFile=$$v},expression:"updateFile"}},[_vm._v(" Modifier le fichier ")]):_vm._e(),_c('k-form-file',{ref:"upload",attrs:{"url":_vm.formAction,"datas":{
            name: _vm.localValue.name ? _vm.localValue.name : ''
          },"btn-mode":"","btn-size":"sm","name":"file","instantUpload":false,"disabled":_vm.localValue.id && !_vm.updateFile},on:{"onUploadStart":function($event){_vm.loading = true},"onUpload":_vm.uploadComplete},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LibraryForm/LibraryForm.ts?vue&type=script&lang=ts&external





var LibraryForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LibraryForm, _super);
    function LibraryForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = {};
        _this.updateFile = false;
        _this.file = null;
        _this.loading = false;
        _this.errorMsg = null;
        return _this;
    }
    Object.defineProperty(LibraryForm.prototype, "formAction", {
        get: function () {
            var url = '/mail/library';
            if (this.localValue.id) {
                url += '/' + this.localValue.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LibraryForm.prototype, "title", {
        get: function () {
            var key = this.localValue.id ? 'edit' : 'create';
            return this.$t('communication.files.' + key + 'Title');
        },
        enumerable: false,
        configurable: true
    });
    LibraryForm.prototype.watchValue = function (value) {
        this.localValue = value === null ? {} : JSON.parse(JSON.stringify(value));
        if (this.localValue.filename === this.localValue.name) {
            this.localValue.name = '';
        }
        this.updateFile = false;
    };
    LibraryForm.prototype.onOk = function (bvEvent) {
        var _a;
        bvEvent.preventDefault();
        this.loading = true;
        var upload = this.$refs.upload;
        var hasFiles = upload.hasFile();
        if ((!this.localValue.id || this.updateFile) && !hasFiles) {
            this.errorMsg = this.$t('communication.files.form.fileIsRequired');
            this.loading = false;
            return;
        }
        else if (this.localValue.id && this.localValue.name === ((_a = this.value) === null || _a === void 0 ? void 0 : _a.name) && !hasFiles) {
            // If no update
            this.onHidden();
            return;
        }
        if (hasFiles) {
            upload.upload();
        }
        else {
            var form = this.$refs.form;
            form.submit();
        }
    };
    LibraryForm.prototype.onHidden = function () {
        this.loading = false;
        this.errorMsg = null;
        this.$emit('hidden');
    };
    LibraryForm.prototype.submitComplete = function (response) {
        this.$emit('submitted', response.data);
    };
    LibraryForm.prototype.uploadComplete = function (file) {
        this.$emit('submitted', file);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LibraryForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], LibraryForm.prototype, "show", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], LibraryForm.prototype, "watchValue", null);
    LibraryForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal,
                BModal: external_bootstrap_vue_.BModal, BAlert: external_bootstrap_vue_.BAlert, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormCheckbox: form_vue_.KFormCheckbox, KFormFile: form_vue_.KFormFileUpload
            }
        })
    ], LibraryForm);
    return LibraryForm;
}(lib/* Vue */.lD));
/* harmony default export */ var LibraryFormvue_type_script_lang_ts_external = (LibraryForm);

;// ./src/components/LibraryForm/LibraryForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LibraryForm_LibraryFormvue_type_script_lang_ts_external = (LibraryFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LibraryForm/LibraryForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LibraryForm_LibraryFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LibraryForm_LibraryForm = (component.exports);

/***/ }),

/***/ 3862:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 3895:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'window-minimize';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f2d1';
var svgPathData = 'M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.um = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3950:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 4066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 4074:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var config = {
    enter: 2,
    fontSizeUnit: 'pt',
    zIndex: 999999,
    heightMin: 100,
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'fontSize',
                '|',
                'textColor',
                'backgroundColor',
                '|',
                'formatUL',
                'formatOL',
                'quote',
                '|',
                'insertImage',
                'insertTable',
                'insertHR',
                'insertLink',
                '|',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify',
                '|',
                'insertDynamicVariables'
            ],
            buttonsVisible: 18
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedAttrs: [
        'align', 'alt', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'class', 'color',
        'cols', 'colspan', 'content', 'contenteditable', 'data', 'data-.*', 'datetime', 'disabled', 'form', 'height',
        'hidden', 'href', 'id', 'label', 'max', 'min', 'multiple', 'name', 'placeholder', 'radiogroup', 'readonly',
        'rel', 'required', 'rows', 'rowspan', 'selected', 'size', 'sizes', 'span', 'src', 'step', 'style', 'tabindex',
        'target', 'title', 'type', 'value', 'valign', 'width'
    ],
    tableEditButtons: [
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableBorder',
        'tableBackground',
        '-',
        'tableCells',
        'tableCellBackground',
        'tableCellBorder',
        'tableCellHorizontalAlign'
    ],
    imageInsertButtons: ['imageByURL', 'uploadInlineImage'],
    imageDefaultDisplay: 'inline',
    imageEditButtons: ['imageReplace', 'imageRemove', 'imageSize']
};
/* harmony default export */ __webpack_exports__.A = (config);


/***/ }),

/***/ 4218:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 4247:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 4248:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 4321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Attachments_Attachments; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Attachments/Attachments.vue?vue&type=template&id=3d821050
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mail-attachments-list"},[_c('b-form-row',{staticClass:"d-inline-flex"},_vm._l((_vm.attachments),function(file,i){return _c('b-col',{key:i,staticClass:"file text-center mb-3",attrs:{"cols":"auto"}},[_c('b-overlay',{attrs:{"show":_vm.loadingFile === file.id}},[_c('div',{attrs:{"id":'file-' + file.id}},[_c('font-awesome-icon',{staticClass:"icon",style:({ color: _vm.color(file.extension) }),attrs:{"icon":['fad', _vm.icon(file.extension) ]}}),_c('p',{staticClass:"mb-0 file-infos"},[_c('span',{staticClass:"d-inline-block text-truncate w-100 small pt-1"},[_vm._v(" "+_vm._s(file.filename)+" ")]),_c('span',{staticClass:"small text-muted"},[_vm._v(" "+_vm._s(file.human_size)+" ")])])],1),_c('b-row',{staticClass:"actions px-0",attrs:{"no-gutters":"","cols":"3"}},[_c('b-col',[(_vm.canBePreview(file.extension))?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],staticClass:"btn-icon p-0",attrs:{"variant":"link","title":_vm.$t('interface.preview')},on:{"click":function($event){$event.preventDefault();return _vm.openPreviewFile(file)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'search' ]}})],1):_vm._e()],1),_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],staticClass:"btn-icon p-0",attrs:{"variant":"link","title":_vm.$t('interface.download')},on:{"click":function($event){$event.preventDefault();return _vm.download(file)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'download' ]}})],1)],1),(_vm.noDelete === false)?_c('b-col',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottom",modifiers:{"bottom":true}}],staticClass:"btn-icon p-0",attrs:{"variant":"link","title":_vm.$t('interface.delete')},on:{"click":function($event){$event.preventDefault();_vm.deleteIndex = i}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'trash' ]}})],1)],1):_vm._e()],1),_c('b-tooltip',{attrs:{"target":'file-' + file.id}},[_c('p',{staticClass:"mb-1 text-left"},[_vm._v(_vm._s(file.filename))]),_c('p',{staticClass:"mb-0 text-left"},[_vm._v(_vm._s(_vm.$t('interface.files.weight'))+" : "+_vm._s(_vm.filesize(file.size)))]),_c('p',{staticClass:"mb-0 text-left"},[_vm._v(_vm._s(_vm.$t('interface.files.type'))+" : "+_vm._s(_vm.filetype(file.extension)))])])],1)],1)}),1),(_vm.previewFile)?_c('b-modal',{attrs:{"visible":_vm.previewFile !== null,"size":"xxl","ok-only":"","ok-title":_vm.$t('interface.close')},on:{"hidden":function($event){_vm.previewFile = null}}},[(_vm.previewFile.extension === 'pdf')?_c('PdfViewer',{attrs:{"src":'data:application/pdf;base64,' + _vm.previewFile.file}}):_c('img',{staticClass:"w-100",attrs:{"src":'data:image/' + _vm.previewFile.extension + ';base64,' + _vm.previewFile.file,"alt":_vm.$t('interface.preview')}})],1):_vm._e(),(_vm.noDelete === false)?_c('b-modal',{attrs:{"visible":_vm.deleteIndex !== null,"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete')},on:{"hidden":function($event){_vm.deleteIndex = null},"ok":_vm.deleteFile}},[_vm._v(" "+_vm._s(_vm.$t('communication.attachmentDeleteMsg'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var index_es = __webpack_require__(1273);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Attachments/Attachments.ts?vue&type=script&lang=ts&external





var Attachments = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Attachments, _super);
    function Attachments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingFile = null;
        _this.previewFile = null;
        _this.deleteIndex = null;
        _this.removeAttachments = [];
        return _this;
    }
    Object.defineProperty(Attachments.prototype, "icon", {
        get: function () {
            var _this = this;
            return function (extension) {
                return _this.fileIcon(extension);
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Attachments.prototype, "color", {
        get: function () {
            var _this = this;
            return function (extension) {
                return _this.fileIconColor(extension);
            };
        },
        enumerable: false,
        configurable: true
    });
    Attachments.prototype.loadFile = function (file) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loadingFile = file.id;
                return [2 /*return*/, this.$kwCommunication.axios.get(this.baseUrl + '/' + file.id + '?with_file=1')
                        .then(function (response) { return response.data; })
                        .catch(function (error) { throw new Error(error); })
                        .finally(function () { return _this.loadingFile = null; })];
            });
        });
    };
    Attachments.prototype.download = function (file) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var loadedFile;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFile(file)];
                    case 1:
                        loadedFile = _a.sent();
                        this.downloadFile(loadedFile.file, loadedFile.filename);
                        return [2 /*return*/];
                }
            });
        });
    };
    Attachments.prototype.openPreviewFile = function (file) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.loadFile(file)];
                    case 1:
                        _a.previewFile = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Attachments.prototype.canBePreview = function (extension) {
        return this.fileCanBePreview(extension);
    };
    Attachments.prototype.deleteFile = function () {
        var _a;
        if (this.deleteIndex === null) {
            return;
        }
        var deleted = this.attachments.splice(this.deleteIndex, 1);
        (_a = this.removeAttachments).push.apply(_a, deleted);
        this.$emit('remove', deleted);
        this.deleteIndex = null;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Attachments.prototype, "attachments", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], Attachments.prototype, "noDelete", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: '/file' })
    ], Attachments.prototype, "baseUrl", void 0);
    Attachments = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PdfViewer: interface_vue_.PdfViewer,
                BFormRow: external_bootstrap_vue_.BFormRow, BCol: external_bootstrap_vue_.BCol, BRow: external_bootstrap_vue_.BRow, BButton: external_bootstrap_vue_.BButton, BTooltip: external_bootstrap_vue_.BTooltip, BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay,
                FontAwesomeIcon: index_es/* FontAwesomeIcon */.gc
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], Attachments);
    return Attachments;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var Attachmentsvue_type_script_lang_ts_external = (Attachments);

;// ./src/components/Attachments/Attachments.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Attachments_Attachmentsvue_type_script_lang_ts_external = (Attachmentsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Attachments/Attachments.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Attachments_Attachmentsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Attachments_Attachments = (component.exports);

/***/ }),

/***/ 4326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ModelDelete_ModelDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModelDelete/ModelDelete.vue?vue&type=template&id=6d039edb
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('communication.models.deleteMsg'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ModelDelete/ModelDelete.ts?vue&type=script&lang=ts&external




var ModelDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ModelDelete, _super);
    function ModelDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        return _this;
    }
    ModelDelete.prototype.mounted = function () {
        this.watchValue(this.value);
    };
    Object.defineProperty(ModelDelete.prototype, "apiUrl", {
        get: function () {
            var _a;
            return '/mail/model/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    ModelDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    ModelDelete.prototype.onOk = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault;
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.delete(this.apiUrl)
                                .then(function () {
                                _this.deleteModel(_this.value);
                                _this.deleted();
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ModelDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    ModelDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ModelDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ModelDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], ModelDelete.prototype, "watchValue", null);
    ModelDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['deleteModel']))
        })
    ], ModelDelete);
    return ModelDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ModelDeletevue_type_script_lang_ts_external = (ModelDelete);

;// ./src/components/ModelDelete/ModelDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ModelDelete_ModelDeletevue_type_script_lang_ts_external = (ModelDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ModelDelete/ModelDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ModelDelete_ModelDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModelDelete_ModelDelete = (component.exports);

/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 4394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 4509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 4517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(6545),
    noop = __webpack_require__(3950),
    setToArray = __webpack_require__(4247);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 4528:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(9770),
    stubArray = __webpack_require__(3345);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 4739:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 4831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CustomerLibraryButton_CustomerLibraryButton; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomerLibraryButton/CustomerLibraryButton.vue?vue&type=template&id=0a0a0298
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.showLibrary = true}}},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.computedLabel)+" "),_c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close'),"title":_vm.$t('communication.mail.form.filesCustomer'),"size":"xl","lazy":""},model:{value:(_vm.showLibrary),callback:function ($$v) {_vm.showLibrary=$$v},expression:"showLibrary"}},[_c('CustomerLibrary',{attrs:{"customerId":_vm.customerId},on:{"add":_vm.fileAdded}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/CustomerLibrary/CustomerLibrary.vue + 3 modules
var CustomerLibrary = __webpack_require__(1439);
// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var index_es = __webpack_require__(1273);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CustomerLibraryButton/CustomerLibraryButton.ts?vue&type=script&lang=ts&external





var CustomerLibraryButton = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CustomerLibraryButton, _super);
    function CustomerLibraryButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showLibrary = false;
        return _this;
    }
    Object.defineProperty(CustomerLibraryButton.prototype, "computedLabel", {
        get: function () {
            return this.label !== undefined ? this.label : this.$t('communication.mail.form.filesCustomer');
        },
        enumerable: false,
        configurable: true
    });
    CustomerLibraryButton.prototype.fileAdded = function (file) {
        return file;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CustomerLibraryButton.prototype, "customerId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'secondary' })
    ], CustomerLibraryButton.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerLibraryButton.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)()
    ], CustomerLibraryButton.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CustomerLibraryButton.prototype, "icon", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('added')
    ], CustomerLibraryButton.prototype, "fileAdded", null);
    CustomerLibraryButton = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton,
                BModal: external_bootstrap_vue_.BModal,
                CustomerLibrary: CustomerLibrary/* default */.A,
                FontAwesomeIcon: index_es/* FontAwesomeIcon */.gc
            }
        })
    ], CustomerLibraryButton);
    return CustomerLibraryButton;
}(lib/* Vue */.lD));
/* harmony default export */ var CustomerLibraryButtonvue_type_script_lang_ts_external = (CustomerLibraryButton);

;// ./src/components/CustomerLibraryButton/CustomerLibraryButton.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CustomerLibraryButton_CustomerLibraryButtonvue_type_script_lang_ts_external = (CustomerLibraryButtonvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CustomerLibraryButton/CustomerLibraryButton.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CustomerLibraryButton_CustomerLibraryButtonvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CustomerLibraryButton_CustomerLibraryButton = (component.exports);

/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 4932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 4974:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 5083:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isMasked = __webpack_require__(7296),
    isObject = __webpack_require__(3805),
    toSource = __webpack_require__(7473);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 5090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_SenderValidationView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SenderValidationView.vue?vue&type=template&id=b5ed802e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SenderValidation',{attrs:{"token":_vm.$route.params.token}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/SenderValidation/SenderValidation.vue + 3 modules
var SenderValidation = __webpack_require__(7890);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/SenderValidationView.vue?vue&type=script&lang=ts



var SenderValidationView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SenderValidationView, _super);
    function SenderValidationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SenderValidationView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SenderValidation: SenderValidation/* default */.A
            }
        })
    ], SenderValidationView);
    return SenderValidationView;
}(lib/* Vue */.lD));
/* harmony default export */ var SenderValidationViewvue_type_script_lang_ts = (SenderValidationView);

;// ./src/views/SenderValidationView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_SenderValidationViewvue_type_script_lang_ts = (SenderValidationViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/SenderValidationView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_SenderValidationViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_SenderValidationView = (component.exports);

/***/ }),

/***/ 5246:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'box-alt';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f49a';
var svgPathData = 'M446.7 160c.4-.5.5-.7.9-1.2L391.3 53.9C386.9 40.8 374.7 32 360.9 32H256l32 128h158.7zM160 160l32-128H87.1c-13.8 0-26 8.8-30.4 21.9L.4 158.8c.4.5.5.7.9 1.2H160zm128 32v80c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-80H0v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192H288z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.In = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5250:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    assignMergeValue = __webpack_require__(7805),
    baseFor = __webpack_require__(6649),
    baseMergeDeep = __webpack_require__(2824),
    isObject = __webpack_require__(3805),
    keysIn = __webpack_require__(7241),
    safeGet = __webpack_require__(4974);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 5259:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'share';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f064';
var svgPathData = 'M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.t5 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5288:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 5294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_LibraryListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/LibraryListView.vue?vue&type=template&id=5dd4e27a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LibraryList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/LibraryList/LibraryList.vue + 3 modules
var LibraryList = __webpack_require__(3176);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/LibraryListView.vue?vue&type=script&lang=ts



var LibraryListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LibraryListView, _super);
    function LibraryListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LibraryListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                LibraryList: LibraryList/* default */.A
            }
        })
    ], LibraryListView);
    return LibraryListView;
}(lib/* Vue */.lD));
/* harmony default export */ var LibraryListViewvue_type_script_lang_ts = (LibraryListView);

;// ./src/views/LibraryListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_LibraryListViewvue_type_script_lang_ts = (LibraryListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/LibraryListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_LibraryListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_LibraryListView = (component.exports);

/***/ }),

/***/ 5325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(6131);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 5341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LetterParams_LetterParams; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LetterParams/LetterParams.vue?vue&type=template&id=78a9f44d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.explain'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.params.model')}},[(_vm.localTeam.letters_model)?_c('div',{staticClass:"mt-2"},[_c('div',[_c('p',{staticClass:"text-center d-inline-block mb-1"},[_c('font-awesome-icon',{staticClass:"icon",style:({ color: '#5959ff', 'font-size': '2rem' }),attrs:{"icon":['fad', 'file-word' ]}}),_c('span',{staticClass:"d-inline-block text-truncate w-100 small pt-1"},[_vm._v(" "+_vm._s(_vm.localTeam.letters_model.filename)+" ")])],1)]),_c('b-overlay',{attrs:{"show":_vm.loadingDefaultModel}},[_c('div',{staticClass:"my-2"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadCustomModel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.toDelete = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])],1)]),_c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"no-close-on-esc":_vm.loadingDelete,"hide-header-close":_vm.loadingDelete,"no-close-on-backdrop":_vm.loadingDelete,"busy":_vm.loadingDelete},on:{"ok":_vm.deleteLettersModel},model:{value:(_vm.toDelete),callback:function ($$v) {_vm.toDelete=$$v},expression:"toDelete"}},[(_vm.loadingDelete)?_c('Spinner'):_c('div',[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.deleteMsg'))+" ")])],1)],1):_c('div',[_c('small',{staticClass:"mb-2"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.fileType'))+" ")]),_c('k-form-file',{attrs:{"url":_vm.formAction,"name":"letters_model","datas":{ _method: 'PUT' },"btnMode":"","btnSize":"sm","accept":['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text']},on:{"onUpload":_vm.applyNewTeam}})],1),_c('div',{staticClass:"mt-5"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.explain2'))),_c('br'),_c('b-overlay',{attrs:{"show":_vm.loadingDefaultModel}},[_c('b-button',{staticClass:"my-2",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.downloadDefaultModel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.downloadDefault'))+" ")])],1),_c('p',{staticClass:"mt-4 mb-2"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.params.variableExplain1'))+" "+_vm._s(_vm.$t('communication.letter.params.variableExplain2'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"200px"}},[_vm._v(_vm._s(_vm.$t('communication.letter.params.variable')))]),_c('th',[_vm._v(_vm._s(_vm.$t('communication.letter.params.description')))])])]),_c('tbody',[_c('tr',[_c('td',[_vm._v("$userFirstname$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.userFirstname')))])]),_c('tr',[_c('td',[_vm._v("$userLastname$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.userLastname')))])]),_c('tr',[_c('td',[_vm._v("$userFullname$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.userFullname')))])]),_c('tr',[_c('td',[_vm._v("$companyName$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.companyName')))])]),_c('tr',[_c('td',[_vm._v("$companyAddress$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.companyAddress')))])]),_c('tr',[_c('td',[_vm._v("$companyTown$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.companyTown')))])]),_c('tr',[_c('td',[_vm._v("$address$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.address')))])]),_c('tr',[_c('td',[_vm._v("$contactCivility$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.contactCivility')))])]),_c('tr',[_c('td',[_vm._v("$contactCivilityShort$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.contactCivilityShort')))])]),_c('tr',[_c('td',[_vm._v("$contactFirstname$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.contactFirstname')))])]),_c('tr',[_c('td',[_vm._v("$contactLastname$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.contactLastname')))])]),_c('tr',[_c('td',[_vm._v("$contactFullname$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.contactFullname')))])]),_c('tr',[_c('td',[_vm._v("$date$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.date')))])]),_c('tr',[_c('td',[_vm._v("$subject$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.subject')))])]),_c('tr',[_c('td',[_vm._v("$sendAr$XXX$sendAr$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.sendAr')))])]),_c('tr',[_c('td',[_vm._v("$content$")]),_c('td',[_vm._v(_vm._s(_vm.$t('communication.letter.params.content')))])])])])],1)])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var index_es = __webpack_require__(1273);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LetterParams/LetterParams.ts?vue&type=script&lang=ts&external






var LetterParams = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LetterParams, _super);
    function LetterParams() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toDelete = false;
        _this.loadingDelete = false;
        _this.loadingDefaultModel = false;
        _this.loadingCustomModel = false;
        return _this;
    }
    LetterParams.prototype.downloadCustomModel = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var model;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        model = (_a = this.localTeam) === null || _a === void 0 ? void 0 : _a.letters_model;
                        if (!model) {
                            return [2 /*return*/];
                        }
                        this.loadingCustomModel = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.get('/file/' + model.id + '?with_file=1')
                                .then(function (response) {
                                _this.downloadFile(response.data.file, model.filename);
                            })
                                .finally(function () {
                                _this.loadingCustomModel = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LetterParams.prototype.downloadDefaultModel = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingDefaultModel = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.get('/communication/default-letter-model')
                                .then(function (response) {
                                _this.downloadFile(response.data, 'letter-model.docx');
                            })
                                .finally(function () {
                                _this.loadingDefaultModel = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LetterParams.prototype.deleteLettersModel = function (evt) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        evt.preventDefault();
                        this.loadingDelete = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.put(this.formAction, {
                                letters_model: null
                            })
                                .then(function (response) {
                                _this.applyNewTeam(response.data);
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.toDelete = false;
                                _this.loadingDelete = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LetterParams = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                KFormFile: form_vue_.KFormFileUpload,
                BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BModal: external_bootstrap_vue_.BModal, BOverlay: external_bootstrap_vue_.BOverlay,
                FontAwesomeIcon: index_es/* FontAwesomeIcon */.gc
            }
        })
    ], LetterParams);
    return LetterParams;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin, interface_vue_.FileMixin)));
/* harmony default export */ var LetterParamsvue_type_script_lang_ts_external = (LetterParams);

;// ./src/components/LetterParams/LetterParams.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LetterParams_LetterParamsvue_type_script_lang_ts_external = (LetterParamsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LetterParams/LetterParams.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LetterParams_LetterParamsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LetterParams_LetterParams = (component.exports);

/***/ }),

/***/ 5364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(5250),
    createAssigner = __webpack_require__(999);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 5389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(3663),
    baseMatchesProperty = __webpack_require__(7978),
    identity = __webpack_require__(3488),
    isArray = __webpack_require__(6449),
    property = __webpack_require__(583);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 5463:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 5474:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'clock';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f017';
var svgPathData = 'M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.a$ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 5528:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'reply';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f3e5';
var svgPathData = 'M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Ez = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(9344),
    getPrototype = __webpack_require__(8879),
    isPrototype = __webpack_require__(5527);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 5544:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chevron-right';
var width = 256;
var height = 512;
var ligatures = [];
var unicode = 'f054';
var svgPathData = 'M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Xk = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 5600:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'square';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f0c8';
var svgPathData = 'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Nf = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 5757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ MailboxLater_MailboxLater; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MailboxLater/MailboxLater.vue?vue&type=template&id=25baa9a2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-dropdown',{staticClass:"mailbox-dropdown",attrs:{"variant":_vm.variant,"size":_vm.size,"toggle-class":"labels","no-caret":""},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('font-awesome-icon',{attrs:{"icon":['fas', 'clock']}})]},proxy:true}])},[(_vm.header)?_c('b-dropdown-header',[_vm._v(" "+_vm._s(_vm.header)+" ")]):_vm._e(),_vm._l((_vm.letterChoices),function(choice,i){return _c('b-dropdown-item-button',{key:i,on:{"click":function($event){$event.preventDefault();return _vm.emit(choice.datetime)}}},[_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(choice.label)+" ")]),_c('span',{staticClass:"time"},[_vm._v(" "+_vm._s(choice.time)+" ")])])}),_c('b-dropdown-text',{staticClass:"mailbox-wait-form"},[_c('span',{staticClass:"px-1"},[_vm._v(" Le ")]),_c('k-form-datepicker',{attrs:{"size":"sm","min-date":_vm.now},model:{value:(_vm.waitDate),callback:function ($$v) {_vm.waitDate=$$v},expression:"waitDate"}}),_c('span',{staticClass:"px-1"},[_vm._v(" à ")]),_c('k-form-timepicker',{attrs:{"size":"sm","min-time":_vm.hour},model:{value:(_vm.waitTime),callback:function ($$v) {_vm.waitTime=$$v},expression:"waitTime"}}),_c('b-button',{attrs:{"disabled":_vm.waitDate === null || _vm.waitTime === null,"size":"sm","variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.emit(_vm.waitDate + ' ' + _vm.waitTime)}}},[_vm._v(" OK ")])],1)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var index_es = __webpack_require__(1273);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/MailboxLater/MailboxLater.ts?vue&type=script&lang=ts&external






var MailboxLater = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MailboxLater, _super);
    function MailboxLater() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.waitDate = (0,interface_vue_.moment)().add(1, 'day').format('YYYY-MM-DD');
        _this.waitTime = '08:00:00';
        return _this;
    }
    Object.defineProperty(MailboxLater.prototype, "now", {
        get: function () {
            return (0,interface_vue_.moment)().format('YYYY-MM-DD');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MailboxLater.prototype, "hour", {
        get: function () {
            return this.waitDate === this.now ? (0,interface_vue_.moment)().format('HH:mm') + ':00' : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MailboxLater.prototype, "letterChoices", {
        get: function () {
            var later = (0,interface_vue_.moment)().add(3, 'hours').set('minute', 0);
            var choices = [
                { label: 'Plus tard aujourd\'hui', time: later.format('ddd HH:mm'), datetime: later.format('YYYY-MM-DD HH:mm:ss') },
            ];
            var tomorrow = (0,interface_vue_.moment)().add(1, 'day').set('hour', 8).set('minute', 0);
            choices.push({ label: 'Demain', time: tomorrow.format('ddd HH:mm'), datetime: tomorrow.format('YYYY-MM-DD HH:mm:ss') });
            tomorrow.add(1, 'day');
            choices.push({ label: 'Après-demain', time: tomorrow.format('ddd HH:mm'), datetime: tomorrow.format('YYYY-MM-DD HH:mm:ss') });
            tomorrow.add(1, 'day');
            if (![6, 0].includes(tomorrow.day())) {
                tomorrow.set('day', 5);
                choices.push({ label: 'Ce week-end', time: tomorrow.format('ddd HH:mm'), datetime: tomorrow.format('YYYY-MM-DD HH:mm:ss') });
            }
            tomorrow.add(1, 'week').set('day', 1);
            choices.push({ label: 'La semaine prochaine', time: tomorrow.format('ddd HH:mm'), datetime: tomorrow.format('YYYY-MM-DD HH:mm:ss') });
            return choices;
        },
        enumerable: false,
        configurable: true
    });
    MailboxLater.prototype.emit = function (datetime) {
        this.$emit('updated', datetime);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], MailboxLater.prototype, "header", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], MailboxLater.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], MailboxLater.prototype, "size", void 0);
    MailboxLater = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FontAwesomeIcon: index_es/* FontAwesomeIcon */.gc,
                BDropdownItemButton: external_bootstrap_vue_.BDropdownItemButton,
                BDropdownHeader: external_bootstrap_vue_.BDropdownHeader,
                BButton: external_bootstrap_vue_.BButton,
                KFormDatepicker: form_vue_.KFormDatepicker,
                BDropdown: external_bootstrap_vue_.BDropdown,
                BDropdownText: external_bootstrap_vue_.BDropdownText,
                KFormTimepicker: form_vue_.KFormTimepicker
            }
        })
    ], MailboxLater);
    return MailboxLater;
}(lib/* Vue */.lD));
/* harmony default export */ var MailboxLatervue_type_script_lang_ts_external = (MailboxLater);

;// ./src/components/MailboxLater/MailboxLater.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MailboxLater_MailboxLatervue_type_script_lang_ts_external = (MailboxLatervue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/MailboxLater/MailboxLater.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  MailboxLater_MailboxLatervue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MailboxLater_MailboxLater = (component.exports);

/***/ }),

/***/ 5765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8859),
    arrayIncludes = __webpack_require__(5325),
    arrayIncludesWith = __webpack_require__(9905),
    cacheHas = __webpack_require__(9219),
    createSet = __webpack_require__(4517),
    setToArray = __webpack_require__(4247);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 5806:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'folder-download';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'e053';
var svgPathData = 'M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM364.44,283.36,268,379.06a17.05,17.05,0,0,1-24,0l-96.42-95.7A16,16,0,0,1,158.81,256H224V208a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16v48h65.18A16,16,0,0,1,364.44,283.36Z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.UD = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5837:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'window-maximize';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f2d0';
var svgPathData = 'M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports._v = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(5580),
    Map = __webpack_require__(8223),
    Promise = __webpack_require__(2804),
    Set = __webpack_require__(6545),
    WeakMap = __webpack_require__(8303),
    baseGetTag = __webpack_require__(2552),
    toSource = __webpack_require__(7473);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 5911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8859),
    arraySome = __webpack_require__(4248),
    cacheHas = __webpack_require__(9219);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 5950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 5967:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrow-left';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f060';
var svgPathData = 'M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Ce = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 6025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 6083:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'file-user';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f65c';
var svgPathData = 'M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm80 273.6v19.2c0 10.61-10.03 19.2-22.4 19.2H102.4c-12.37 0-22.4-8.6-22.4-19.2v-19.2c0-31.81 30.09-57.6 67.2-57.6h4.95c12.29 5.12 25.73 8 39.85 8s27.56-2.88 39.85-8h4.95c37.11 0 67.2 25.79 67.2 57.6zM192 320c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm185-215L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.TP = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(5083),
    getValue = __webpack_require__(392);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 6131:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(2523),
    baseIsNaN = __webpack_require__(5463),
    strictIndexOf = __webpack_require__(6959);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 6436:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'inbox';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f01c';
var svgPathData = 'M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Up = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 6463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LibraryDelete_LibraryDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LibraryDelete/LibraryDelete.vue?vue&type=template&id=34683344
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"cancel":_vm.onCancel},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('communication.files.deleteMsg'))+" ")])],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LibraryDelete/LibraryDelete.ts?vue&type=script&lang=ts&external



var LibraryDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LibraryDelete, _super);
    function LibraryDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        return _this;
    }
    LibraryDelete.prototype.mounted = function () {
        this.watchValue(this.value);
    };
    LibraryDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    LibraryDelete.prototype.onCancel = function () {
        return null;
    };
    LibraryDelete.prototype.onOk = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.delete(this.apiUrl)
                                .then(function () {
                                _this.$emit('deleted');
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(LibraryDelete.prototype, "apiUrl", {
        get: function () {
            return '/mail/library/' + this.value;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LibraryDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], LibraryDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], LibraryDelete.prototype, "onCancel", null);
    LibraryDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], LibraryDelete);
    return LibraryDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var LibraryDeletevue_type_script_lang_ts_external = (LibraryDelete);

;// ./src/components/LibraryDelete/LibraryDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LibraryDelete_LibraryDeletevue_type_script_lang_ts_external = (LibraryDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LibraryDelete/LibraryDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LibraryDelete_LibraryDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LibraryDelete_LibraryDelete = (component.exports);

/***/ }),

/***/ 6545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 6547:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    eq = __webpack_require__(5288);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 6598:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f055';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.OQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6614:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'download';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f019';
var svgPathData = 'M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.cb = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 6721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1042);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 6757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(1033);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 6800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(5288),
    isArrayLike = __webpack_require__(4894),
    isIndex = __webpack_require__(361),
    isObject = __webpack_require__(3805);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 6959:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 7068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(7217),
    equalArrays = __webpack_require__(5911),
    equalByTag = __webpack_require__(1986),
    equalObjects = __webpack_require__(689),
    getTag = __webpack_require__(5861),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isTypedArray = __webpack_require__(7167);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 7106:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'folder';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f07b';
var svgPathData = 'M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.ao = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 7192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7342);
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faComments__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9275);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faSearch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(726);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faDownload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6614);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faWindowMinimize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3895);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faWindowMaximize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5837);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faCompressAlt__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9583);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faExpandAlt__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(867);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faTimes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2986);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faPaperclip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8888);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faBook__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7243);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faMailBulk__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2025);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faPlusCircle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6598);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7352);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faFileUser__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6083);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faFilter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8072);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faSquare__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5600);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faMinusSquare__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(2040);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faCheckSquare__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(1928);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faSync__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(260);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faChevronLeft__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(1793);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faChevronRight__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(5544);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faCaretRight__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(8257);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faCaretDown__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(7711);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faFolder__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(7106);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faPlus__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(906);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faInbox__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(6436);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faHourglassStart__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(2392);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faPaperPlane__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(8694);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faFile__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(197);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faTrash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1658);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faExclamationCircle__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(1277);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(1790);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faExclamation__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(9013);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faClock__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(5474);
/* harmony import */ var _fortawesome_pro_regular_svg_icons_faArrowLeft__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(5967);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faBoxAlt__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(5246);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faEnvelope__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(7258);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faFolderDownload__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(5806);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faReply__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(5528);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faReplyAll__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(7849);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faShare__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(5259);
/* harmony import */ var _fortawesome_pro_solid_svg_icons_faEllipsisV__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(8023);











































_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__.library.add(_fortawesome_pro_solid_svg_icons_faComments__WEBPACK_IMPORTED_MODULE_1__/* .faComments */ .q9, _fortawesome_pro_solid_svg_icons_faSearch__WEBPACK_IMPORTED_MODULE_2__/* .faSearch */ .Mj, _fortawesome_pro_solid_svg_icons_faDownload__WEBPACK_IMPORTED_MODULE_3__/* .faDownload */ .cb, _fortawesome_pro_solid_svg_icons_faTrash__WEBPACK_IMPORTED_MODULE_4__/* .faTrash */ .yL, _fortawesome_pro_regular_svg_icons_faWindowMaximize__WEBPACK_IMPORTED_MODULE_5__/* .faWindowMaximize */ ._v, _fortawesome_pro_regular_svg_icons_faWindowMinimize__WEBPACK_IMPORTED_MODULE_6__/* .faWindowMinimize */ .um, _fortawesome_pro_solid_svg_icons_faCompressAlt__WEBPACK_IMPORTED_MODULE_7__/* .faCompressAlt */ .rM, _fortawesome_pro_solid_svg_icons_faExpandAlt__WEBPACK_IMPORTED_MODULE_8__/* .faExpandAlt */ .vQ, _fortawesome_pro_solid_svg_icons_faTimes__WEBPACK_IMPORTED_MODULE_9__/* .faTimes */ .GR, _fortawesome_pro_solid_svg_icons_faPaperclip__WEBPACK_IMPORTED_MODULE_10__/* .faPaperclip */ .WM, _fortawesome_pro_solid_svg_icons_faBook__WEBPACK_IMPORTED_MODULE_11__/* .faBook */ .LB, _fortawesome_pro_solid_svg_icons_faMailBulk__WEBPACK_IMPORTED_MODULE_12__/* .faMailBulk */ .$8, _fortawesome_pro_solid_svg_icons_faPlusCircle__WEBPACK_IMPORTED_MODULE_13__/* .faPlusCircle */ .OQ, _fortawesome_pro_solid_svg_icons_faCheck__WEBPACK_IMPORTED_MODULE_14__/* .faCheck */ .e6, _fortawesome_pro_solid_svg_icons_faFileUser__WEBPACK_IMPORTED_MODULE_15__/* .faFileUser */ .TP, _fortawesome_pro_solid_svg_icons_faFilter__WEBPACK_IMPORTED_MODULE_16__/* .faFilter */ .mR, _fortawesome_pro_solid_svg_icons_faPlus__WEBPACK_IMPORTED_MODULE_17__/* .faPlus */ .QL, _fortawesome_pro_solid_svg_icons_faInbox__WEBPACK_IMPORTED_MODULE_18__/* .faInbox */ .Up, _fortawesome_pro_regular_svg_icons_faSquare__WEBPACK_IMPORTED_MODULE_19__/* .faSquare */ .Nf, _fortawesome_pro_regular_svg_icons_faMinusSquare__WEBPACK_IMPORTED_MODULE_20__/* .faMinusSquare */ .xb, _fortawesome_pro_regular_svg_icons_faCheckSquare__WEBPACK_IMPORTED_MODULE_21__/* .faCheckSquare */ .rQ, _fortawesome_pro_regular_svg_icons_faSync__WEBPACK_IMPORTED_MODULE_22__/* .faSync */ .VN, _fortawesome_pro_regular_svg_icons_faChevronLeft__WEBPACK_IMPORTED_MODULE_23__/* .faChevronLeft */ .Wz, _fortawesome_pro_regular_svg_icons_faChevronRight__WEBPACK_IMPORTED_MODULE_24__/* .faChevronRight */ .Xk, _fortawesome_pro_solid_svg_icons_faCaretRight__WEBPACK_IMPORTED_MODULE_25__/* .faCaretRight */ .fU, _fortawesome_pro_solid_svg_icons_faCaretDown__WEBPACK_IMPORTED_MODULE_26__/* .faCaretDown */ .xB, _fortawesome_pro_solid_svg_icons_faFolder__WEBPACK_IMPORTED_MODULE_27__/* .faFolder */ .ao, _fortawesome_pro_solid_svg_icons_faHourglassStart__WEBPACK_IMPORTED_MODULE_28__/* .faHourglassStart */ .et, _fortawesome_pro_solid_svg_icons_faPaperPlane__WEBPACK_IMPORTED_MODULE_29__/* .faPaperPlane */ .is, _fortawesome_pro_regular_svg_icons_faFile__WEBPACK_IMPORTED_MODULE_30__/* .faFile */ .A4, _fortawesome_pro_solid_svg_icons_faExclamationCircle__WEBPACK_IMPORTED_MODULE_31__/* .faExclamationCircle */ .tU, _fortawesome_pro_solid_svg_icons_faStar__WEBPACK_IMPORTED_MODULE_32__/* .faStar */ .yy, _fortawesome_pro_solid_svg_icons_faExclamation__WEBPACK_IMPORTED_MODULE_33__/* .faExclamation */ .bx, _fortawesome_pro_solid_svg_icons_faClock__WEBPACK_IMPORTED_MODULE_34__/* .faClock */ .a$, _fortawesome_pro_regular_svg_icons_faArrowLeft__WEBPACK_IMPORTED_MODULE_35__/* .faArrowLeft */ .Ce, _fortawesome_pro_solid_svg_icons_faBoxAlt__WEBPACK_IMPORTED_MODULE_36__/* .faBoxAlt */ .In, _fortawesome_pro_solid_svg_icons_faEnvelope__WEBPACK_IMPORTED_MODULE_37__/* .faEnvelope */ .y_, _fortawesome_pro_solid_svg_icons_faFolderDownload__WEBPACK_IMPORTED_MODULE_38__/* .faFolderDownload */ .UD, _fortawesome_pro_solid_svg_icons_faReply__WEBPACK_IMPORTED_MODULE_39__/* .faReply */ .Ez, _fortawesome_pro_solid_svg_icons_faReplyAll__WEBPACK_IMPORTED_MODULE_40__/* .faReplyAll */ .Jl, _fortawesome_pro_solid_svg_icons_faShare__WEBPACK_IMPORTED_MODULE_41__/* .faShare */ .t5, _fortawesome_pro_solid_svg_icons_faEllipsisV__WEBPACK_IMPORTED_MODULE_42__/* .faEllipsisV */ .v);


/***/ }),

/***/ 7197:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 7217:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(79),
    stackClear = __webpack_require__(1420),
    stackDelete = __webpack_require__(938),
    stackGet = __webpack_require__(3605),
    stackHas = __webpack_require__(9817),
    stackSet = __webpack_require__(945);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 7237:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 7241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeysIn = __webpack_require__(2903),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 7243:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'book';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f02d';
var svgPathData = 'M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.LB = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 7258:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'envelope';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f0e0';
var svgPathData = 'M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.y_ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(5481);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 7334:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 7342:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/fontawesome-svg-core");

/***/ }),

/***/ 7352:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'check';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f00c';
var svgPathData = 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.e6 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    toKey = __webpack_require__(7797);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 7473:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 7556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    arrayMap = __webpack_require__(4932),
    isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AttachmentsForm_AttachmentsForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AttachmentsForm/AttachmentsForm.vue?vue&type=template&id=fe1c422a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-form-group',{staticClass:"mb-2",attrs:{"label":_vm.$t('communication.models.form.files'),"label-cols-lg":"auto","label-class":"pt-1"}},[_c('LibraryListButton',{staticClass:"mr-2",attrs:{"size":"sm"},on:{"added":_vm.addLibraryFile}}),_c('k-form-file',{staticClass:"d-inline",attrs:{"url":_vm.url,"datas":_vm.datas,"imagePreview":false,"removeUploadedFile":true,"name":'add_attachments[' + _vm.value.add_attachments.length + ']',"btn-mode":"","btn-size":"sm","btn-label":_vm.$t('communication.models.form.uploadBtn'),"multiple":""},on:{"onUpload":_vm.fileUploaded}})],1),_c('Attachments',{staticClass:"d-inline",attrs:{"attachments":_vm.value.attachments},on:{"remove":removed => _vm.value.remove_attachments.push(...removed)}}),_c('Attachments',{staticClass:"d-inline",attrs:{"attachments":_vm.value.add_attachments}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/LibraryListButton/LibraryListButton.vue + 3 modules
var LibraryListButton = __webpack_require__(8546);
// EXTERNAL MODULE: ./src/components/Attachments/Attachments.vue + 3 modules
var Attachments = __webpack_require__(4321);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AttachmentsForm/AttachmentsForm.ts?vue&type=script&lang=ts&external






var AttachmentsForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AttachmentsForm, _super);
    function AttachmentsForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttachmentsForm.prototype.fileUploaded = function (model) {
        return Object.assign(model, {
            add_attachments: [],
            remove_attachments: []
        });
    };
    AttachmentsForm.prototype.addLibraryFile = function (file) {
        var inAttachment = this.value.attachments && this.value.attachments.find(function (attachment) { return 'id' in attachment && attachment.id === file.id; });
        var waiting = this.value.add_attachments && this.value.add_attachments.find(function (attachment) { return 'id' in attachment && attachment.id === file.id; });
        if (!inAttachment && !waiting) {
            this.value.add_attachments.push(file);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AttachmentsForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AttachmentsForm.prototype, "url", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], AttachmentsForm.prototype, "datas", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], AttachmentsForm.prototype, "fileUploaded", null);
    AttachmentsForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                LibraryListButton: LibraryListButton/* default */.A,
                Attachments: Attachments/* default */.A,
                KFormFile: form_vue_.KFormFile,
                BFormGroup: external_bootstrap_vue_.BFormGroup
            }
        })
    ], AttachmentsForm);
    return AttachmentsForm;
}(lib/* Vue */.lD));
/* harmony default export */ var AttachmentsFormvue_type_script_lang_ts_external = (AttachmentsForm);

;// ./src/components/AttachmentsForm/AttachmentsForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AttachmentsForm_AttachmentsFormvue_type_script_lang_ts_external = (AttachmentsFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AttachmentsForm/AttachmentsForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AttachmentsForm_AttachmentsFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AttachmentsForm_AttachmentsForm = (component.exports);

/***/ }),

/***/ 7670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(2651);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 7711:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'caret-down';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f0d7';
var svgPathData = 'M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.xB = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7797:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(4394);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 7805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(3360),
    eq = __webpack_require__(5288);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 7828:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 7849:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'reply-all';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f122';
var svgPathData = 'M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Jl = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ SenderValidation_SenderValidation; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SenderValidation/SenderValidation.vue?vue&type=template&id=970c317c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_vm._e(),(_vm.is404Error)?[_c('p',{staticClass:"text-center font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.confirm404Error'))+" ")])]:(_vm.errorMsg !== null)?[_c('p',{staticClass:"text-center font-weight-bold"},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])]:_c('p',{staticClass:"text-center font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.confirmSenderMessage', { email: _vm.sender.address }))+" ")])],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SenderValidation/SenderValidation.ts?vue&type=script&lang=ts&external



var SenderValidation = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SenderValidation, _super);
    function SenderValidation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.errorMsg = null;
        _this.is404Error = false;
        _this.sender = null;
        return _this;
    }
    SenderValidation.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validToken()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SenderValidation.prototype.validToken = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.$kwCommunication.axios.post('/mail/sender/validation/' + this.token)
                    .then(function (response) {
                    _this.sender = response.data;
                })
                    .catch(function (error) {
                    _this.is404Error = error.response.status === 404;
                    _this.errorMsg = error;
                })
                    .finally(function () {
                    _this.loading = false;
                });
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SenderValidation.prototype, "token", void 0);
    SenderValidation = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner
            }
        })
    ], SenderValidation);
    return SenderValidation;
}(lib/* Vue */.lD));
/* harmony default export */ var SenderValidationvue_type_script_lang_ts_external = (SenderValidation);

;// ./src/components/SenderValidation/SenderValidation.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SenderValidation_SenderValidationvue_type_script_lang_ts_external = (SenderValidationvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/SenderValidation/SenderValidation.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SenderValidation_SenderValidationvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SenderValidation_SenderValidation = (component.exports);

/***/ }),

/***/ 7978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(270),
    get = __webpack_require__(8156),
    hasIn = __webpack_require__(631),
    isKey = __webpack_require__(8586),
    isStrictComparable = __webpack_require__(756),
    matchesStrictComparable = __webpack_require__(7197),
    toKey = __webpack_require__(7797);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 8023:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'ellipsis-v';
var width = 192;
var height = 512;
var ligatures = [];
var unicode = 'f142';
var svgPathData = 'M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.v = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 8072:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'filter';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f0b0';
var svgPathData = 'M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.mR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8077:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 8156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7422);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 8223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 8257:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'caret-right';
var width = 192;
var height = 512;
var ligatures = [];
var unicode = 'f0da';
var svgPathData = 'M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.fU = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(6110),
    root = __webpack_require__(9325);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 8329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 8399:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/table-vue");

/***/ }),

/***/ 8546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ LibraryListButton_LibraryListButton; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LibraryListButton/LibraryListButton.vue?vue&type=template&id=724ba88d
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.showLibrary = true}}},[(_vm.icon)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.computedLabel)+" "),_c('b-modal',{attrs:{"ok-only":"","ok-title":_vm.$t('interface.close'),"title":_vm.$t('communication.files.pageTitle'),"size":"xl","lazy":""},model:{value:(_vm.showLibrary),callback:function ($$v) {_vm.showLibrary=$$v},expression:"showLibrary"}},[_c('LibraryList',{attrs:{"modalMode":""},on:{"add":_vm.fileAdded}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/LibraryList/LibraryList.vue + 3 modules
var LibraryList = __webpack_require__(3176);
// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var index_es = __webpack_require__(1273);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LibraryListButton/LibraryListButton.ts?vue&type=script&lang=ts&external





var LibraryListButton = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LibraryListButton, _super);
    function LibraryListButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showLibrary = false;
        return _this;
    }
    Object.defineProperty(LibraryListButton.prototype, "computedLabel", {
        get: function () {
            return this.label !== undefined ? this.label : this.$t('communication.models.form.libraryBtn');
        },
        enumerable: false,
        configurable: true
    });
    LibraryListButton.prototype.fileAdded = function (file) {
        return file;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'secondary' })
    ], LibraryListButton.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LibraryListButton.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)()
    ], LibraryListButton.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LibraryListButton.prototype, "icon", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('added')
    ], LibraryListButton.prototype, "fileAdded", null);
    LibraryListButton = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton,
                BModal: external_bootstrap_vue_.BModal,
                LibraryList: LibraryList/* default */.A,
                FontAwesomeIcon: index_es/* FontAwesomeIcon */.gc
            }
        })
    ], LibraryListButton);
    return LibraryListButton;
}(lib/* Vue */.lD));
/* harmony default export */ var LibraryListButtonvue_type_script_lang_ts_external = (LibraryListButton);

;// ./src/components/LibraryListButton/LibraryListButton.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LibraryListButton_LibraryListButtonvue_type_script_lang_ts_external = (LibraryListButtonvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/LibraryListButton/LibraryListButton.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  LibraryListButton_LibraryListButtonvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LibraryListButton_LibraryListButton = (component.exports);

/***/ }),

/***/ 8586:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(6449),
    isSymbol = __webpack_require__(4394);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 8655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(6025);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 8694:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'paper-plane';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f1d8';
var svgPathData = 'M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.is = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8859:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3661),
    setCacheAdd = __webpack_require__(1380),
    setCacheHas = __webpack_require__(1459);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 8879:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 8888:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'paperclip';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f0c6';
var svgPathData = 'M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.WM = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 9013:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'exclamation';
var width = 192;
var height = 512;
var ligatures = [];
var unicode = 'f12a';
var svgPathData = 'M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.bx = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ModelList_ModelList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModelList/ModelList.vue?vue&type=template&id=77d04a84
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-table"},[_c('PageHeader',{attrs:{"page-title":_vm.$t('communication.models.pageTitle'),"buttons":_vm.headerButtons}}),_c('k-table',{ref:"table",attrs:{"url":"/mail/model","columns":_vm.columns,"rowActions":_vm.rowActions}}),_c('ModelForm',{attrs:{"show":_vm.edited !== null},on:{"updated":_vm.modelUpdated,"submitted":_vm.submitted,"hidden":_vm.cancelEdited},model:{value:(_vm.edited),callback:function ($$v) {_vm.edited=$$v},expression:"edited"}}),_c('ModelDelete',{attrs:{"modal":_vm.deleteModel !== null},on:{"closed":function($event){_vm.deleteModel = null},"deleted":_vm.deleted},model:{value:(_vm.deleteModel),callback:function ($$v) {_vm.deleteModel=$$v},expression:"deleteModel"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ModelForm/ModelForm.vue + 5 modules
var ModelForm = __webpack_require__(9129);
// EXTERNAL MODULE: ./src/components/ModelDelete/ModelDelete.vue + 3 modules
var ModelDelete = __webpack_require__(4326);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ModelList/ModelList.ts?vue&type=script&lang=ts&external






var ModelList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ModelList, _super);
    function ModelList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.edited = null;
        _this.editedIndex = null;
        _this.deleteModel = null;
        _this.deleteIndex = null;
        return _this;
    }
    Object.defineProperty(ModelList.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('communication.models.newLabel'),
                    click: function () {
                        _this.toEdit();
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'name',
                    name: this.$t('communication.models.list.name'),
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    render: 'datetime'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('interface.edit'),
                    variant: 'primary',
                    click: function (model, index) {
                        _this.toEdit(model, index);
                    }
                },
                {
                    label: this.$t('interface.delete'),
                    variant: 'secondary',
                    click: function (model, index) {
                        _this.deleteModel = model;
                        _this.deleteIndex = index;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ModelList.prototype.toEdit = function (model, index) {
        if (model === void 0) { model = null; }
        if (index === void 0) { index = null; }
        this.edited = model !== null && model !== void 0 ? model : {};
        this.editedIndex = index;
    };
    ModelList.prototype.modelUpdated = function (model) {
        var table = this.$refs.table;
        if (this.editedIndex !== null && this.editedIndex >= 0) {
            table.updateRow(this.editedIndex, model);
            this.editedIndex = null;
        }
        else {
            table.addRow(model);
        }
    };
    ModelList.prototype.submitted = function (model) {
        this.modelUpdated(model);
        this.cancelEdited();
    };
    ModelList.prototype.cancelEdited = function () {
        this.edited = null;
    };
    ModelList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
        }
    };
    ModelList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ModelForm: ModelForm/* default */.A,
                ModelDelete: ModelDelete/* default */.A,
                PageHeader: interface_vue_.PageHeader,
                KTable: table_vue_.KTable
            }
        })
    ], ModelList);
    return ModelList;
}(lib/* Vue */.lD));
/* harmony default export */ var ModelListvue_type_script_lang_ts_external = (ModelList);

;// ./src/components/ModelList/ModelList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ModelList_ModelListvue_type_script_lang_ts_external = (ModelListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ModelList/ModelList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ModelList_ModelListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModelList_ModelList = (component.exports);

/***/ }),

/***/ 9052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CommunicationParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommunicationParamsView.vue?vue&type=template&id=a41f3e7a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CommunicationParams')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CommunicationParams/CommunicationParams.vue + 3 modules
var CommunicationParams = __webpack_require__(3607);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CommunicationParamsView.vue?vue&type=script&lang=ts



var CommunicationParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommunicationParamsView, _super);
    function CommunicationParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommunicationParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CommunicationParams: CommunicationParams/* default */.A
            }
        })
    ], CommunicationParamsView);
    return CommunicationParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var CommunicationParamsViewvue_type_script_lang_ts = (CommunicationParamsView);

;// ./src/views/CommunicationParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CommunicationParamsViewvue_type_script_lang_ts = (CommunicationParamsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CommunicationParamsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CommunicationParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CommunicationParamsView = (component.exports);

/***/ }),

/***/ 9129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ModelForm_ModelForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModelForm/ModelForm.vue?vue&type=template&id=4de8f89c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('FormModal',{attrs:{"title":_vm.title,"visible":_vm.show,"size":"xl"},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":"POST"},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.models.form.name')}},[_c('k-form-input',{attrs:{"name":"name","required":""},model:{value:(_vm.localValue.name),callback:function ($$v) {_vm.$set(_vm.localValue, "name", $$v)},expression:"localValue.name"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.models.form.subject')}},[_c('k-form-editor',{attrs:{"config":_vm.subjectConfig,"name":"subject","required":"","size":"sm"},model:{value:(_vm.localValue.subject),callback:function ($$v) {_vm.$set(_vm.localValue, "subject", $$v)},expression:"localValue.subject"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.models.form.message')}},[_c('k-form-editor',{attrs:{"config":_vm.editorConfig,"name":"html","required":"","size":"sm"},model:{value:(_vm.localValue.html),callback:function ($$v) {_vm.$set(_vm.localValue, "html", $$v)},expression:"localValue.html"}})],1),_c('b-form-group',{staticClass:"mb-2",attrs:{"label":_vm.$t('communication.models.form.files'),"label-cols":"auto","label-class":"pt-1"}},[_c('LibraryListButton',{staticClass:"mr-2",attrs:{"size":"sm"},on:{"added":_vm.addLibraryFile}}),_c('k-form-file',{staticClass:"d-inline",attrs:{"url":_vm.formAction,"datas":_vm.formDatas,"imagePreview":false,"removeUploadedFile":true,"name":'add_attachments[' + _vm.localValue.add_attachments.length + ']',"btn-mode":"","btn-size":"sm","btn-label":_vm.$t('communication.models.form.uploadBtn'),"multiple":""},on:{"onUpload":_vm.fileUploaded}})],1),_c('Attachments',{staticClass:"d-inline",attrs:{"attachments":_vm.localValue.library_files},on:{"remove":_vm.removeLibraryFile}}),_c('Attachments',{staticClass:"d-inline",attrs:{"attachments":_vm.localValue.add_library_files},on:{"remove":_vm.removeLibraryFile}}),_c('Attachments',{staticClass:"d-inline",attrs:{"attachments":_vm.localValue.attachments},on:{"remove":_vm.removeAttachments}}),_c('Attachments',{staticClass:"d-inline",attrs:{"attachments":_vm.localValue.add_attachments},on:{"remove":_vm.removeAttachments}}),_vm._l((_vm.localValue.add_library_files),function(file){return _c('input',{key:file.id,attrs:{"type":"hidden","name":"add_library_files[]"},domProps:{"value":file.id}})}),_vm._l((_vm.localValue.remove_library_files),function(file){return _c('input',{key:file.id,attrs:{"type":"hidden","name":"remove_library_files[]"},domProps:{"value":file.id}})}),_vm._l((_vm.localValue.remove_attachments),function(file){return _c('input',{key:file.id,attrs:{"type":"hidden","name":"remove_attachments[]"},domProps:{"value":file.id}})})],2)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/ModelForm/editorConfig.ts
var editorConfig = __webpack_require__(4074);
;// ./src/components/ModelForm/subjectConfig.ts
var config = {
    zIndex: 9999999,
    heightMin: 40,
    multiLine: false,
    toolbarButtons: {
        moreText: {
            buttons: [
                'insertDynamicVariables'
            ],
            buttonsVisible: 2
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedTags: [],
    htmlAllowedAttrs: ['class', 'contenteditable', 'data-.*', 'data'],
    tableEditButtons: []
};
/* harmony default export */ var subjectConfig = (config);

// EXTERNAL MODULE: ./src/components/Attachments/Attachments.vue + 3 modules
var Attachments = __webpack_require__(4321);
// EXTERNAL MODULE: ./src/components/AttachmentsForm/AttachmentsForm.vue + 3 modules
var AttachmentsForm = __webpack_require__(7605);
// EXTERNAL MODULE: ./src/components/LibraryListButton/LibraryListButton.vue + 3 modules
var LibraryListButton = __webpack_require__(8546);
// EXTERNAL MODULE: ./src/fetchDatas/mailModel.ts
var mailModel = __webpack_require__(3644);
;// ./src/components/ModelForm/dynamicVariables.ts
var variables = function (i18n) {
    return {
        company: {
            label: i18n.t('communication.variables.company.title'),
            variables: [
                { value: 'COMPANY-NAME', label: i18n.t('communication.variables.company.name') },
                { value: 'COMPANY-ROAD', label: i18n.t('communication.variables.road') },
                { value: 'COMPANY-ROAD2', label: i18n.t('communication.variables.road2') },
                { value: 'COMPANY-ROAD3', label: i18n.t('communication.variables.road3') },
                { value: 'COMPANY-POSTAL', label: i18n.t('communication.variables.postal') },
                { value: 'COMPANY-TOWN', label: i18n.t('communication.variables.town') },
                { value: 'COMPANY-COUNTRY', label: i18n.t('communication.variables.country') },
                { value: 'COMPANY-PHONE', label: i18n.t('communication.variables.phone') },
                { value: 'COMPANY-MOBILE', label: i18n.t('communication.variables.mobile') },
                { value: 'COMPANY-FAX', label: i18n.t('communication.variables.fax') },
                { value: 'COMPANY-EMAIL', label: i18n.t('communication.variables.email') },
                { value: 'COMPANY-WEBSITE', label: i18n.t('communication.variables.website') },
                { value: 'COMPANY-TYPE', label: i18n.t('communication.variables.company.type') },
                { value: 'COMPANY-SIRET', label: i18n.t('communication.variables.company.siret') },
                { value: 'COMPANY-RCS', label: i18n.t('communication.variables.company.rcs') },
                { value: 'COMPANY-TVA', label: i18n.t('communication.variables.company.tva') },
                { value: 'COMPANY-NAF', label: i18n.t('communication.variables.company.naf') },
                { value: 'COMPANY-CAPITAL', label: i18n.t('communication.variables.company.capital') }
            ]
        },
        tiers: {
            label: i18n.t('communication.variables.customer.title'),
            variables: [
                { value: 'TIERS-CODE', label: i18n.t('communication.variables.customer.code') },
                { value: 'TIERS-NAME', label: i18n.t('communication.variables.customer.name') },
                { value: 'TIERS-ROAD', label: i18n.t('communication.variables.road') },
                { value: 'TIERS-ROAD2', label: i18n.t('communication.variables.road2') },
                { value: 'TIERS-ROAD3', label: i18n.t('communication.variables.road3') },
                { value: 'TIERS-POSTAL', label: i18n.t('communication.variables.postal') },
                { value: 'TIERS-TOWN', label: i18n.t('communication.variables.town') },
                { value: 'TIERS-COUNTRY', label: i18n.t('communication.variables.country') },
                { value: 'TIERS-PHONE', label: i18n.t('communication.variables.phone') },
                { value: 'TIERS-MOBILE', label: i18n.t('communication.variables.mobile') },
                { value: 'TIERS-FAX', label: i18n.t('communication.variables.fax') },
                { value: 'TIERS-EMAIL', label: i18n.t('communication.variables.email') },
                { value: 'TIERS-WEBSITE', label: i18n.t('communication.variables.website') },
                { value: 'TIERS-SIRET', label: i18n.t('communication.variables.company.siret') },
                { value: 'TIERS-TVA', label: i18n.t('communication.variables.company.tva') },
                { value: 'TIERS-COMMERCIAL', label: 'Prénom et nom du commercial' }
            ]
        },
        contact: {
            label: i18n.t('communication.variables.contact.title'),
            variables: [
                { value: 'CONTACT-FULLNAME', label: i18n.t('communication.variables.contact.fullname') },
                { value: 'CONTACT-CIVILITY', label: i18n.t('communication.variables.contact.civility') },
                { value: 'CONTACT-CIVILITY-FULL', label: i18n.t('communication.variables.contact.civilityFull') },
                { value: 'CONTACT-FIRSTNAME', label: i18n.t('communication.variables.contact.firstname') },
                { value: 'CONTACT-LASTNAME', label: i18n.t('communication.variables.contact.lastname') },
                { value: 'CONTACT-FUNCTION', label: i18n.t('communication.variables.contact.function') },
                { value: 'CONTACT-ROAD', label: i18n.t('communication.variables.road') },
                { value: 'CONTACT-ROAD2', label: i18n.t('communication.variables.road2') },
                { value: 'CONTACT-ROAD3', label: i18n.t('communication.variables.road3') },
                { value: 'CONTACT-POSTAL', label: i18n.t('communication.variables.postal') },
                { value: 'CONTACT-TOWN', label: i18n.t('communication.variables.town') },
                { value: 'CONTACT-COUNTRY', label: i18n.t('communication.variables.country') },
                { value: 'CONTACT-PHONE', label: i18n.t('communication.variables.phone') },
                { value: 'CONTACT-MOBILE', label: i18n.t('communication.variables.mobile') },
                { value: 'CONTACT-FAX', label: i18n.t('communication.variables.fax') },
                { value: 'CONTACT-EMAIL', label: i18n.t('communication.variables.email') },
                { value: 'CONTACT-WEBSITE', label: i18n.t('communication.variables.website') }
            ]
        },
        document: {
            label: i18n.t('communication.variables.document.title'),
            variables: [
                { value: 'DOC-NUM', label: i18n.t('communication.variables.document.reference') },
                { value: 'DATE', label: i18n.t('communication.variables.document.date') },
                { value: 'EXP-DATE', label: i18n.t('communication.variables.document.expDate') },
                { value: 'BDC-TIERS', label: i18n.t('communication.variables.document.customerCommand') },
                { value: 'INVOICE-ADDRESS', label: i18n.t('communication.variables.document.invoiceAddress') },
                { value: 'DELIVERY-ADDRESS', label: i18n.t('communication.variables.document.deliveryAddress') },
                { value: 'TITLE', label: i18n.t('communication.variables.document.documentTitle') },
                { value: 'ACOMPTE-AMOUNT', label: i18n.t('communication.variables.document.depositAmount') },
                { value: 'ESCOMPTE', label: i18n.t('communication.variables.document.escompte') },
                { value: 'ESCOMPTE-AM0UNT-HT', label: i18n.t('communication.variables.document.escompteHt') },
                { value: 'ESCOMPTE-AM0UNT-TVA', label: i18n.t('communication.variables.document.escompteTva') },
                { value: 'ESCOMPTE-AM0UNT-TTC', label: i18n.t('communication.variables.document.escompteTtc') },
                { value: 'PENALTY-RATE', label: i18n.t('communication.variables.document.penalty') },
                { value: 'PAYMENT-TERM', label: i18n.t('communication.variables.document.paymentTerm') },
                { value: 'TOTAL-HT', label: i18n.t('communication.variables.document.totalHt') },
                { value: 'TOTAL-TVA', label: i18n.t('communication.variables.document.totalTva') },
                { value: 'TOTAL-TTC', label: i18n.t('communication.variables.document.totalTtc') },
                { value: 'TO-PAID', label: i18n.t('communication.variables.document.toPaid') },
                { value: 'ALREADY-PAID', label: i18n.t('communication.variables.document.alreadyPaid') },
                { value: 'STAY-TO-PAID', label: i18n.t('communication.variables.document.stayToPaid') },
                { value: 'PAYMENT-LINK', label: i18n.t('communication.variables.document.paymentLink') },
                { value: 'DELIVERY-TRACKING', label: i18n.t('communication.variables.document.tracking') }
            ]
        },
        sender: {
            label: i18n.t('communication.variables.senderTitle'),
            variables: [
                { value: 'SENDER-EMAIL', label: i18n.t('communication.variables.email') },
                { value: 'SENDER-FIRSTNAME', label: i18n.t('communication.variables.contact.firstname') },
                { value: 'SENDER-LASTNAME', label: i18n.t('communication.variables.contact.lastname') },
                { value: 'SENDER-PHONE', label: i18n.t('communication.variables.phone') },
                { value: 'SENDER-MOBILE', label: i18n.t('communication.variables.mobile') }
            ]
        },
        other: {
            label: 'Date du jour',
            variables: [
                { value: 'TODAY', label: i18n.t('communication.variables.date.today') },
                { value: 'TODAY-DAY', label: i18n.t('communication.variables.date.todayNumber') },
                { value: 'TODAY-DAY-NUMBER', label: i18n.t('communication.variables.date.dayNumber') },
                { value: 'TODAY-MONTH-NUMBER', label: i18n.t('communication.variables.date.monthNumber') },
                { value: 'TODAY-MONTH', label: i18n.t('communication.variables.date.month') },
                { value: 'TODAY-YEAR', label: i18n.t('communication.variables.date.year') }
            ]
        },
        signature: {
            label: i18n.t('communication.variables.signatureTitle'),
            variables: [
                { value: 'SIGN-LINK', label: i18n.t('communication.variables.signatureLink') }
            ]
        },
        construction: {
            label: i18n.t('communication.variables.construction.title'),
            variables: [
                { value: 'CONSTRUCTION-REFERENCE', label: i18n.t('communication.variables.construction.reference') },
                { value: 'CONSTRUCTION-TITLE', label: i18n.t('communication.variables.construction.constructionTitle') },
                { value: 'CONSTRUCTION-CONTACT', label: i18n.t('communication.variables.construction.contact') },
                { value: 'CONSTRUCTION-ADDRESS', label: i18n.t('communication.variables.construction.address') },
                { value: 'PLANIFICATION-BEGIN', label: i18n.t('communication.variables.construction.begin') },
                { value: 'PLANIFICATION-END', label: i18n.t('communication.variables.construction.end') }
            ]
        }
    };
};
/* harmony default export */ var dynamicVariables = (variables);

// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(5364);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ModelForm/ModelForm.ts?vue&type=script&lang=ts&external














var ModelForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ModelForm, _super);
    function ModelForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = {
            attachments: [],
            add_attachments: [],
            remove_attachments: [],
            library_files: [],
            add_library_files: [],
            remove_library_files: []
        };
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(ModelForm.prototype, "editorConfig", {
        get: function () {
            return merge_default()(editorConfig/* default */.A, {
                dynamicVariables: this.variables
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelForm.prototype, "subjectConfig", {
        get: function () {
            return merge_default()(subjectConfig, {
                dynamicVariables: this.variables
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelForm.prototype, "variables", {
        get: function () {
            return dynamicVariables(this.$i18n);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelForm.prototype, "formAction", {
        get: function () {
            var url = '/mail/model';
            if (this.localValue.id) {
                url += '/' + this.localValue.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelForm.prototype, "formDatas", {
        get: function () {
            var value = this.localValue;
            var datas = {};
            if (value.name)
                datas.name = value.name;
            if (value.subject)
                datas.subject = value.subject;
            if (value.html)
                datas.html = value.html;
            if (value.remove_attachments.length > 0)
                datas.remove_attachments = value.remove_attachments.map(function (file) { return file.id; });
            if (value.add_library_files.length > 0)
                datas.add_library_files = value.add_library_files.map(function (file) { return file.id; });
            if (value.remove_library_files.length > 0)
                datas.remove_library_files = value.remove_library_files.map(function (file) { return file.id; });
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ModelForm.prototype, "title", {
        get: function () {
            var key = this.localValue.id ? 'edit' : 'create';
            return this.$t('communication.models.' + key + 'Title');
        },
        enumerable: false,
        configurable: true
    });
    ModelForm.prototype.watchValue = function (value) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(value && value.id)) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, (0,mailModel/* fetchMailModel */.xo)(value.id)];
                    case 1:
                        value = _a.sent();
                        this.loading = false;
                        _a.label = 2;
                    case 2:
                        this.setLocalValue(value);
                        return [2 /*return*/];
                }
            });
        });
    };
    ModelForm.prototype.setLocalValue = function (value) {
        this.localValue = Object.assign({
            attachments: [],
            add_attachments: [],
            remove_attachments: [],
            library_files: [],
            add_library_files: [],
            remove_library_files: [],
        }, value === null ? {} : JSON.parse(JSON.stringify(value)));
    };
    ModelForm.prototype.fileUploaded = function (model) {
        this.setModel(model);
        this.setLocalValue(model);
        return model;
    };
    ModelForm.prototype.submitComplete = function (response) {
        var model = response.data;
        this.setModel(model);
        return model;
    };
    // Add a library file
    ModelForm.prototype.addLibraryFile = function (file) {
        var deletedIndex = this.localValue.remove_library_files.findIndex(function (f) { return f.id === file.id; });
        if (deletedIndex >= 0) {
            this.localValue.remove_library_files.splice(deletedIndex, 1);
        }
        if (!this.localValue.add_library_files.find(function (f) { return f.id === file.id; }) &&
            !this.localValue.library_files.find(function (f) { return f.id === file.id; })) {
            this.localValue.add_library_files.push(file);
        }
    };
    // Remove a library file
    ModelForm.prototype.removeLibraryFile = function (files) {
        var _a;
        if (this.localValue.id) {
            (_a = this.localValue.remove_library_files).push.apply(_a, files);
        }
    };
    ModelForm.prototype.removeAttachments = function (files) {
        var _a;
        if (this.localValue.id) {
            (_a = this.localValue.remove_attachments).push.apply(_a, files);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ModelForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ModelForm.prototype, "show", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ModelForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('updated')
    ], ModelForm.prototype, "fileUploaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitted'),
        (0,lib/* Emit */.O5)('hidden')
    ], ModelForm.prototype, "submitComplete", null);
    ModelForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                LibraryListButton: LibraryListButton/* default */.A,
                AttachmentsForm: AttachmentsForm/* default */.A,
                Attachments: Attachments/* default */.A,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormEditor: form_vue_.KFormEditor, KFormFile: form_vue_.KFormFileUpload
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['setModel']))
        })
    ], ModelForm);
    return ModelForm;
}(lib/* Vue */.lD));
/* harmony default export */ var ModelFormvue_type_script_lang_ts_external = (ModelForm);

;// ./src/components/ModelForm/ModelForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ModelForm_ModelFormvue_type_script_lang_ts_external = (ModelFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/ModelForm/ModelForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  ModelForm_ModelFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModelForm_ModelForm = (component.exports);

/***/ }),

/***/ 9219:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 9275:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'comments';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f086';
var svgPathData = 'M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.q9 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9302:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488),
    overRest = __webpack_require__(6757),
    setToString = __webpack_require__(2865);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1769),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isIndex = __webpack_require__(361),
    isLength = __webpack_require__(294),
    toKey = __webpack_require__(7797);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 9344:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3805);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 9529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 9570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(7334),
    defineProperty = __webpack_require__(3243),
    identity = __webpack_require__(3488);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 9583:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'compress-alt';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f422';
var svgPathData = 'M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.rM = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm; },
  O5: function() { return /* reexport */ Emit; },
  Xe: function() { return /* reexport */ mixins; },
  kv: function() { return /* reexport */ Prop; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: Inject, InjectReactive, Model, ModelSync, PropSync, Provide, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) // removed by dead control flow
{}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) // removed by dead control flow
{}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9653:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(7828);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 9695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ModelListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ModelListView.vue?vue&type=template&id=2a7b07c4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModelList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/ModelList/ModelList.vue + 3 modules
var ModelList = __webpack_require__(9031);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ModelListView.vue?vue&type=script&lang=ts



var ModelListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ModelListView, _super);
    function ModelListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ModelList: ModelList/* default */.A
            }
        })
    ], ModelListView);
    return ModelListView;
}(lib/* Vue */.lD));
/* harmony default export */ var ModelListViewvue_type_script_lang_ts = (ModelListView);

;// ./src/views/ModelListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ModelListViewvue_type_script_lang_ts = (ModelListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ModelListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ModelListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ModelListView = (component.exports);

/***/ }),

/***/ 9754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(3729),
    baseEach = __webpack_require__(909),
    castFunction = __webpack_require__(4066),
    isArray = __webpack_require__(6449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 9770:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 9817:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 9884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(1791),
    keysIn = __webpack_require__(7241);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 9905:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 9998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	!function() {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = function(chunkId) {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce(function(promises, key) {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return "communication.common." + (chunkId === 1 ? "communication" : chunkId) + ".js";
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	!function() {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@kwixeo/communication-vue:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = function(url, done, key, chunkId) {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = function(prev, event) {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach(function(fn) { return fn(event); });
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			362: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = function(chunkId, promises) {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = function(event) {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_communication_vue"] = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_communication_vue"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AgregateDatas: function() { return /* reexport */ AgregateDatas_AgregateDatas; },
  Attachments: function() { return /* reexport */ Attachments/* default */.A; },
  AttachmentsForm: function() { return /* reexport */ AttachmentsForm/* default */.A; },
  CommunicationParams: function() { return /* reexport */ CommunicationParams/* default */.A; },
  CommunicationParamsView: function() { return /* reexport */ CommunicationParamsView["default"]; },
  CommunicationStore: function() { return /* reexport */ modules_CommunicationStore; },
  CustomerLibrary: function() { return /* reexport */ CustomerLibrary/* default */.A; },
  CustomerLibraryButton: function() { return /* reexport */ CustomerLibraryButton/* default */.A; },
  EmailDelete: function() { return /* reexport */ EmailDelete/* default */.A; },
  EmailItem: function() { return /* reexport */ EmailItem_EmailItem; },
  KwixeoCommunication: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ lang; },
  LetterDelete: function() { return /* reexport */ LetterDelete_LetterDelete; },
  LetterDownloadMixin: function() { return /* reexport */ mixins_LetterDownloadMixin; },
  LetterForm: function() { return /* reexport */ LetterForm_LetterForm; },
  LetterFormButton: function() { return /* reexport */ LetterFormButton_LetterFormButton; },
  LetterItem: function() { return /* reexport */ LetterItem_LetterItem; },
  LetterList: function() { return /* reexport */ LetterList_LetterList; },
  LetterParams: function() { return /* reexport */ LetterParams/* default */.A; },
  LetterParamsView: function() { return /* reexport */ LetterParamsView["default"]; },
  LibraryDelete: function() { return /* reexport */ LibraryDelete/* default */.A; },
  LibraryForm: function() { return /* reexport */ LibraryForm/* default */.A; },
  LibraryList: function() { return /* reexport */ LibraryList/* default */.A; },
  LibraryListButton: function() { return /* reexport */ LibraryListButton/* default */.A; },
  LibraryListView: function() { return /* reexport */ LibraryListView["default"]; },
  ModelDelete: function() { return /* reexport */ ModelDelete/* default */.A; },
  ModelForm: function() { return /* reexport */ ModelForm/* default */.A; },
  ModelList: function() { return /* reexport */ ModelList/* default */.A; },
  ModelListView: function() { return /* reexport */ ModelListView["default"]; },
  ModelSelect: function() { return /* reexport */ ModelSelect_ModelSelect; },
  ReportDelete: function() { return /* reexport */ ReportDelete_ReportDelete; },
  ReportForm: function() { return /* reexport */ ReportForm_ReportForm; },
  ReportFormButton: function() { return /* reexport */ ReportFormButton_ReportFormButton; },
  ReportItem: function() { return /* reexport */ ReportItem_ReportItem; },
  ReportList: function() { return /* reexport */ ReportList_ReportList; },
  SendEmail: function() { return /* reexport */ SendEmail/* default */.A; },
  SendEmailButton: function() { return /* reexport */ SendEmailButton_SendEmailButton; },
  SendEmailsArea: function() { return /* reexport */ SendEmailsArea_SendEmailsArea; },
  SenderDelete: function() { return /* reexport */ SenderDelete_SenderDelete; },
  SenderForm: function() { return /* reexport */ SenderForm_SenderForm; },
  SenderList: function() { return /* reexport */ SenderList_SenderList; },
  SenderValidation: function() { return /* reexport */ SenderValidation/* default */.A; },
  SenderValidationView: function() { return /* reexport */ SenderValidationView["default"]; },
  UserProfileView: function() { return /* reexport */ views_UserProfileView; },
  VariablesMixin: function() { return /* reexport */ VariablesMixin/* default */.A; },
  configRoutes: function() { return /* reexport */ configRoutes; },
  validationRules: function() { return /* reexport */ validate; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) // removed by dead control flow
{ var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AgregateDatas/AgregateDatas.vue?vue&type=template&id=d60bca72
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'agregate-datas': true,
    'tasks-hide-completed': !_vm.teamUserConfigs.task_timeline_completed_opacity
  }},[_c('b-row',[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"auto"}},[_c('b-dropdown',{staticClass:"add-menu mx-3",attrs:{"variant":"icon","no-caret":""},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}})]},proxy:true}])},[_c('b-dropdown-header',[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.newElement'))+" ")]),_vm._l((_vm.addElementMenu),function(entry,i){return [_c(entry.component,_vm._g(_vm._b({key:i,tag:"component"},'component',entry.attributes,false),entry.events),[(entry.label)?[_vm._v(" "+_vm._s(entry.label)+" ")]:_vm._e()],2)]})],2)],1),_c('b-col',{staticClass:"pl-0"},[_c('div',{staticClass:"agregate-menu"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.buttonTitle('file'), delay: { hide: 0 } }),expression:"{ title: buttonTitle('file'), delay: { hide: 0 } }"}],staticClass:"mb-1 ml-2",attrs:{"size":"sm","variant":_vm.isSelected('file') ? 'secondary' : 'light'},on:{"click":function($event){$event.preventDefault();return _vm.selectType('file')},"contextmenu":function($event){$event.preventDefault();_vm.forceState = 'file'}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.files'))+" "),_c('small',[_vm._v(_vm._s(_vm.totals && _vm.totals['file'] ? '(' + _vm.totals['file'] + ')' : '(' + 0 + ')'))])]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.buttonTitle('comment'), delay: { hide: 0 } }),expression:"{ title: buttonTitle('comment'), delay: { hide: 0 } }"}],staticClass:"ml-2 mb-1",attrs:{"size":"sm","variant":_vm.isSelected('comment') ? 'secondary' : 'light'},on:{"click":function($event){$event.preventDefault();return _vm.selectType('comment')},"contextmenu":function($event){$event.preventDefault();_vm.forceState = 'comment'}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.comments'))+" "),_c('small',[_vm._v(_vm._s(_vm.totals && _vm.totals['comment'] ? '(' + _vm.totals['comment'] + ')' : '(' + 0 + ')'))])]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.buttonTitle('task'), delay: { hide: 0 } }),expression:"{ title: buttonTitle('task'), delay: { hide: 0 } }"}],staticClass:"ml-2 mb-1",attrs:{"size":"sm","variant":_vm.isSelected('task') ? 'secondary' : 'light'},on:{"click":function($event){$event.preventDefault();return _vm.selectType('task')},"contextmenu":function($event){$event.preventDefault();_vm.forceState = 'task'}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.tasks'))+" "),_c('small',[_vm._v(_vm._s(_vm.totals && _vm.totals['task'] ? '(' + _vm.totals['task'] + ')' : '(' + 0 + ')'))])]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.buttonTitle('mail'), delay: { hide: 0 } }),expression:"{ title: buttonTitle('mail'), delay: { hide: 0 } }"}],staticClass:"ml-2 mb-1",attrs:{"size":"sm","variant":_vm.isSelected('mail') ? 'secondary' : 'light'},on:{"click":function($event){$event.preventDefault();return _vm.selectType('mail')},"contextmenu":function($event){$event.preventDefault();_vm.forceState = 'mail'}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.mails'))+" "),_c('small',[_vm._v(_vm._s(_vm.totals && _vm.totals['mail'] ? '(' + _vm.totals['mail'] + ')' : '(' + 0 + ')'))])]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.buttonTitle('event'), delay: { hide: 0 } }),expression:"{ title: buttonTitle('event'), delay: { hide: 0 } }"}],staticClass:"ml-2 mb-1",attrs:{"size":"sm","variant":_vm.isSelected('event') ? 'secondary' : 'light'},on:{"click":function($event){$event.preventDefault();return _vm.selectType('event')},"contextmenu":function($event){$event.preventDefault();_vm.forceState = 'event'}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.appointments'))+" "),_c('small',[_vm._v(_vm._s(_vm.totals && _vm.totals['event'] ? '(' + _vm.totals['event'] + ')' : '(' + 0 + ')'))])]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.buttonTitle('report'), delay: { hide: 0 } }),expression:"{ title: buttonTitle('report'), delay: { hide: 0 } }"}],staticClass:"ml-2 mb-1",attrs:{"size":"sm","variant":_vm.isSelected('report') ? 'secondary' : 'light'},on:{"click":function($event){$event.preventDefault();return _vm.selectType('report')},"contextmenu":function($event){$event.preventDefault();_vm.forceState = 'report'}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.reports'))+" "),_c('small',[_vm._v(_vm._s(_vm.totals && _vm.totals['report'] ? '(' + _vm.totals['report'] + ')' : '(' + 0 + ')'))])]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.buttonTitle('letter'), delay: { hide: 0 } }),expression:"{ title: buttonTitle('letter'), delay: { hide: 0 } }"}],staticClass:"ml-2 mb-1",attrs:{"size":"sm","variant":_vm.isSelected('letter') ? 'secondary' : 'light'},on:{"click":function($event){$event.preventDefault();return _vm.selectType('letter')},"contextmenu":function($event){$event.preventDefault();_vm.forceState = 'letter'}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.letters'))+" "),_c('small',[_vm._v(_vm._s(_vm.totals && _vm.totals['letter'] ? '(' + _vm.totals['letter'] + ')' : '(' + 0 + ')'))])]),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.buttonTitle('historic'), delay: { hide: 0 } }),expression:"{ title: buttonTitle('historic'), delay: { hide: 0 } }"}],staticClass:"ml-2 mb-1",attrs:{"size":"sm","variant":_vm.isSelected('historic') ? 'secondary' : 'light'},on:{"click":function($event){$event.preventDefault();return _vm.selectType('historic')},"contextmenu":function($event){$event.preventDefault();_vm.forceState = 'historic'}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.history'))+" "),_c('small',[_vm._v(_vm._s(_vm.totals && _vm.totals['historic'] ? '(' + _vm.totals['historic'] + ')' : '(' + 0 + ')'))])])],1)]),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-dropdown',{ref:"filter-dropdown",attrs:{"variant":"light","size":"sm","right":""},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('font-awesome-icon',{attrs:{"icon":['fas', 'filter']}}),(_vm.nbFilters > 0)?_c('b-badge',{staticClass:"ml-2",attrs:{"variant":"primary"}},[_vm._v(" "+_vm._s(_vm.nbFilters)+" ")]):_vm._e()]},proxy:true}])},[_c('b-dropdown-text',[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Utilisateur","label-size":"sm"}},[_c('TeamUserSelect',{attrs:{"size":"sm","multiple":"","reduce":opt => opt.id},on:{"input":_vm.teamUserFilter},model:{value:(_vm.filters.team_users),callback:function ($$v) {_vm.$set(_vm.filters, "team_users", $$v)},expression:"filters.team_users"}})],1)],1),_c('b-dropdown-text',[_c('b-form-group',{staticStyle:{"width":"250px"},attrs:{"label":"Date","label-size":"sm"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-1"},[_c('k-form-datepicker',{attrs:{"size":"sm","max-date":_vm.filters.end},model:{value:(_vm.filters.begin),callback:function ($$v) {_vm.$set(_vm.filters, "begin", $$v)},expression:"filters.begin"}})],1),_c('b-col',{staticClass:"px-0 small",attrs:{"cols":"auto"}},[_vm._v(" au ")]),_c('b-col',{staticClass:"pl-1"},[_c('k-form-datepicker',{attrs:{"size":"sm","min-date":_vm.filters.begin},model:{value:(_vm.filters.end),callback:function ($$v) {_vm.$set(_vm.filters, "end", $$v)},expression:"filters.end"}})],1)],1)],1)],1),(_vm.nbFilters > 0)?_c('b-dropdown-text',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();return _vm.clearFilters.apply(null, arguments)}}},[_vm._v(" Effacer les filtres ")])],1):_vm._e()],1)],1)],1),_c('hr',{staticClass:"mt-1"}),_c('k-form-file',{ref:"fileupload",staticClass:"upload-area",attrs:{"name":"file","url":"/file","datas":{
      element_id: _vm.id,
      element_type: _vm.type
    },"method":"post","multiple":"","removeUploadedFile":"","imagePreview":false,"btnMode":""},on:{"onUpload":_vm.fileAdded}}),(_vm.view === 'timeline' && !_vm.showOnlyFiles)?_c('div',{staticClass:"timeline"},[(_vm.noDatas && !_vm.loading)?_c('div',{staticClass:"empty"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.noDatas'))+" ")]):_vm._e(),_vm._l((_vm.groupedDatas),function(datas,i){return _c('div',{key:i,staticClass:"agregate-day"},[_c('p',{staticClass:"day"},[_vm._v(" "+_vm._s(_vm.stringDate(i))+" ")]),_vm._l((datas),function(data,j){return _c('div',{key:j,class:'agregate-element ' + data.type},[(data.type !== 'mail' && data.data.team_user)?_c('b-avatar',{staticClass:"timeline-avatar",attrs:{"text":data.data.team_user.initials,"src":_vm.teamUserAvatar(data.data.team_user),"size":"1.5rem"}}):_vm._e(),_c('div',{staticClass:"time"},[(_vm.withTime(data))?[_vm._v(" "+_vm._s(_vm.time(data.date))+" ")]:_vm._e()],2),(data.type === 'comment')?_c('div',[(data.data.team_user)?_c('p',{staticClass:"font-weight-bold mb-0"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.commentBy', { name: data.data.team_user.fullname }))+" ")]):_vm._e(),_c('CommentsItem',{attrs:{"withoutInformations":""},on:{"deleted":function($event){return _vm.deleted(data.type, data.id)}},model:{value:(data.data),callback:function ($$v) {_vm.$set(data, "data", $$v)},expression:"data.data"}})],1):(data.type === 'historic')?_c('div',[_vm._v(" "+_vm._s(data.data.message)+" ")]):(data.type === 'task')?_c('div',[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(_vm._s(_vm.$t('agregateDatas.task')))]),_c('TaskItem',{on:{"input":task => data.date = task.datetime,"deleted":function($event){return _vm.deleted(data.type, data.id)}},model:{value:(data.data),callback:function ($$v) {_vm.$set(data, "data", $$v)},expression:"data.data"}})],1):(data.type === 'file')?_c('div',[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.fileAdded'))+" ")]),_c('FileItem',{staticClass:"d-inline-block file-item",staticStyle:{"min-width":"100px"},on:{"deleted":function($event){return _vm.deleted(data.type, data.id)}},model:{value:(data.data),callback:function ($$v) {_vm.$set(data, "data", $$v)},expression:"data.data"}})],1):(data.type === 'mail')?_c('div',[(data.data.team_user)?_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.mailSendBy', { name: data.data.team_user.fullname }))+" ")]):_vm._e(),_c('p',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(data.data.subject)+" ")]),(data.data.send_status === false)?_c('p',{staticClass:"mb-1 font-weight-bold text-danger"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}}),_vm._v(" Une erreur est survenue lors de l'envoi de l'email ")],1):(data.data.send_status === true && data.data.read_at)?_c('p',{staticClass:"mb-1 font-weight-bold text-success"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}}),_vm._v(" Lu : "+_vm._s(_vm.datetime(data.data.read_at))+" ")],1):_vm._e(),_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.showEmail = data.data}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.see'))+" ")])],1):(data.type === 'paymentLink')?_c('div',[_c('p',{staticClass:"font-weight-bold mb-0"},[(data.data.team_user)?[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.paymentLinkSendBy', { name: data.data.team_user.fullname, amount: _vm.formattedNumber(data.data.amount) }))+" ")]:[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.paymentLink', { amount: _vm.formattedNumber(data.data.amount) }))+" ")],(data.data.name)?[_vm._v(" "+_vm._s(data.data.name)+" <"+_vm._s(data.data.email)+"> ")]:[_vm._v(" "+_vm._s(data.data.email)+" ")]],2),(_vm.isExpired(data.data.expire_at))?_c('p',{staticClass:"text-danger font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.paymentLinkExpired', { datetime: _vm.datetime(data.data.expire_at) }))+" ")]):(data.data.canceled_at !== null)?_c('p',{staticClass:"text-danger font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.paymentLinkCanceled', { datetime: _vm.datetime(data.data.canceled_at) }))+" ")]):(data.data.used_at !== null)?_c('p',{staticClass:"text-success font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.paymentLinkPaid', { datetime: _vm.datetime(data.data.used_at) }))+" ")]):_vm._e()]):(data.type === 'report')?_c('div',[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.render', { type: data.data.type?.label, name: data.data.created_by ? data.data.created_by.fullname : null }))+" ")]),_c('div',_vm._l((data.data.recipients),function(recipient,i){return _c('div',{key:i,staticClass:"d-inline-block mr-1"},[(recipient.type === 'teamUser')?_c('b-badge',{staticClass:"px-2 py-1 mb-1",attrs:{"variant":"tag"}},[_vm._v(" "+_vm._s(recipient.label)+" ")]):(recipient.type === 'customer')?_c('b-badge',{staticClass:"px-2 py-1 mb-1",attrs:{"variant":"tag","to":{ name: 'customer-item', params: { id: recipient.id } }}},[_vm._v(" "+_vm._s(recipient.label)+" ")]):(recipient.type === 'contact')?_c('b-badge',{staticClass:"px-2 py-1 mb-1",attrs:{"variant":"tag","to":{ name: 'contact-item', params: { id: recipient.id } }}},[_vm._v(" "+_vm._s(recipient.label)+" ")]):_vm._e()],1)}),0),_c('p',{staticClass:"mb-1 font-weight-bold"},[_vm._v(" "+_vm._s(data.data.subject)+" ")]),_c('p',{staticClass:"mb-1 preview-content"},[_vm._v(" "+_vm._s(_vm.previewContent(data.data.content))+" ")]),_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.showReport = data.data}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.see'))+" ")])],1):(data.type === 'letter')?_c('div',[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.letterSend', { name: data.data.created_by ? data.data.created_by.fullname : null }))+" ")]),_c('p',{staticClass:"mb-1 font-weight-bold"},[_vm._v(" "+_vm._s(data.data.subject)+" ")]),_c('p',{staticClass:"mb-1 preview-content"},[_vm._v(" "+_vm._s(_vm.previewContent(data.data.content))+" ")]),_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.showLetter = data.data}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.see'))+" ")]),_vm._v(" | "),_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.downloadLetter(data.data)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")])],1):(data.type === 'event')?_c('div',[_c('p',{staticClass:"font-weight-bold mb-1"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.appointment'))+" "),(data.data.title)?_c('span',[_vm._v(" : "+_vm._s(data.data.title)+" ")]):_vm._e()]),(data.data.comments)?_c('TextareaView',{staticClass:"mb-1 text-muted",model:{value:(data.data.comments),callback:function ($$v) {_vm.$set(data.data, "comments", $$v)},expression:"data.data.comments"}}):_vm._e(),_c('b-button',{staticClass:"p-0",attrs:{"variant":"link","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.eventForm(data.data)}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.see'))+" ")])],1):_vm._e()],1)})],2)})],2):(_vm.view === 'timeline' && _vm.showOnlyFiles)?_c('div',[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.filesList'))+" ")]),(_vm.files.length > 0)?_c('b-row',_vm._l((_vm.files),function(file,i){return _c('b-col',{key:i,attrs:{"cols":"auto"}},[_c('FileItem',{staticClass:"file-item",attrs:{"value":file.data}})],1)}),1):_c('p',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('interface.noFile'))+" ")])],1):_vm._e(),_c('FormModal',{attrs:{"title":_vm.$t('interface.comments.addTitle'),"size":"lg"},model:{value:(_vm.newComment),callback:function ($$v) {_vm.newComment=$$v},expression:"newComment"}},[_c('CommentsForm',{attrs:{"type":_vm.type,"id":_vm.id,"formOnly":""},on:{"submitted":_vm.commentAdded}})],1),(_vm.showEmail)?_c('EmailItem',{attrs:{"value":_vm.showEmail,"modal":_vm.showEmail !== null},on:{"hidden":function($event){_vm.showEmail = null}}}):_vm._e(),(_vm.showReport)?_c('ReportItem',{attrs:{"value":_vm.showReport,"modal":_vm.showReport !== null},on:{"hidden":function($event){_vm.showReport = null}}}):_vm._e(),(_vm.showLetter)?_c('LetterItem',{attrs:{"value":_vm.showLetter,"modal":_vm.showLetter !== null},on:{"hidden":function($event){_vm.showLetter = null}}}):_vm._e(),_c('p',{staticClass:"text-center"},[(_vm.haveMoreDatas && !_vm.loading)?_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();return _vm.loadDatas.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('agregateDatas.loadMore'))+" ")]):_vm._e()],1),(_vm.loading)?_c('Spinner'):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// external "lodash"
var external_lodash_namespaceObject = require("lodash");
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var index_es = __webpack_require__(1273);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// external "@kwixeo/tasks-vue"
var tasks_vue_namespaceObject = require("@kwixeo/tasks-vue");
;// external "@kwixeo/calendars-vue"
var calendars_vue_namespaceObject = require("@kwixeo/calendars-vue");
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SendEmailButton/SendEmailButton.vue?vue&type=template&id=66d9cc2e
var SendEmailButtonvue_type_template_id_66d9cc2e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();return _vm.newMail.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])
}
var SendEmailButtonvue_type_template_id_66d9cc2e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SendEmailButton/SendEmailButton.ts?vue&type=script&lang=ts&external




var SendEmailButton = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SendEmailButton, _super);
    function SendEmailButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SendEmailButton.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendEmailButton.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('communication.mail.mail');
        },
        enumerable: false,
        configurable: true
    });
    SendEmailButton.prototype.newMail = function () {
        this.openMailForm({
            contact: this.contact,
            customer: this.customer,
            preload: this.preload,
            mail: {
                elements: this.linkedElements,
                add_files: this.attachments,
                to: this.to
            }
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], SendEmailButton.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SendEmailButton.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SendEmailButton.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SendEmailButton.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SendEmailButton.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], SendEmailButton.prototype, "linkedElements", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], SendEmailButton.prototype, "attachments", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], SendEmailButton.prototype, "to", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SendEmailButton.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SendEmailButton.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SendEmailButton.prototype, "preload", void 0);
    SendEmailButton = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['openMailForm']))
        })
    ], SendEmailButton);
    return SendEmailButton;
}(lib/* Vue */.lD));
/* harmony default export */ var SendEmailButtonvue_type_script_lang_ts_external = (SendEmailButton);

;// ./src/components/SendEmailButton/SendEmailButton.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SendEmailButton_SendEmailButtonvue_type_script_lang_ts_external = (SendEmailButtonvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/SendEmailButton/SendEmailButton.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  SendEmailButton_SendEmailButtonvue_type_script_lang_ts_external,
  SendEmailButtonvue_type_template_id_66d9cc2e_render,
  SendEmailButtonvue_type_template_id_66d9cc2e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SendEmailButton_SendEmailButton = (component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/EmailItem/EmailItem.vue?vue&type=template&id=8965e670
var EmailItemvue_type_template_id_8965e670_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"visible":_vm.modal,"size":"lg","body-class":{
    'pb-0': _vm.mail?.attachments && _vm.mail.attachments.length > 0
  }},on:{"hidden":function($event){return _vm.$emit('hidden')}},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('EmailDelete',{on:{"deleted":() => { _vm.$emit('deleted'); close() }},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('div',{staticClass:"modal-footer-separator"}),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.close'))+" ")])]}}])},[(_vm.loading || !_vm.mail)?_c('Spinner'):[(_vm.mail.send_error !== null)?_c('p',{staticClass:"font-weight-bold text-danger"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}}),_vm._v(" "+_vm._s(_vm.$t('communication.mail.sendError'))+" ")],1):(_vm.mail.send_status === true && _vm.mail.read_at)?_c('p',{staticClass:"font-weight-bold text-success"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'check']}}),_vm._v(" "+_vm._s(_vm.$t('communication.mail.read'))+" "+_vm._s(_vm.datetime(_vm.mail.read_at))+" ")],1):_vm._e(),(_vm.mail.sender)?_c('b-form-group',{attrs:{"label-cols":"1","label-class":"pt-0","label":_vm.$t('communication.mail.form.from')}},[(_vm.mail.sender)?_c('span',[_c('strong',[_vm._v(_vm._s(_vm.mail.sender.name))]),_vm._v(" <")]):_vm._e(),_vm._v(_vm._s(_vm.mail.sender.address)),(_vm.mail.sender)?_c('span',[_vm._v(">")]):_vm._e()]):_vm._e(),(_vm.mail.to && _vm.mail.to.length > 0)?_c('b-form-group',{attrs:{"label":_vm.$t('communication.mail.form.to'),"label-cols":"1","label-class":"pt-0"}},_vm._l((_vm.mail.to),function(recipient,i){return _c('span',{key:i},[(recipient.name)?[(i > 0)?[_vm._v(", ")]:_vm._e(),_c('strong',[_vm._v(_vm._s(recipient.name))]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("<"+_vm._s(recipient.mail)+">")])]:[_c('strong',[_vm._v(_vm._s(recipient.mail))])]],2)}),0):_vm._e(),(_vm.mail.cc && _vm.mail.cc.length > 0)?_c('b-form-group',{attrs:{"label":_vm.$t('communication.mail.form.cc'),"label-cols":"1","label-class":"pt-0"}},_vm._l((_vm.mail.cc),function(recipient,i){return _c('span',{key:i},[(recipient.name)?[(i > 0)?[_vm._v(", ")]:_vm._e(),_c('strong',[_vm._v(_vm._s(recipient.name))]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("<"+_vm._s(recipient.mail)+">")])]:[_c('strong',[_vm._v(_vm._s(recipient.mail))])]],2)}),0):_vm._e(),(_vm.mail.cci && _vm.mail.cci.length > 0)?_c('b-form-group',{attrs:{"label":_vm.$t('communication.mail.form.cci'),"label-cols":"1","label-class":"pt-0"}},_vm._l((_vm.mail.cci),function(recipient,i){return _c('span',{key:i},[(recipient.name)?[(i > 0)?[_vm._v(", ")]:_vm._e(),_c('strong',[_vm._v(_vm._s(recipient.name))]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("<"+_vm._s(recipient.mail)+">")])]:[_c('strong',[_vm._v(_vm._s(recipient.mail))])]],2)}),0):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('communication.mail.form.subject')}},[_c('p',{staticClass:"communication-wrapper"},[(_vm.mail.subject === null)?_c('span',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.emptySubject'))+" ")]):[_vm._v(" "+_vm._s(_vm.mail.subject)+" ")]],2)]),_c('b-form-group',{attrs:{"label":_vm.$t('communication.mail.form.message')}},[(_vm.mail.html === null)?_c('p',{staticClass:"text-muted communication-wrapper mb-0"},[_vm._v(" "+_vm._s(_vm.$t('communication.mail.emptyContent'))+" ")]):_c('FroalaView',{staticClass:"communication-wrapper",model:{value:(_vm.mail.html),callback:function ($$v) {_vm.$set(_vm.mail, "html", $$v)},expression:"mail.html"}})],1),(_vm.mail.attachments && _vm.mail.attachments.length > 0)?_c('Attachments',{staticClass:"mt-4",attrs:{"attachments":_vm.mail.attachments,"noDelete":"","baseUrl":"/mail/attachment"}}):_vm._e()]],2)
}
var EmailItemvue_type_template_id_8965e670_staticRenderFns = []


// EXTERNAL MODULE: ./src/components/Attachments/Attachments.vue + 3 modules
var Attachments = __webpack_require__(4321);
// EXTERNAL MODULE: ./src/components/EmailDelete/EmailDelete.vue + 3 modules
var EmailDelete = __webpack_require__(3070);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./src/fetchDatas/mail.ts


var mailRelations = [
    'teamUser', 'recipients', 'attachments', 'sender'
];
var needFetchMail = function (model) {
    return !mailRelations.every(function (relation) { return relation in model; });
};
var fetchMail = function (id) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, external_vue_default().prototype.$kwCommunication.axios.get('/mail/' + id, {
                    params: {
                        include: mailRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/EmailItem/EmailItem.ts?vue&type=script&lang=ts&external









var EmailItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(EmailItem, _super);
    function EmailItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.mail = null;
        return _this;
    }
    EmailItem.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, fetchMail(this.value.id)];
                    case 1:
                        _a.mail = _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], EmailItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], EmailItem.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], EmailItem.prototype, "watchValue", null);
    EmailItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                BButton: external_bootstrap_vue_.BButton,
                FroalaView: form_vue_.FroalaView,
                Attachments: Attachments/* default */.A,
                EmailDelete: EmailDelete/* default */.A,
                FontAwesomeIcon: index_es/* FontAwesomeIcon */.gc,
                Spinner: interface_vue_.Spinner
            }
        })
    ], EmailItem);
    return EmailItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var EmailItemvue_type_script_lang_ts_external = (EmailItem);

;// ./src/components/EmailItem/EmailItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var EmailItem_EmailItemvue_type_script_lang_ts_external = (EmailItemvue_type_script_lang_ts_external); 
;// ./src/components/EmailItem/EmailItem.vue





/* normalize component */
;
var EmailItem_component = (0,componentNormalizer/* default */.A)(
  EmailItem_EmailItemvue_type_script_lang_ts_external,
  EmailItemvue_type_template_id_8965e670_render,
  EmailItemvue_type_template_id_8965e670_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var EmailItem_EmailItem = (EmailItem_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReportItem/ReportItem.vue?vue&type=template&id=1e476026
var ReportItemvue_type_template_id_1e476026_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline-block"},[(!_vm.deleteModalState && !_vm.editModalState)?_c('b-modal',{ref:"modal",attrs:{"visible":_vm.modal,"size":"lg","body-class":{
      'pb-0': _vm.value.attachments && _vm.value.attachments.length > 0
    },"scrollable":""},on:{"hidden":_vm.modalHidden},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-button',{on:{"click":function($event){$event.preventDefault();_vm.deleteModalState = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.editModalState = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.edit'))+" ")]),_c('div',{staticClass:"modal-footer-separator"}),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.close'))+" ")])]}}],null,false,1723715989)},[(_vm.loading)?_c('Spinner'):[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.type')}},[_vm._v(" "+_vm._s(_vm.report.type?.label)+" ")])],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.date')}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.report.date))+" ")])],1)],1),_c('b-form-group',{staticClass:"communication-recipient-items",attrs:{"label":_vm.$t('communication.report.form.recipients')}},_vm._l((_vm.report.recipients),function(recipient,i){return _c('b-badge',{key:i,class:{
                'px-2': true,
                'py-1': true,
                'mb-1': true,
                'ml-1': i > 0,
                'speed-item': recipient.type === 'customer' || recipient.type === 'contact'
              },attrs:{"variant":"tag"}},[(recipient.type === 'customer')?_c('CustomerSpeedItem',{attrs:{"size":"sm"},model:{value:(recipient.data),callback:function ($$v) {_vm.$set(recipient, "data", $$v)},expression:"recipient.data"}}):(recipient.type === 'contact')?_c('ContactSpeedItem',{attrs:{"size":"sm"},model:{value:(recipient.data),callback:function ($$v) {_vm.$set(recipient, "data", $$v)},expression:"recipient.data"}}):_c('span',[_vm._v(" "+_vm._s(recipient.label)+" ")])],1)}),1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.object')}},[_c('p',{staticClass:"communication-wrapper"},[(_vm.report.subject === null)?_c('span',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.$t('communication.report.emptySubject'))+" ")]):[_vm._v(" "+_vm._s(_vm.report.subject)+" ")]],2)]),_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.content')}},[(_vm.report.content === null)?_c('p',{staticClass:"text-muted communication-wrapper mb-0"},[_vm._v(" "+_vm._s(_vm.$t('communication.report.emptyContent'))+" ")]):_c('FroalaView',{staticClass:"communication-wrapper",model:{value:(_vm.report.content),callback:function ($$v) {_vm.$set(_vm.report, "content", $$v)},expression:"report.content"}})],1),(_vm.report.attachments && _vm.report.attachments.length > 0)?_c('Attachments',{staticClass:"mt-4",attrs:{"attachments":_vm.report.attachments,"noDelete":""}}):_vm._e()]],2):_vm._e(),_c('ReportForm',{attrs:{"modalState":_vm.editModalState,"customer":_vm.value.customer,"elements":_vm.value.elements},on:{"hidden":function($event){_vm.editModalState = false; _vm.modalHidden()},"submitComplete":report => _vm.$emit('input', report)},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('ReportDelete',{attrs:{"element":"modal","modal":_vm.deleteModalState},on:{"deleted":_vm.deleted,"closed":function($event){_vm.deleteModalState = false}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var ReportItemvue_type_template_id_1e476026_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReportForm/ReportForm.vue?vue&type=template&id=66b8e065
var ReportFormvue_type_template_id_66b8e065_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"size":"lg","title":_vm.modalTitle,"body-class":"pb-0","scrollable":""},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('k-form',{attrs:{"action":_vm.formAction,"method":"POST","value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.type')}},[(_vm.reportTypes.length === 2)?_c('b-form-radio-group',{staticClass:"pt-2",attrs:{"name":"type","options":_vm.reportTypes,"text-field":"label","value-field":"id"},model:{value:(_vm.report.type_id),callback:function ($$v) {_vm.$set(_vm.report, "type_id", $$v)},expression:"report.type_id"}}):(_vm.reportTypes.length === 1)?_c('span',{staticClass:"pt-2"},[_vm._v(" "+_vm._s(_vm.reportTypes[0].label)+" "),_c('input',{attrs:{"type":"hidden","name":"type"},domProps:{"value":_vm.report.type_id}})]):_c('k-form-select',{attrs:{"name":"type","options":_vm.reportTypes,"reduce":opt => opt.id,"clearable":false},model:{value:(_vm.report.type_id),callback:function ($$v) {_vm.$set(_vm.report, "type_id", $$v)},expression:"report.type_id"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.date')}},[_c('k-form-datetime',{attrs:{"name":"date","required":""},model:{value:(_vm.report.date),callback:function ($$v) {_vm.$set(_vm.report, "date", $$v)},expression:"report.date"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.recipients')}},[_c('k-form-select',{attrs:{"multiple":"","taggable":"","options":_vm.recipientsOptions,"getOptionKey":opt => opt.id ? opt.type + '-' + opt.id : null,"required":""},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('span',{class:{ 'communication-recipient-group': option.disabled === true }},[_vm._v(" "+_vm._s(option.label)+" ")])]}}]),model:{value:(_vm.report.recipients),callback:function ($$v) {_vm.$set(_vm.report, "recipients", $$v)},expression:"report.recipients"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.object')}},[_c('k-form-input',{attrs:{"name":"subject"},model:{value:(_vm.report.subject),callback:function ($$v) {_vm.$set(_vm.report, "subject", $$v)},expression:"report.subject"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.report.form.content')}},[_c('k-form-editor',{attrs:{"name":"content","size":"sm"},model:{value:(_vm.report.content),callback:function ($$v) {_vm.$set(_vm.report, "content", $$v)},expression:"report.content"}})],1),_c('AttachmentsForm',{attrs:{"url":_vm.formAction,"value":_vm.report,"datas":_vm.formDatas},on:{"input":_vm.reportUpdated}})],1)],1)
}
var ReportFormvue_type_template_id_66b8e065_staticRenderFns = []


// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(1146);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);
// EXTERNAL MODULE: ./src/components/AttachmentsForm/AttachmentsForm.vue + 3 modules
var AttachmentsForm = __webpack_require__(7605);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ReportForm/ReportForm.ts?vue&type=script&lang=ts&external








var ReportForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ReportForm, _super);
    function ReportForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        _this.contacts = [];
        _this.report = {
            recipients: [],
            attachments: [],
            add_attachments: [],
            remove_attachments: []
        };
        return _this;
    }
    Object.defineProperty(ReportForm.prototype, "modalTitle", {
        get: function () {
            return this.$t('communication.report.' + (this.report.id ? 'editTitle' : 'newTitle'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReportForm.prototype, "formAction", {
        get: function () {
            var url = '/communication/report';
            if (this.report.id) {
                url += '/' + this.report.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReportForm.prototype, "formDatas", {
        get: function () {
            var _a, _b, _c;
            var value = this.report;
            var datas = {
                type: value.type_id,
                date: value.date,
                subject: (_a = value.subject) !== null && _a !== void 0 ? _a : null,
                content: (_b = value.content) !== null && _b !== void 0 ? _b : null,
                recipients: value.recipients.map(function (recipient) {
                    if (!recipient.type) {
                        return recipient.label;
                    }
                    return {
                        type: recipient.type,
                        id: recipient.id
                    };
                }),
                is_reminder: (_c = value.is_reminder) !== null && _c !== void 0 ? _c : false
            };
            if (value.add_attachments.length > 0) {
                datas.add_attachments = value.add_attachments.map(function (file) { return file.id; });
            }
            if (value.remove_attachments.length > 0) {
                datas.remove_attachments = value.remove_attachments.map(function (file) { return file.id; });
            }
            if (this.elements) {
                datas.elements = this.elements.map(function (element) { return ({
                    type: element.type,
                    id: element.id
                }); });
            }
            if (this.customer) {
                datas.customer = this.customer.id;
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReportForm.prototype, "recipientsOptions", {
        get: function () {
            var recipients = [];
            var customer = this.customer;
            if (customer) {
                recipients.push({
                    label: this.$t('communication.report.form.customer'),
                    disabled: true
                });
                recipients.push({
                    label: customer.name,
                    type: 'customer',
                    id: customer.id,
                    data: customer
                });
                this.contacts.forEach(function (contact) {
                    recipients.push({
                        label: contact.fullname,
                        type: 'contact',
                        id: contact.id,
                        data: contact
                    });
                });
            }
            else if (this.contact) {
                recipients.push({
                    label: this.$t('communication.report.form.contact'),
                    disabled: true
                });
                recipients.push({
                    label: this.contact.fullname,
                    type: 'contact',
                    id: this.contact.id,
                    data: this.contact
                });
            }
            recipients.push({
                label: this.$t('communication.report.form.user'),
                disabled: true
            });
            this.activeTeamUsers.forEach(function (teamUser) {
                recipients.push({
                    label: teamUser.fullname,
                    type: 'teamUser',
                    id: teamUser.id,
                    data: teamUser
                });
            });
            return recipients;
        },
        enumerable: false,
        configurable: true
    });
    ReportForm.prototype.watchValue = function (report) {
        var _a;
        if (report) {
            this.report = Object.assign({
                add_attachments: [],
                remove_attachments: []
            }, JSON.parse(JSON.stringify(report)));
            return;
        }
        var recipients = [];
        if (this.contact) {
            recipients.push({
                type: 'contact',
                label: this.contact.fullname,
                id: this.contact.id,
                data: this.contact
            });
        }
        else if (this.customer) {
            recipients.push({
                type: 'customer',
                label: this.customer.name,
                id: this.customer.id,
                data: this.customer
            });
        }
        recipients.push({
            type: 'teamUser',
            label: this.teamUser.fullname,
            id: this.teamUser.id,
            data: this.teamUser
        });
        this.report = {
            type_id: ((_a = this.reportTypes.find(function (report) { return report.use_default; })) !== null && _a !== void 0 ? _a : this.reportTypes[0]).id,
            date: external_moment_default()().format('YYYY-MM-DD HH:mm:ss'),
            recipients: recipients,
            attachments: [],
            add_attachments: [],
            remove_attachments: []
        };
    };
    ReportForm.prototype.watchModalState = function (state) {
        this.modal = state;
    };
    ReportForm.prototype.watchModal = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.modal) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadReportTypes()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.watchCustomer(this.customer)];
                    case 3:
                        _a.sent();
                        this.watchValue(this.value);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReportForm.prototype.reportUpdated = function (report) {
        if (this.value && this.value.id) {
            interface_vue_.emitter.emit('reportUpdated', {
                old: JSON.parse(JSON.stringify(this.report)),
                new: report
            });
        }
        else {
            interface_vue_.emitter.emit('reportCreated', report);
        }
        this.watchValue(report);
        return report;
    };
    ReportForm.prototype.submitComplete = function (response) {
        this.reportUpdated(response.data);
    };
    ReportForm.prototype.watchCustomer = function (customer) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!customer || !this.modal) {
                            return [2 /*return*/];
                        }
                        if (!customer.contacts) return [3 /*break*/, 1];
                        this.contacts = Array.from(customer.contacts);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.loadContacts()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReportForm.prototype.loadContacts = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.$kwCommunication.axios.get('/customer/contact', {
                            params: {
                                per_page: 500,
                                sort: 'fullname',
                                filter: {
                                    with_customer: (_a = this.customer) === null || _a === void 0 ? void 0 : _a.id
                                }
                            }
                        })
                            .then(function (response) {
                            _this.contacts = response.data.data;
                        })
                            .catch(function (error) {
                            throw new Error(error);
                        })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ReportForm.prototype, "elements", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: false })
    ], ReportForm.prototype, "modalState", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportForm.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportForm.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportForm.prototype, "preload", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value')
    ], ReportForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState', { immediate: true })
    ], ReportForm.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ReportForm.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], ReportForm.prototype, "reportUpdated", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('customer', { immediate: true })
    ], ReportForm.prototype, "watchCustomer", null);
    ReportForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AttachmentsForm: AttachmentsForm/* default */.A,
                FormModal: interface_vue_.FormModal,
                BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormEditor: form_vue_.KFormEditor, KFormDatetime: form_vue_.KFormDatetime, KFormSelect: form_vue_.KFormSelect
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('globalDatas', ['activeTeamUsers'])), (0,external_vuex_.mapGetters)('user', ['teamUser'])), (0,external_vuex_.mapState)('communication', ['reportTypes'])),
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])), (0,external_vuex_.mapActions)('communication', ['loadReportTypes']))
        })
    ], ReportForm);
    return ReportForm;
}(lib/* Vue */.lD));
/* harmony default export */ var ReportFormvue_type_script_lang_ts_external = (ReportForm);

;// ./src/components/ReportForm/ReportForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ReportForm_ReportFormvue_type_script_lang_ts_external = (ReportFormvue_type_script_lang_ts_external); 
;// ./src/components/ReportForm/ReportForm.vue





/* normalize component */
;
var ReportForm_component = (0,componentNormalizer/* default */.A)(
  ReportForm_ReportFormvue_type_script_lang_ts_external,
  ReportFormvue_type_template_id_66b8e065_render,
  ReportFormvue_type_template_id_66b8e065_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReportForm_ReportForm = (ReportForm_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReportDelete/ReportDelete.vue?vue&type=template&id=571ef5fe
var ReportDeletevue_type_template_id_571ef5fe_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.$t('communication.report.deleteMsg')))])]],2)],1)
}
var ReportDeletevue_type_template_id_571ef5fe_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ReportDelete/ReportDelete.ts?vue&type=script&lang=ts&external




var ReportDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ReportDelete, _super);
    function ReportDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(ReportDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReportDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    ReportDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    ReportDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    ReportDelete.prototype.process = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.delete('/communication/report/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.deleted();
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    ReportDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    ReportDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('reportDeleted', this.value);
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ReportDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ReportDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ReportDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ReportDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], ReportDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], ReportDelete.prototype, "watchModalState", null);
    ReportDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], ReportDelete);
    return ReportDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var ReportDeletevue_type_script_lang_ts_external = (ReportDelete);

;// ./src/components/ReportDelete/ReportDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ReportDelete_ReportDeletevue_type_script_lang_ts_external = (ReportDeletevue_type_script_lang_ts_external); 
;// ./src/components/ReportDelete/ReportDelete.vue





/* normalize component */
;
var ReportDelete_component = (0,componentNormalizer/* default */.A)(
  ReportDelete_ReportDeletevue_type_script_lang_ts_external,
  ReportDeletevue_type_template_id_571ef5fe_render,
  ReportDeletevue_type_template_id_571ef5fe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReportDelete_ReportDelete = (ReportDelete_component.exports);
;// ./src/fetchDatas/report.ts


var reportRelations = [
    'customer', 'recipients', 'elements', 'attachments', 'recipients.data', 'userHistoric', 'type'
];
var needFetchReport = function (model) {
    return !reportRelations.every(function (relation) { return relation in model; });
};
var fetchReport = function (id) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, external_vue_default().prototype.$kwCommunication.axios.get('/communication/report/' + id, {
                    params: {
                        include: reportRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ReportItem/ReportItem.ts?vue&type=script&lang=ts&external









var ReportItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ReportItem, _super);
    function ReportItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.report = null;
        _this.editModalState = false;
        _this.deleteModalState = false;
        return _this;
    }
    ReportItem.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, fetchReport(this.value.id)];
                    case 1:
                        _a.report = _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportItem.prototype.modalHidden = function () {
        this.deleteModalState = false;
        this.$emit('hidden');
    };
    ReportItem.prototype.deleted = function () {
        this.modalHidden();
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ReportItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ReportItem.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], ReportItem.prototype, "watchValue", null);
    ReportItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BRow: external_bootstrap_vue_.BRow, BBadge: external_bootstrap_vue_.BBadge, BCol: external_bootstrap_vue_.BCol, BModal: external_bootstrap_vue_.BModal, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup,
                FroalaView: form_vue_.FroalaView, TextareaView: interface_vue_.TextareaView,
                Spinner: interface_vue_.Spinner,
                Attachments: Attachments/* default */.A,
                ReportForm: ReportForm_ReportForm,
                ReportDelete: ReportDelete_ReportDelete
            }
        })
    ], ReportItem);
    return ReportItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var ReportItemvue_type_script_lang_ts_external = (ReportItem);

;// ./src/components/ReportItem/ReportItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ReportItem_ReportItemvue_type_script_lang_ts_external = (ReportItemvue_type_script_lang_ts_external); 
;// ./src/components/ReportItem/ReportItem.vue





/* normalize component */
;
var ReportItem_component = (0,componentNormalizer/* default */.A)(
  ReportItem_ReportItemvue_type_script_lang_ts_external,
  ReportItemvue_type_template_id_1e476026_render,
  ReportItemvue_type_template_id_1e476026_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReportItem_ReportItem = (ReportItem_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LetterItem/LetterItem.vue?vue&type=template&id=515c0c38
var LetterItemvue_type_template_id_515c0c38_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline-block"},[(!_vm.deleteModalState && !_vm.editModalState)?_c('b-modal',{ref:"modal",attrs:{"visible":_vm.modal,"size":"lg","body-class":{
    'pb-0': _vm.value.attachments && _vm.value.attachments.length > 0
    },"scrollable":""},on:{"hidden":_vm.modalHidden},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ close }){return [_c('b-button',{on:{"click":function($event){$event.preventDefault();_vm.deleteModalState = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();_vm.editModalState = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.edit'))+" ")]),_c('div',{staticClass:"modal-footer-separator"}),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.preventDefault();return close.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.close'))+" ")])]}}],null,false,1723715989)},[(_vm.loading)?_c('Spinner'):[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.form.date'),"label-cols":"auto","label-class":"pt-0"}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.date))+" ")])],1),_c('b-col',{attrs:{"cols":"12","md":"auto"}},[_c('b-overlay',{attrs:{"show":_vm.loadingDownload}},[_c('b-button',{staticClass:"mb-2 mt-md-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.download'))+" ")])],1)],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.form.address')}},[_c('TextareaView',{model:{value:(_vm.value.address),callback:function ($$v) {_vm.$set(_vm.value, "address", $$v)},expression:"value.address"}})],1),(_vm.value.send_ar)?_c('p',{staticClass:"font-weight-bold text-danger"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.form.withAr'))+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.form.subject')}},[_c('p',{staticClass:"communication-wrapper"},[(_vm.value.subject === null)?_c('span',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.emptySubject'))+" ")]):[_vm._v(" "+_vm._s(_vm.value.subject)+" ")]],2)]),_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.form.content')}},[(_vm.value.content === null)?_c('p',{staticClass:"text-muted communication-wrapper"},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.emptyContent'))+" ")]):_c('FroalaView',{staticClass:"communication-wrapper",model:{value:(_vm.value.content),callback:function ($$v) {_vm.$set(_vm.value, "content", $$v)},expression:"value.content"}})],1),(_vm.value.attachments && _vm.value.attachments.length > 0)?_c('Attachments',{staticClass:"mt-4",attrs:{"attachments":_vm.value.attachments,"noDelete":""}}):_vm._e()]],2):_vm._e(),_c('LetterForm',{attrs:{"modalState":_vm.editModalState,"customer":_vm.value.customer,"contact":_vm.value.contact,"elements":_vm.value.elements},on:{"hidden":function($event){_vm.editModalState = false; _vm.modalHidden()},"submitComplete":letter => _vm.$emit('input', letter)},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('LetterDelete',{attrs:{"element":"modal","modal":_vm.deleteModalState},on:{"deleted":_vm.deleted,"closed":function($event){_vm.deleteModalState = false}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var LetterItemvue_type_template_id_515c0c38_staticRenderFns = []


;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LetterDelete/LetterDelete.vue?vue&type=template&id=7f53055d
var LetterDeletevue_type_template_id_7f53055d_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.$t('communication.letter.deleteMsg')))])]],2)],1)
}
var LetterDeletevue_type_template_id_7f53055d_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LetterDelete/LetterDelete.ts?vue&type=script&lang=ts&external




var LetterDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LetterDelete, _super);
    function LetterDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(LetterDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LetterDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    LetterDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    LetterDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    LetterDelete.prototype.process = function (event) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.delete('/communication/letter/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.deleted();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                                _this.modalState = false;
                                _this.closeModal();
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LetterDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    LetterDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    LetterDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('letterDeleted', this.value);
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LetterDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], LetterDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], LetterDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], LetterDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], LetterDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], LetterDelete.prototype, "watchModalState", null);
    LetterDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            }
        })
    ], LetterDelete);
    return LetterDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var LetterDeletevue_type_script_lang_ts_external = (LetterDelete);

;// ./src/components/LetterDelete/LetterDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LetterDelete_LetterDeletevue_type_script_lang_ts_external = (LetterDeletevue_type_script_lang_ts_external); 
;// ./src/components/LetterDelete/LetterDelete.vue





/* normalize component */
;
var LetterDelete_component = (0,componentNormalizer/* default */.A)(
  LetterDelete_LetterDeletevue_type_script_lang_ts_external,
  LetterDeletevue_type_template_id_7f53055d_render,
  LetterDeletevue_type_template_id_7f53055d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LetterDelete_LetterDelete = (LetterDelete_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LetterForm/LetterForm.vue?vue&type=template&id=576bce01
var LetterFormvue_type_template_id_576bce01_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"size":!_vm.waitLetterGeneration ? 'lg' : null,"title":_vm.modalTitle,"body-class":{
    'pb-0': !_vm.waitLetterGeneration,
    'text-center': _vm.waitLetterGeneration
  },"ok-only":_vm.waitLetterGeneration,"ok-title":_vm.$t('interface.' + (_vm.waitLetterGeneration ? 'close' : 'save')),"scrollable":"","closeOnSubmit":false},on:{"hidden":_vm.hideModal},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[(!_vm.waitLetterGeneration)?_c('k-form',{attrs:{"action":_vm.formAction,"method":"post","value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.form.date')}},[_c('k-form-datepicker',{staticStyle:{"max-width":"200px"},attrs:{"name":"date","required":""},model:{value:(_vm.letter.date),callback:function ($$v) {_vm.$set(_vm.letter, "date", $$v)},expression:"letter.date"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.models.selectLabel')}},[_c('ModelSelect',{attrs:{"placeholder":_vm.$t('communication.models.selectPlaceholder'),"size":"sm","clearOnSelect":""},on:{"selected":_vm.applyModel}})],1)],1)],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.form.address')}},[(_vm.customer)?_c('CustomerAddressSelect',{staticClass:"mb-1",attrs:{"customer":_vm.customer,"size":"sm","clearOnSelect":"","placeholder":_vm.$t('communication.letter.form.selectAddressPlaceholder'),"label":null},on:{"input":_vm.onSelectAddress}}):_vm._e(),_c('k-form-textarea',{attrs:{"name":"address","rows":"4"},model:{value:(_vm.letter.address),callback:function ($$v) {_vm.$set(_vm.letter, "address", $$v)},expression:"letter.address"}})],1)],1),_c('b-col',{staticClass:"pt-0 pt-md-5",attrs:{"cols":"12","md":"6"}},[(_vm.customer)?_c('ContactSelect',{staticClass:"mt-2",attrs:{"customer":_vm.customer,"size":"sm"},on:{"input":_vm.generateAddress},model:{value:(_vm.letter.contact),callback:function ($$v) {_vm.$set(_vm.letter, "contact", $$v)},expression:"letter.contact"}}):_vm._e(),_c('b-form-checkbox',{staticClass:"mt-2 mb-2",model:{value:(_vm.letter.send_ar),callback:function ($$v) {_vm.$set(_vm.letter, "send_ar", $$v)},expression:"letter.send_ar"}},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.form.withAr'))+" ")])],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.form.subject')}},[_c('k-form-input',{attrs:{"name":"subject"},model:{value:(_vm.letter.subject),callback:function ($$v) {_vm.$set(_vm.letter, "subject", $$v)},expression:"letter.subject"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.letter.form.content')}},[_c('k-form-editor',{attrs:{"name":"content","size":"sm","config":_vm.editorConfig},model:{value:(_vm.letter.content),callback:function ($$v) {_vm.$set(_vm.letter, "content", $$v)},expression:"letter.content"}})],1),_c('AttachmentsForm',{attrs:{"url":_vm.formAction,"value":_vm.letter,"datas":_vm.formDatas},on:{"input":_vm.letterUpdated}})],1):_c('div',[(_vm.letter.document_status === 0 || _vm.letter.document_status === 1)?_c('div',[_c('Spinner',{staticClass:"pt-0",attrs:{"size":"2"}}),_vm._v(" "+_vm._s(_vm.$t('communication.letter.form.inGeneration'))+" ")],1):(_vm.letter.document_status === 2)?_c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('communication.letter.form.generated'))+" ")]),_c('b-overlay',{attrs:{"show":_vm.loadingDownload}},[_c('b-button',{staticClass:"my-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.download'))+" ")])],1)],1):_c('div',[_vm._v(" "+_vm._s(_vm.$t('communication.letter.form.generatingError'))+" ")])]),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.yes'),"cancel-title":_vm.$t('interface.no')},on:{"ok":function($event){return _vm.applyModel(_vm.usedModel)}},model:{value:(_vm.askApplyModel),callback:function ($$v) {_vm.askApplyModel=$$v},expression:"askApplyModel"}},[_vm._v(" "+_vm._s(_vm.$t('communication.letter.form.contactUpdated'))+" ")])],1)
}
var LetterFormvue_type_template_id_576bce01_staticRenderFns = []


;// external "@kwixeo/customers-vue"
var customers_vue_namespaceObject = require("@kwixeo/customers-vue");
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ModelSelect/ModelSelect.vue?vue&type=template&id=6c3617a5
var ModelSelectvue_type_template_id_6c3617a5_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form-select',{attrs:{"options":_vm.models,"label":"name","clearable":_vm.clearable !== false,"placeholder":_vm.placeholder,"size":_vm.size},on:{"input":_vm.onSelect},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var ModelSelectvue_type_template_id_6c3617a5_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ModelSelect/ModelSelect.ts?vue&type=script&lang=ts&external




var ModelSelect = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ModelSelect, _super);
    function ModelSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selected = null;
        return _this;
    }
    ModelSelect.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadModels()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ModelSelect.prototype.onSelect = function (model) {
        var _this = this;
        if (this.clearOnSelect !== false) {
            this.$nextTick(function () {
                _this.selected = null;
            });
        }
        return model;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ModelSelect.prototype, "clearable", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ModelSelect.prototype, "clearOnSelect", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ModelSelect.prototype, "placeholder", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ModelSelect.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('selected')
    ], ModelSelect.prototype, "onSelect", null);
    ModelSelect = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['loadModels'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('communication', ['models'])),
            components: {
                KFormSelect: form_vue_.KFormSelect
            }
        })
    ], ModelSelect);
    return ModelSelect;
}(lib/* Vue */.lD));
/* harmony default export */ var ModelSelectvue_type_script_lang_ts_external = (ModelSelect);

;// ./src/components/ModelSelect/ModelSelect.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ModelSelect_ModelSelectvue_type_script_lang_ts_external = (ModelSelectvue_type_script_lang_ts_external); 
;// ./src/components/ModelSelect/ModelSelect.vue





/* normalize component */
;
var ModelSelect_component = (0,componentNormalizer/* default */.A)(
  ModelSelect_ModelSelectvue_type_script_lang_ts_external,
  ModelSelectvue_type_template_id_6c3617a5_render,
  ModelSelectvue_type_template_id_6c3617a5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ModelSelect_ModelSelect = (ModelSelect_component.exports);
;// ./src/components/LetterForm/editorConfig.ts
var config = {
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'fontSize',
                '|',
                'formatOL',
                '|',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify'
            ],
            buttonsVisible: 17
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: [],
            align: 'right',
            buttonsVisible: 0
        }
    },
    tableEditButtons: [
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableBorder',
        'tableBackground',
        '-',
        'tableCells',
        'tableCellBackground',
        'tableCellBorder',
        'tableCellHorizontalAlign'
    ],
    imageUpload: true,
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    imageMaxSize: 5 * 1024 * 1024,
    imageUploadMethod: 'POST',
    imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageManager'],
    imageDefaultDisplay: 'inline',
    imageEditButtons: ['imageReplace', 'imageRemove', 'imageSize'],
    imageManagerToggleTags: false,
    requestHeaders: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + ({"NODE_ENV":"production","VUE_APP_HERE_API_KEY":"23z1ejZ9DwiGvj9aAxpscJ_yr-et9lqeAeZKxgWynL4","VUE_APP_API_URL":"http://127.0.0.1:8000/api","VUE_APP_PUSHER_APP_KEY":"e4637479ee4cb1334e35271b32f57f72","VUE_APP_PUSHER_HOST":"socket.kwixeo.fr","VUE_APP_PUSHER_PORT":"6002","BASE_URL":"/"}).VUE_APP_BEARER_TOKEN
    },
    requestWithCredentials: true,
    requestWithCORS: false,
    imageCORSProxy: false
};
/* harmony default export */ var editorConfig = (config);

;// ./src/mixins/LetterDownloadMixin.ts



var LetterDownloadMixin = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LetterDownloadMixin, _super);
    function LetterDownloadMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingDownload = false;
        return _this;
    }
    LetterDownloadMixin.prototype.loadLetterFile = function (letterId) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loadingDownload = true;
                return [2 /*return*/, this.$kwCommunication.axios.get('/communication/letter/' + letterId + '/download')
                        .then(function (response) {
                        return response.data;
                    })
                        .finally(function () {
                        _this.loadingDownload = false;
                    })];
            });
        });
    };
    LetterDownloadMixin.prototype.downloadLetter = function (letter) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var file;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadLetterFile(letter.id)];
                    case 1:
                        file = _a.sent();
                        this.downloadFile(file.content, file.filename);
                        return [2 /*return*/];
                }
            });
        });
    };
    LetterDownloadMixin = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], LetterDownloadMixin);
    return LetterDownloadMixin;
}((0,lib/* Mixins */.Xe)(interface_vue_.FileMixin)));
/* harmony default export */ var mixins_LetterDownloadMixin = (LetterDownloadMixin);

// EXTERNAL MODULE: ./src/mixins/VariablesMixin.ts
var VariablesMixin = __webpack_require__(3717);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LetterForm/LetterForm.ts?vue&type=script&lang=ts&external













var LetterForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LetterForm, _super);
    function LetterForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        _this.selectedAddress = {};
        _this.waitLetterGeneration = false;
        _this.timeoutLetterGeneration = null;
        _this.editorConfig = editorConfig;
        _this.usedModel = null;
        _this.askApplyModel = false;
        _this.letter = {
            contact: null,
            send_ar: false,
            add_attachments: [],
            remove_attachments: []
        };
        return _this;
    }
    LetterForm.prototype.mounted = function () {
        if (this.preload && !this.value && this.teamConfigs['communication_model_' + this.preload]) {
            this.applyModel(this.teamConfigs['communication_model_' + this.preload]);
        }
    };
    LetterForm.prototype.destroyed = function () {
        this.clearTimeout();
    };
    Object.defineProperty(LetterForm.prototype, "modalTitle", {
        get: function () {
            if (this.waitLetterGeneration) {
                return null;
            }
            return this.$t('communication.letter.' + (this.letter.id ? 'editTitle' : 'newTitle'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LetterForm.prototype, "formAction", {
        get: function () {
            var url = '/communication/letter';
            if (this.letter.id) {
                url += '/' + this.letter.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LetterForm.prototype, "formDatas", {
        // Return form datas
        get: function () {
            var _a, _b, _c;
            var value = this.letter;
            var datas = {
                date: value.date,
                customer: this.customer ? this.customer.id : null,
                contact: this.contact ? this.contact.id : null,
                send_ar: Number(value.send_ar),
                address: value.address,
                subject: (_a = value.subject) !== null && _a !== void 0 ? _a : null,
                content: (_b = value.content) !== null && _b !== void 0 ? _b : null,
                elements: this.elements.map(function (element) { return ({
                    type: element.type,
                    id: element.id
                }); }),
                is_reminder: (_c = value.is_reminder) !== null && _c !== void 0 ? _c : false
            };
            if (value.attachments && value.attachments.length > 0) {
                datas.attachments = value.attachments.map(function (file) { return file.id; });
            }
            if (value.add_attachments.length > 0) {
                datas.add_attachments = value.add_attachments.map(function (file) { return file.id; });
            }
            if (value.remove_attachments.length > 0) {
                datas.remove_attachments = value.remove_attachments.map(function (file) { return file.id; });
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    LetterForm.prototype.watchMailTo = function (value, oldValue) {
        if (JSON.stringify(value) === JSON.stringify(oldValue)) {
            return;
        }
        if (this.usedModel && this.usedModel.html.includes('data-variable="CONTACT-')) {
            var content = this.getModelContents(this.usedModel);
            var clean = function (content) {
                if (!content) {
                    content = '';
                }
                content = content.replaceAll(/\n|\r/g, '')
                    .replaceAll(/<br \/>|<br\/>/g, '<br>')
                    .replaceAll('&nbsp;', ' ')
                    .replaceAll(/>\s+</g, '><');
                return content;
            };
            if (this.letter.subject !== content.subject || clean(this.letter.content) !== clean(content.content)) {
                this.askApplyModel = true;
            }
        }
    };
    LetterForm.prototype.watchValue = function (letter) {
        this.letter = Object.assign({
            date: external_moment_default()().format('YYYY-MM-DD'),
            contact: this.contact,
            send_ar: false,
            add_attachments: [],
            attachments: [],
            remove_attachments: []
        }, letter ? JSON.parse(JSON.stringify(letter)) : {});
        if (!letter) {
            this.generateAddress();
        }
    };
    LetterForm.prototype.watchModalState = function (state) {
        this.modal = state;
    };
    LetterForm.prototype.watchCustomer = function (customer) {
        var _a, _b;
        if (!customer || this.value !== null) {
            return;
        }
        this.selectedAddress = (_b = (_a = customer.address_invoice) !== null && _a !== void 0 ? _a : customer.address_delivery) !== null && _b !== void 0 ? _b : {};
        this.generateAddress();
    };
    LetterForm.prototype.watchContact = function (contact) {
        if (this.customer || !contact) {
            return;
        }
        this.selectedAddress = contact;
        this.generateAddress();
    };
    // Generate the address
    LetterForm.prototype.generateAddress = function () {
        var _a;
        var noEmpty = function (part) { return part !== '' && part !== undefined && part !== null; };
        var part = [];
        if (this.customer)
            part.push(this.customer.name);
        if (this.letter.contact)
            part.push(this.letter.contact.fullname);
        var address = this.selectedAddress;
        if (address) {
            part.push.apply(part, [
                address.road1,
                address.road2,
                address.road3,
                [address.postal_code, address.town].filter(noEmpty).join(' '),
                (_a = address.country) === null || _a === void 0 ? void 0 : _a.name
            ]);
        }
        lib/* Vue */.lD.set(this.letter, 'address', part.filter(noEmpty).join("\n"));
    };
    // Select an address
    LetterForm.prototype.onSelectAddress = function (address) {
        this.selectedAddress = address;
        this.generateAddress();
    };
    // Apply a model
    LetterForm.prototype.applyModel = function (model) {
        var _a;
        this.usedModel = model;
        var content = this.getModelContents(model);
        lib/* Vue */.lD.set(this.letter, 'subject', content.subject);
        lib/* Vue */.lD.set(this.letter, 'content', content.content);
        var attachments = (_a = model.attachments) !== null && _a !== void 0 ? _a : [];
        attachments.push.apply(attachments, model.library_files);
        lib/* Vue */.lD.set(this.letter, 'add_attachments', attachments);
    };
    // Return model datas
    LetterForm.prototype.getModelContents = function (model) {
        var _a, _b;
        return {
            content: this.replaceVariables(model.html, ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? this.value.elements : this.elements, this.letter.contact),
            subject: this.htmltoText(this.replaceVariables(model.subject, ((_b = this.value) === null || _b === void 0 ? void 0 : _b.id) ? this.value.elements : this.elements, this.letter.contact))
        };
    };
    // Letter is updated
    LetterForm.prototype.letterUpdated = function (letter) {
        if (this.value && this.value.id) {
            interface_vue_.emitter.emit('letterUpdated', {
                old: JSON.parse(JSON.stringify(this.letter)),
                new: letter
            });
        }
        else {
            interface_vue_.emitter.emit('letterCreated', letter);
        }
        this.watchValue(letter);
    };
    LetterForm.prototype.submitComplete = function (response) {
        var letter = response.data;
        this.letterUpdated(letter);
        this.letterGenerating();
        return letter;
    };
    // Initialize letter generating
    LetterForm.prototype.letterGenerating = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.waitLetterGeneration = true;
                if (this.letter.document_status !== undefined && this.letter.document_status < 2) {
                    this.timeoutLetterGeneration = setTimeout(this.reloadLetter, 2000);
                }
                return [2 /*return*/];
            });
        });
    };
    // Reload letter from server
    LetterForm.prototype.reloadLetter = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.$kwCommunication.axios.get('/communication/letter/' + ((_a = this.letter) === null || _a === void 0 ? void 0 : _a.id) + '?file=1')
                            .then(function (response) {
                            var letter = response.data;
                            _this.watchValue(letter);
                            _this.clearTimeout();
                            if (letter.document_status < 2) {
                                _this.timeoutLetterGeneration = setTimeout(_this.reloadLetter, 2000);
                            }
                        })
                            .catch(function (error) {
                            new Error(error);
                        })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LetterForm.prototype.download = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadLetter(this.letter)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Clear timeout for letter generating
    LetterForm.prototype.clearTimeout = function () {
        if (this.timeoutLetterGeneration) {
            clearTimeout(this.timeoutLetterGeneration);
        }
    };
    LetterForm.prototype.hideModal = function () {
        this.waitLetterGeneration = false;
        this.clearTimeout();
        this.$emit('hidden');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LetterForm.prototype, "elements", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true, default: false })
    ], LetterForm.prototype, "modalState", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterForm.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterForm.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterForm.prototype, "preload", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('letter.contact')
    ], LetterForm.prototype, "watchMailTo", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], LetterForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState', { immediate: true })
    ], LetterForm.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('customer', { immediate: true })
    ], LetterForm.prototype, "watchCustomer", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('contact', { immediate: true })
    ], LetterForm.prototype, "watchContact", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitComplete')
    ], LetterForm.prototype, "submitComplete", null);
    LetterForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs'])),
            components: {
                AttachmentsForm: AttachmentsForm/* default */.A,
                ModelSelect: ModelSelect_ModelSelect,
                FormModal: interface_vue_.FormModal, Spinner: interface_vue_.Spinner,
                CustomerAddressSelect: customers_vue_namespaceObject.CustomerAddressSelect, ContactSelect: customers_vue_namespaceObject.ContactSelect,
                BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormCheckbox: external_bootstrap_vue_.BFormCheckbox, BButton: external_bootstrap_vue_.BButton, BOverlay: external_bootstrap_vue_.BOverlay,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormEditor: form_vue_.KFormEditor, KFormDatepicker: form_vue_.KFormDatepicker, KFormTextarea: form_vue_.KFormTextarea, KFormSelect: form_vue_.KFormSelect
            }
        })
    ], LetterForm);
    return LetterForm;
}((0,lib/* Mixins */.Xe)(VariablesMixin/* default */.A, mixins_LetterDownloadMixin)));
/* harmony default export */ var LetterFormvue_type_script_lang_ts_external = (LetterForm);

;// ./src/components/LetterForm/LetterForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LetterForm_LetterFormvue_type_script_lang_ts_external = (LetterFormvue_type_script_lang_ts_external); 
;// ./src/components/LetterForm/LetterForm.vue





/* normalize component */
;
var LetterForm_component = (0,componentNormalizer/* default */.A)(
  LetterForm_LetterFormvue_type_script_lang_ts_external,
  LetterFormvue_type_template_id_576bce01_render,
  LetterFormvue_type_template_id_576bce01_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LetterForm_LetterForm = (LetterForm_component.exports);
;// ./src/fetchDatas/letter.ts


var letterRelations = [
    'customer', 'contact', 'elements', 'attachments'
];
var needFetchLetter = function (model) {
    return !letterRelations.every(function (relation) { return relation in model; });
};
var fetchLetter = function (id) { return (0,tslib_es6/* __awaiter */.sH)(void 0, void 0, Promise, function () {
    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, external_vue_default().prototype.$kwCommunication.axios.get('/communication/letter/' + id, {
                    params: {
                        include: letterRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LetterItem/LetterItem.ts?vue&type=script&lang=ts&external










var LetterItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LetterItem, _super);
    function LetterItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.letter = null;
        _this.editModalState = false;
        _this.deleteModalState = false;
        return _this;
    }
    LetterItem.prototype.watchValue = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _a;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, fetchLetter(this.value.id)];
                    case 1:
                        _a.letter = _b.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    LetterItem.prototype.download = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.downloadLetter(this.value);
                return [2 /*return*/];
            });
        });
    };
    LetterItem.prototype.modalHidden = function () {
        this.deleteModalState = false;
        this.$emit('hidden');
    };
    LetterItem.prototype.deleted = function () {
        this.modalHidden();
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LetterItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], LetterItem.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], LetterItem.prototype, "watchValue", null);
    LetterItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BRow: external_bootstrap_vue_.BRow,
                BCol: external_bootstrap_vue_.BCol,
                BModal: external_bootstrap_vue_.BModal,
                BButton: external_bootstrap_vue_.BButton,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                BOverlay: external_bootstrap_vue_.BOverlay,
                FroalaView: form_vue_.FroalaView,
                Attachments: Attachments/* default */.A,
                TextareaView: interface_vue_.TextareaView,
                LetterForm: LetterForm_LetterForm,
                LetterDelete: LetterDelete_LetterDelete,
                Spinner: interface_vue_.Spinner
            }
        })
    ], LetterItem);
    return LetterItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, mixins_LetterDownloadMixin)));
/* harmony default export */ var LetterItemvue_type_script_lang_ts_external = (LetterItem);

;// ./src/components/LetterItem/LetterItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LetterItem_LetterItemvue_type_script_lang_ts_external = (LetterItemvue_type_script_lang_ts_external); 
;// ./src/components/LetterItem/LetterItem.vue





/* normalize component */
;
var LetterItem_component = (0,componentNormalizer/* default */.A)(
  LetterItem_LetterItemvue_type_script_lang_ts_external,
  LetterItemvue_type_template_id_515c0c38_render,
  LetterItemvue_type_template_id_515c0c38_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LetterItem_LetterItem = (LetterItem_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReportFormButton/ReportFormButton.vue?vue&type=template&id=32f348fa
var ReportFormButtonvue_type_template_id_32f348fa_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();return _vm.openReportForm.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" "),_c('ReportForm',{attrs:{"elements":_vm.linkedElements,"value":_vm.value,"modalState":_vm.modal,"customer":_vm.customer,"contact":_vm.contact},on:{"hidden":function($event){_vm.modal = false},"submitComplete":report => _vm.$emit('submitComplete', report)}})],1)
}
var ReportFormButtonvue_type_template_id_32f348fa_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ReportFormButton/ReportFormButton.ts?vue&type=script&lang=ts&external




var ReportFormButton = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ReportFormButton, _super);
    function ReportFormButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        return _this;
    }
    Object.defineProperty(ReportFormButton.prototype, "buttonLabel", {
        get: function () {
            if (this.label) {
                return this.label;
            }
            return this.$t('interface.' + (this.value && this.value.id ? 'edit' : 'create'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ReportFormButton.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    ReportFormButton.prototype.openReportForm = function () {
        this.modal = true;
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], ReportFormButton.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportFormButton.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportFormButton.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportFormButton.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], ReportFormButton.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ReportFormButton.prototype, "linkedElements", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportFormButton.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportFormButton.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], ReportFormButton.prototype, "contact", void 0);
    ReportFormButton = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ReportForm: ReportForm_ReportForm
            }
        })
    ], ReportFormButton);
    return ReportFormButton;
}(lib/* Vue */.lD));
/* harmony default export */ var ReportFormButtonvue_type_script_lang_ts_external = (ReportFormButton);

;// ./src/components/ReportFormButton/ReportFormButton.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ReportFormButton_ReportFormButtonvue_type_script_lang_ts_external = (ReportFormButtonvue_type_script_lang_ts_external); 
;// ./src/components/ReportFormButton/ReportFormButton.vue





/* normalize component */
;
var ReportFormButton_component = (0,componentNormalizer/* default */.A)(
  ReportFormButton_ReportFormButtonvue_type_script_lang_ts_external,
  ReportFormButtonvue_type_template_id_32f348fa_render,
  ReportFormButtonvue_type_template_id_32f348fa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReportFormButton_ReportFormButton = (ReportFormButton_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LetterFormButton/LetterFormButton.vue?vue&type=template&id=75fe0424
var LetterFormButtonvue_type_template_id_75fe0424_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modal = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" "),_c('LetterForm',{attrs:{"elements":_vm.linkedElements,"value":_vm.value,"modalState":_vm.modal,"customer":_vm.customer,"contact":_vm.contact,"preload":_vm.preload},on:{"hidden":function($event){_vm.modal = false},"submitComplete":letter => _vm.$emit('submitComplete', letter)}})],1)
}
var LetterFormButtonvue_type_template_id_75fe0424_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LetterFormButton/LetterFormButton.ts?vue&type=script&lang=ts&external




var LetterFormButton = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LetterFormButton, _super);
    function LetterFormButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        return _this;
    }
    Object.defineProperty(LetterFormButton.prototype, "buttonLabel", {
        get: function () {
            if (this.label) {
                return this.label;
            }
            return this.$t('interface.' + (this.value && this.value.id ? 'edit' : 'create'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LetterFormButton.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
            }
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], LetterFormButton.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterFormButton.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterFormButton.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterFormButton.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], LetterFormButton.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], LetterFormButton.prototype, "linkedElements", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterFormButton.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterFormButton.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterFormButton.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], LetterFormButton.prototype, "preload", void 0);
    LetterFormButton = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                LetterForm: LetterForm_LetterForm
            }
        })
    ], LetterFormButton);
    return LetterFormButton;
}(lib/* Vue */.lD));
/* harmony default export */ var LetterFormButtonvue_type_script_lang_ts_external = (LetterFormButton);

;// ./src/components/LetterFormButton/LetterFormButton.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LetterFormButton_LetterFormButtonvue_type_script_lang_ts_external = (LetterFormButtonvue_type_script_lang_ts_external); 
;// ./src/components/LetterFormButton/LetterFormButton.vue





/* normalize component */
;
var LetterFormButton_component = (0,componentNormalizer/* default */.A)(
  LetterFormButton_LetterFormButtonvue_type_script_lang_ts_external,
  LetterFormButtonvue_type_template_id_75fe0424_render,
  LetterFormButtonvue_type_template_id_75fe0424_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LetterFormButton_LetterFormButton = (LetterFormButton_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AgregateDatas/AgregateDatas.ts?vue&type=script&lang=ts&external

















var AgregateDatas = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AgregateDatas, _super);
    function AgregateDatas() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.datas = [];
        _this.total = 0;
        _this.totals = {};
        _this.page = 0;
        _this.perPage = 50;
        _this.loading = false;
        _this.view = 'timeline';
        _this.forceState = null;
        _this.timeout = null;
        _this.newComment = false;
        _this.showEmail = null;
        _this.showReport = null;
        _this.showLetter = null;
        _this.filters = {
            team_users: [],
            begin: null,
            end: null
        };
        _this.state = {
            comment: true,
            task: true,
            file: true,
            historic: false,
            mail: true,
            report: true,
            letter: true,
            event: true
        };
        return _this;
    }
    Object.defineProperty(AgregateDatas.prototype, "nbFilters", {
        get: function () {
            var _a, _b;
            var number = (_b = (_a = this.filters.team_users) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
            if (this.filters.begin) {
                number++;
            }
            if (this.filters.end) {
                number++;
            }
            return number;
        },
        enumerable: false,
        configurable: true
    });
    AgregateDatas.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fetchState();
                        return [4 /*yield*/, this.loadDatas()];
                    case 1:
                        _a.sent();
                        interface_vue_.emitter.on('selectFiles-' + this.type + '-' + this.id, this.newFiles);
                        interface_vue_.emitter.on('taskCreated', this.taskAdded);
                        interface_vue_.emitter.on('taskUpdated', this.taskUpdated);
                        interface_vue_.emitter.on('taskDeleted', this.taskDeleted);
                        interface_vue_.emitter.on('letterCreated', this.letterAdded);
                        interface_vue_.emitter.on('letterUpdated', this.letterUpdated);
                        interface_vue_.emitter.on('letterDeleted', this.letterDeleted);
                        interface_vue_.emitter.on('reportCreated', this.reportAdded);
                        interface_vue_.emitter.on('reportUpdated', this.reportUpdated);
                        interface_vue_.emitter.on('reportDeleted', this.reportDeleted);
                        interface_vue_.emitter.on('mailSent', this.mailSent);
                        interface_vue_.emitter.on('mailCreated', this.mailAdded);
                        interface_vue_.emitter.on('mailUpdated', this.mailUpdated);
                        interface_vue_.emitter.on('mailDeleted', this.mailDeleted);
                        interface_vue_.emitter.on('eventCreated', this.eventAdded);
                        interface_vue_.emitter.on('eventUpdated', this.eventUpdated);
                        interface_vue_.emitter.on('eventDeleted', this.eventDeleted);
                        interface_vue_.emitter.on('fileCreated', this.fileAdded);
                        interface_vue_.emitter.on('fileUpdated', this.fileUpdated);
                        interface_vue_.emitter.on('fileDeleted', this.fileDeleted);
                        interface_vue_.emitter.on('commentCreated', this.commentAdded);
                        interface_vue_.emitter.on('commentUpdated', this.commentUpdated);
                        interface_vue_.emitter.on('commentDeleted', this.commentDeleted);
                        interface_vue_.emitter.on('historicCreated', this.historicAdded);
                        return [2 /*return*/];
                }
            });
        });
    };
    AgregateDatas.prototype.destroyed = function () {
        interface_vue_.emitter.off('selectFiles-' + this.type + '-' + this.id, this.newFiles);
        interface_vue_.emitter.off('taskCreated', this.taskAdded);
        interface_vue_.emitter.off('taskUpdated', this.taskUpdated);
        interface_vue_.emitter.off('taskDeleted', this.taskDeleted);
        interface_vue_.emitter.off('letterCreated', this.letterAdded);
        interface_vue_.emitter.off('letterUpdated', this.letterUpdated);
        interface_vue_.emitter.off('letterDeleted', this.letterDeleted);
        interface_vue_.emitter.off('reportCreated', this.reportAdded);
        interface_vue_.emitter.off('reportUpdated', this.reportUpdated);
        interface_vue_.emitter.off('reportDeleted', this.reportDeleted);
        interface_vue_.emitter.off('mailSent', this.mailSent);
        interface_vue_.emitter.off('mailCreated', this.mailAdded);
        interface_vue_.emitter.off('mailUpdated', this.mailUpdated);
        interface_vue_.emitter.off('mailDeleted', this.mailDeleted);
        interface_vue_.emitter.off('eventCreated', this.eventAdded);
        interface_vue_.emitter.off('eventUpdated', this.eventUpdated);
        interface_vue_.emitter.off('eventDeleted', this.eventDeleted);
        interface_vue_.emitter.off('fileCreated', this.fileAdded);
        interface_vue_.emitter.off('fileUpdated', this.fileUpdated);
        interface_vue_.emitter.off('fileDeleted', this.fileDeleted);
        interface_vue_.emitter.off('commentCreated', this.commentAdded);
        interface_vue_.emitter.off('commentUpdated', this.commentUpdated);
        interface_vue_.emitter.off('commentDeleted', this.commentDeleted);
        interface_vue_.emitter.off('historicCreated', this.historicAdded);
    };
    Object.defineProperty(AgregateDatas.prototype, "addElementMenu", {
        get: function () {
            var _this = this;
            var menu = [];
            menu.push.apply(menu, [
                {
                    component: external_bootstrap_vue_.BDropdownItem,
                    label: this.$t('agregateDatas.file'),
                    events: {
                        click: this.newFiles
                    }
                },
                {
                    component: external_bootstrap_vue_.BDropdownItem,
                    label: this.$t('agregateDatas.comment'),
                    events: {
                        click: function () { return _this.newComment = true; }
                    }
                }
            ]);
            if (this.hasModule('task') && this.can('task', 1)) {
                menu.push({
                    component: external_bootstrap_vue_.BDropdownItem,
                    label: this.$t('agregateDatas.task'),
                    events: {
                        click: this.newTask
                    }
                });
            }
            if (this.can('send-mail', 1)) {
                menu.push({
                    component: SendEmailButton_SendEmailButton,
                    attributes: {
                        customer: this.type === 'customer' ? this.model : this.customer,
                        contact: this.contact,
                        element: 'dropdown',
                        linkedElements: this.computedLinkedElements(),
                        attachments: this.attachments,
                        preload: this.preload
                    }
                });
            }
            if (this.hasModule('calendar') && this.can('calendar', 1)) {
                menu.push({
                    component: calendars_vue_namespaceObject.CalendarButton,
                    attributes: {
                        element: 'dropdown',
                        linkedElements: this.computedLinkedElements(),
                    }
                });
            }
            if (this.hasModule('communication-reports') && this.can('communication-reports', 1)) {
                menu.push({
                    component: ReportFormButton_ReportFormButton,
                    attributes: {
                        linkedElements: this.computedLinkedElements(),
                        element: 'dropdown',
                        label: this.$t('agregateDatas.report'),
                        customer: this.customer,
                        contact: this.contact
                    }
                });
            }
            if (this.hasModule('communication-letters') && this.can('communication-letters', 1)) {
                menu.push({
                    component: LetterFormButton_LetterFormButton,
                    attributes: {
                        linkedElements: this.computedLinkedElements(),
                        element: 'dropdown',
                        label: this.$t('agregateDatas.letter'),
                        customer: this.customer,
                        contact: this.contact,
                        preload: this.preload
                    }
                });
            }
            return menu;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "computedLinkedElements", {
        get: function () {
            var _this = this;
            return function (includeCustomer) {
                var _a;
                if (includeCustomer === void 0) { includeCustomer = false; }
                var elements = (_a = _this.linkedElements) !== null && _a !== void 0 ? _a : [];
                if (!elements.find(function (el) { return el.type === _this.type && el.id === _this.id; })) {
                    // Include concerned element if not present in linked elements
                    elements.push({
                        type: _this.type,
                        id: _this.id,
                        title: _this.modelTitle,
                        data: _this.model
                    });
                }
                if (includeCustomer) {
                    if (_this.type !== 'customer' && _this.customer) {
                        elements.push({
                            title: _this.customer.name,
                            type: 'customer',
                            id: _this.customer.id,
                            data: _this.customer,
                        });
                    }
                    if (_this.type !== 'contact' && _this.contact) {
                        elements.push({
                            title: _this.contact.fullname,
                            type: 'contact',
                            id: _this.contact.id,
                            data: _this.contact,
                        });
                    }
                }
                return elements;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "haveMoreDatas", {
        // If more datas can be loaded from server
        get: function () {
            return this.datas.length < this.total || this.page === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "isSelected", {
        // If a type is selected for display
        get: function () {
            var _this = this;
            return function (type) { return (_this.state[type] && _this.forceState === null) || _this.forceState === type; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "showOnlyFiles", {
        // If the view must show only the files
        get: function () {
            var state = this.state;
            return this.forceState === 'file' || (state.file && !state.comment && !state.task && !state.historic && !state.mail && !state.report);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "buttonTitle", {
        // Return the tooltip text for buttons
        get: function () {
            var _this = this;
            return function (type) {
                if (_this.forceState !== null) {
                    return null;
                }
                return _this.state[type] ? 'Masquer' : 'Afficher';
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "noDatas", {
        // If no datas to show
        get: function () {
            return (0,external_lodash_namespaceObject.isEmpty)(this.groupedDatas);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "withTime", {
        get: function () {
            return function (data) {
                var _a;
                return data.type !== 'letter' && (data.type !== 'task' || data.type === 'task' && ((_a = data.date) === null || _a === void 0 ? void 0 : _a.substr(11, 9)) !== '00:00:00');
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "groupedDatas", {
        // Return datas grouped by dates
        get: function () {
            var _this = this;
            return (0,external_lodash_namespaceObject.groupBy)(this.datas.filter(function (data) {
                return _this.isSelected(data.type === 'paymentLink' ? 'mail' : data.type);
            }).sort(function (a, b) {
                var aDate = (0,interface_vue_.moment)(_this.withTime(a) ? a.date : a.date.replace('00:00:00', '23:59:59'));
                var bDate = (0,interface_vue_.moment)(_this.withTime(b) ? b.date : b.date.replace('00:00:00', '23:59:59'));
                if (aDate.isAfter(bDate))
                    return -1;
                else if (aDate.isBefore(bDate))
                    return 1;
                else
                    return 0;
            }), function (data) { return (0,interface_vue_.moment)(data.date).format('YYYY-MM-DD'); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "isExpired", {
        get: function () {
            return function (datetime) { return (0,interface_vue_.moment)(datetime).isBefore(); };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AgregateDatas.prototype, "files", {
        // Return the files
        get: function () {
            return this.datas.filter(function (data) { return data.type === 'file'; });
        },
        enumerable: false,
        configurable: true
    });
    AgregateDatas.prototype.teamUserAvatar = function (teamUser) {
        var value = this.teamUsers.find(function (val) { return val.id === teamUser.id; });
        return value && value.avatar ? 'data:image.png;base64,' + value.avatar.file : null;
    };
    AgregateDatas.prototype.watchFilters = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(this.processFilters, 800);
                this.saveState();
                return [2 /*return*/];
            });
        });
    };
    AgregateDatas.prototype.processFilters = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.page = 0;
                        this.datas = [];
                        return [4 /*yield*/, this.loadDatas()];
                    case 1:
                        _a.sent();
                        this.timeout = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    AgregateDatas.prototype.teamUserFilter = function () {
        var _this = this;
        setTimeout(function () {
            _this.$refs['filter-dropdown'].show();
        }, 10);
    };
    AgregateDatas.prototype.clearFilters = function () {
        this.filters = {
            team_users: [],
            begin: null,
            end: null
        };
    };
    // Load the datas
    AgregateDatas.prototype.loadDatas = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var url;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.haveMoreDatas) {
                            return [2 /*return*/];
                        }
                        this.page++;
                        this.loading = true;
                        url = (_a = this.url) !== null && _a !== void 0 ? _a : ('/' + this.type + '/' + this.id + '/agregate-datas');
                        return [4 /*yield*/, this.$kwCommunication.axios.get(url, {
                                params: {
                                    per_page: this.perPage,
                                    page: this.page,
                                    filters: this.filters
                                }
                            })
                                .then(function (response) {
                                var _a;
                                var datas = response.data;
                                (_a = _this.datas).push.apply(_a, datas.data.filter(function (data) { return !_this.datas.find(function (d) { return d.type === data.type && d.id === data.id; }); }));
                                _this.total = datas.total;
                                _this.totals = datas.totals;
                                _this.$emit('loaded', datas);
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Change the display state for a type
    AgregateDatas.prototype.selectType = function (type) {
        if (this.forceState !== null) {
            this.forceState = null;
            if (!this.state[type]) {
                this.state[type] = true;
            }
        }
        else {
            this.state[type] = !this.state[type];
        }
        this.saveState();
    };
    // Format a time
    AgregateDatas.prototype.time = function (date) {
        return (0,interface_vue_.moment)(date).format('HH[h]mm');
    };
    // Remove an element from the datas
    AgregateDatas.prototype.deleted = function (type, id) {
        var index = this.datas.findIndex(function (data) { return data.type === type && data.id === id; });
        if (index >= 0) {
            lib/* Vue */.lD.delete(this.datas, index);
            this.total--;
            this.page = Math.floor(this.total / this.perPage) + 1;
            if (this.totals && this.totals[type]) {
                this.totals[type]--;
            }
        }
    };
    // Add new file(s)
    AgregateDatas.prototype.newFiles = function () {
        var file = this.$refs.fileupload;
        file.selectFile();
    };
    // Create a new task
    AgregateDatas.prototype.newTask = function () {
        this.openModal({
            key: 'task-form',
            value: {
                elements: this.computedLinkedElements(true)
            }
        });
    };
    // Update an event
    AgregateDatas.prototype.eventForm = function (event) {
        if (!event) {
            event = {
                elements: this.computedLinkedElements(true)
            };
        }
        this.openModal({
            key: 'event-form',
            value: event
        });
    };
    // Call when a task is created
    AgregateDatas.prototype.taskAdded = function (task) {
        var _this = this;
        var _a;
        var index = this.datas.findIndex(function (data) { return data.id === task.id && data.type === 'task'; });
        if (index >= 0) {
            // If task already present
            this.taskUpdated({ new: task, old: null });
            return;
        }
        if (task.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; })) {
            this.addElement('task', task.id, (_a = task.datetime) !== null && _a !== void 0 ? _a : '0000-00-00 00:00:00', task);
        }
    };
    // Call when a task is updated
    AgregateDatas.prototype.taskUpdated = function (event) {
        var _this = this;
        var _a;
        var task = event.new;
        if (task.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; })) {
            this.updateElement('task', task.id, (_a = task.datetime) !== null && _a !== void 0 ? _a : '0000-00-00 00:00:00', task);
        }
        else {
            this.deleteElement('task', task.id);
        }
    };
    // Call when a task is deleted
    AgregateDatas.prototype.taskDeleted = function (id) {
        this.deleteElement('task', id);
    };
    // Call when a letter is added
    AgregateDatas.prototype.letterAdded = function (letter) {
        var _this = this;
        var _a;
        var index = this.datas.findIndex(function (data) { return data.id === letter.id && data.type === 'letter'; });
        if (index >= 0) {
            this.letterUpdated({ new: letter, old: null });
            return;
        }
        if ((this.type === 'customer' && this.id === letter.customer_id) ||
            (letter.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; }))) {
            this.addElement('letter', letter.id, (_a = letter.date) !== null && _a !== void 0 ? _a : '0000-00-00 00:00:00', letter);
            this.$emit('letterSent', letter);
        }
    };
    // Call when a letter is updated
    AgregateDatas.prototype.letterUpdated = function (event) {
        var _this = this;
        var _a;
        var letter = event.new;
        if ((this.type === 'customer' && this.id === letter.customer_id) ||
            (letter.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; }))) {
            this.updateElement('letter', letter.id, (_a = letter.date) !== null && _a !== void 0 ? _a : '0000-00-00 00:00:00', letter);
        }
        else {
            this.deleteElement('letter', letter.id);
        }
    };
    // Call when a letter is deleted
    AgregateDatas.prototype.letterDeleted = function (letter) {
        this.deleteElement('letter', letter.id);
    };
    // Call when a report is added
    AgregateDatas.prototype.reportAdded = function (report) {
        var _this = this;
        var index = this.datas.findIndex(function (data) { return data.id === report.id && data.type === 'report'; });
        if (index >= 0) {
            this.reportUpdated({ new: report, old: null });
            return;
        }
        if ((this.type === 'customer' && this.id === report.customer_id) ||
            (report.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; }))) {
            this.addElement('report', report.id, report.date, report);
        }
    };
    // Call when a report is updated
    AgregateDatas.prototype.reportUpdated = function (event) {
        var _this = this;
        var report = event.new;
        if ((this.type === 'customer' && this.id === report.customer_id) ||
            (report.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; }))) {
            this.updateElement('report', report.id, report.date, report);
        }
        else {
            this.deleteElement('report', report.id);
        }
    };
    // Call when a report is deleted
    AgregateDatas.prototype.reportDeleted = function (report) {
        this.deleteElement('report', report.id);
    };
    // Call when an email is added
    AgregateDatas.prototype.mailAdded = function (mail) {
        var _this = this;
        var index = this.datas.findIndex(function (data) { return data.id === mail.id && data.type === 'mail'; });
        if (index >= 0) {
            this.mailUpdated({ new: mail, old: null });
            return;
        }
        if (mail.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; }) ||
            mail.recipients.find(function (recipient) { var _a, _b; return ((_a = recipient === null || recipient === void 0 ? void 0 : recipient.element) === null || _a === void 0 ? void 0 : _a.type) === _this.type && ((_b = recipient === null || recipient === void 0 ? void 0 : recipient.element) === null || _b === void 0 ? void 0 : _b.id) === _this.id; })) {
            this.addElement('mail', mail.id, mail.datetime, mail);
            this.$emit('mailSent', mail);
        }
    };
    // Call when an email is updated
    AgregateDatas.prototype.mailUpdated = function (event) {
        var _this = this;
        var _a;
        var mail = event.new;
        if (((_a = mail.elements) === null || _a === void 0 ? void 0 : _a.find(function (element) { return element.id === _this.id && element.type === _this.type; })) ||
            mail.recipients.find(function (recipient) { var _a, _b; return ((_a = recipient === null || recipient === void 0 ? void 0 : recipient.element) === null || _a === void 0 ? void 0 : _a.type) === _this.type && ((_b = recipient === null || recipient === void 0 ? void 0 : recipient.element) === null || _b === void 0 ? void 0 : _b.id) === _this.id; })) {
            this.updateElement('mail', mail.id, mail.datetime, mail);
        }
        else {
            this.deleteElement('mail', mail.id);
        }
    };
    // Call when an email is deleted
    AgregateDatas.prototype.mailDeleted = function (mail) {
        this.deleteElement('mail', mail.id);
    };
    AgregateDatas.prototype.mailSent = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var data;
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = this.datas.find(function (data) { return data.id === event.id && data.type === 'mail'; });
                        if (!(!data || (0,interface_vue_.moment)(event.updated_at).isAfter(data.data.updated_at))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$kwCommunication.axios.get('/mail/' + event.id, { params: { include: ['sender', 'recipients', 'elements', 'attachments', 'teamUser'] } })
                                .then(function (response) {
                                _this.mailAdded(response.data);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AgregateDatas.prototype.eventAdded = function (event) {
        var _this = this;
        var index = this.datas.findIndex(function (data) { return data.id === event.id && data.type === 'event'; });
        if (index >= 0) {
            // If task already present
            this.eventUpdated({ new: event, old: null });
            return;
        }
        if (event.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; })) {
            this.addElement('event', event.id, event.begin, event);
        }
    };
    AgregateDatas.prototype.eventUpdated = function (updateEvent) {
        var _this = this;
        var event = updateEvent.new;
        if (event.elements.find(function (element) { return element.id === _this.id && element.type === _this.type; })) {
            this.updateElement('event', event.id, event.begin, event);
        }
        else {
            this.deleteElement('event', event.id);
        }
    };
    AgregateDatas.prototype.eventDeleted = function (event) {
        this.deleteElement('event', event.id);
    };
    AgregateDatas.prototype.commentAdded = function (comment) {
        var index = this.datas.findIndex(function (data) { return data.id === comment.id && data.type === 'comment'; });
        if (index >= 0) {
            this.commentUpdated(comment);
            return;
        }
        if (comment.element_type === this.type && comment.element_id === this.id) {
            this.addElement('comment', comment.id, comment.created_at, comment);
        }
    };
    AgregateDatas.prototype.commentUpdated = function (comment) {
        if (comment.element_type === this.type && comment.element_id === this.id) {
            this.updateElement('comment', comment.id, comment.created_at, comment);
        }
        else {
            this.deleteElement('comment', comment.id);
        }
    };
    AgregateDatas.prototype.commentDeleted = function (comment) {
        this.deleteElement('comment', comment.id);
    };
    AgregateDatas.prototype.fileAdded = function (file) {
        var index = this.datas.findIndex(function (data) { return data.id === file.id && data.type === 'file'; });
        if (index >= 0) {
            this.fileUpdated(file);
            return;
        }
        if (file.element_type === this.type && file.element_id === this.id) {
            this.addElement('file', file.id, file.created_at, file);
        }
    };
    AgregateDatas.prototype.fileUpdated = function (file) {
        if (file.element_type === this.type && file.element_id === this.id) {
            this.updateElement('file', file.id, file.created_at, file);
        }
        else {
            this.deleteElement('file', file.id);
        }
    };
    AgregateDatas.prototype.fileDeleted = function (file) {
        this.deleteElement('file', file.id);
    };
    AgregateDatas.prototype.historicAdded = function (historic) {
        if (historic.linked.type === this.type && historic.linked.id === this.id) {
            this.addElement('historic', 0, historic.date, historic);
        }
    };
    // Create an element
    AgregateDatas.prototype.addElement = function (type, id, date, data) {
        this.datas.push({ type: type, id: id, date: date, data: data });
        this.total++;
        if (this.totals) {
            this.totals[type]++;
        }
    };
    // Update an element
    AgregateDatas.prototype.updateElement = function (type, id, date, data) {
        var index = this.datas.findIndex(function (data) { return data.id === id && data.type === type; });
        if (index >= 0) {
            lib/* Vue */.lD.set(this.datas, index, { type: type, id: id, date: date, data: data });
        }
        else {
            this.addElement(type, id, date, data);
        }
    };
    // Delete an element
    AgregateDatas.prototype.deleteElement = function (type, id) {
        var index = this.datas.findIndex(function (data) { return data.id === id && data.type === type; });
        if (index >= 0) {
            lib/* Vue */.lD.delete(this.datas, index);
            this.totals[type]--;
            this.total--;
        }
    };
    AgregateDatas.prototype.saveState = function () {
        var date = new Date();
        date.setTime(date.getTime() + (60 * 60 * 1000));
        var state = {
            state: this.state,
            filters: this.filters,
            expire: date.getTime()
        };
        localStorage.setItem('agregateDatasStates', JSON.stringify(state));
    };
    AgregateDatas.prototype.fetchState = function () {
        var state = localStorage.getItem('agregateDatasStates');
        if (state) {
            var parsed = JSON.parse(state);
            this.state = 'comment' in parsed ? parsed : parsed.state;
            if (parsed.filters && parsed.expire > new Date().getTime()) {
                this.filters = parsed.filters;
            }
        }
    };
    AgregateDatas.prototype.watchTotal = function () {
        this.$emit('total', this.total);
    };
    AgregateDatas.prototype.previewContent = function (html) {
        if (html === null) {
            return '';
        }
        return this.htmlToText(html)
            .replaceAll(/\s\s+/g, '. ')
            .replaceAll('\n', '. ');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AgregateDatas.prototype, "type", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AgregateDatas.prototype, "id", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AgregateDatas.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AgregateDatas.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AgregateDatas.prototype, "model", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AgregateDatas.prototype, "modelTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AgregateDatas.prototype, "url", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AgregateDatas.prototype, "preload", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], AgregateDatas.prototype, "linkedElements", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return []; } })
    ], AgregateDatas.prototype, "attachments", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('filters', { deep: true })
    ], AgregateDatas.prototype, "watchFilters", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('total')
    ], AgregateDatas.prototype, "watchTotal", null);
    AgregateDatas = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            name: 'agregate-datas',
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'teamUserConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapState)('globalDatas', ['teamUsers'])),
            components: {
                SendEmailButton: SendEmailButton_SendEmailButton,
                EmailItem: EmailItem_EmailItem,
                ReportItem: ReportItem_ReportItem,
                LetterItem: LetterItem_LetterItem,
                ReportFormButton: ReportFormButton_ReportFormButton,
                LetterFormButton: LetterFormButton_LetterFormButton,
                Spinner: interface_vue_.Spinner, FileItem: interface_vue_.FileItem, CommentsItem: interface_vue_.CommentsItem, CommentsForm: interface_vue_.CommentsForm, FormModal: interface_vue_.FormModal, TextareaView: interface_vue_.TextareaView, TeamUserSelect: interface_vue_.TeamUserSelect,
                FroalaView: form_vue_.FroalaView, KFormFile: form_vue_.KFormFileUpload, KFormDatepicker: form_vue_.KFormDatepicker,
                TaskItem: tasks_vue_namespaceObject.TaskItem,
                CalendarButton: calendars_vue_namespaceObject.CalendarButton,
                FontAwesomeIcon: index_es/* FontAwesomeIcon */.gc,
                BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard, BButtonGroup: external_bootstrap_vue_.BButtonGroup, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItem: external_bootstrap_vue_.BDropdownItem, BDropdownText: external_bootstrap_vue_.BDropdownText, BAvatar: external_bootstrap_vue_.BAvatar, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BBadge: external_bootstrap_vue_.BBadge, BDropdownHeader: external_bootstrap_vue_.BDropdownHeader, BDropdownDivider: external_bootstrap_vue_.BDropdownDivider, BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], AgregateDatas);
    return AgregateDatas;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, mixins_LetterDownloadMixin, interface_vue_.NumberMixin, interface_vue_.TextMixin)));
/* harmony default export */ var AgregateDatasvue_type_script_lang_ts_external = (AgregateDatas);

;// ./src/components/AgregateDatas/AgregateDatas.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AgregateDatas_AgregateDatasvue_type_script_lang_ts_external = (AgregateDatasvue_type_script_lang_ts_external); 
;// ./src/components/AgregateDatas/AgregateDatas.vue





/* normalize component */
;
var AgregateDatas_component = (0,componentNormalizer/* default */.A)(
  AgregateDatas_AgregateDatasvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AgregateDatas_AgregateDatas = (AgregateDatas_component.exports);
// EXTERNAL MODULE: ./src/components/CommunicationParams/CommunicationParams.vue + 3 modules
var CommunicationParams = __webpack_require__(3607);
// EXTERNAL MODULE: ./src/components/CustomerLibrary/CustomerLibrary.vue + 3 modules
var CustomerLibrary = __webpack_require__(1439);
// EXTERNAL MODULE: ./src/components/CustomerLibraryButton/CustomerLibraryButton.vue + 3 modules
var CustomerLibraryButton = __webpack_require__(4831);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LetterList/LetterList.vue?vue&type=template&id=71645275
var LetterListvue_type_template_id_71645275_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.loadingDownload}},[_c('k-table',{ref:"table",attrs:{"url":"/communication/letter","ajaxDatas":{ include: 'customer,contact,attachments' },"columns":_vm.columns,"rowClick":_vm.rowClick,"rowActions":_vm.rowActions,"exportable":"letters"}})],1),(_vm.show)?_c('LetterItem',{attrs:{"modal":_vm.show !== null},on:{"hidden":function($event){_vm.show = null}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}}):_vm._e(),_c('LetterForm',{attrs:{"elements":_vm.edited ? _vm.edited.elements : [],"customer":_vm.edited ? _vm.edited.customer : null,"contact":_vm.edited ? _vm.edited.contact : null,"modalState":_vm.edited !== null},on:{"hidden":function($event){_vm.edited = null}},model:{value:(_vm.edited),callback:function ($$v) {_vm.edited=$$v},expression:"edited"}}),_c('LetterDelete',{attrs:{"element":"modal","modal":_vm.deleteLetter !== null},on:{"closed":function($event){_vm.deleteLetter = null}},model:{value:(_vm.deleteLetter),callback:function ($$v) {_vm.deleteLetter=$$v},expression:"deleteLetter"}})],1)
}
var LetterListvue_type_template_id_71645275_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/LetterList/LetterList.ts?vue&type=script&lang=ts&external









var LetterList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(LetterList, _super);
    function LetterList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.show = null;
        _this.edited = null;
        _this.deleteLetter = null;
        return _this;
    }
    LetterList.prototype.mounted = function () {
        interface_vue_.emitter.on('letterCreated', this.letterCreated);
        interface_vue_.emitter.on('letterUpdated', this.letterUpdated);
        interface_vue_.emitter.on('letterDeleted', this.letterDeleted);
    };
    LetterList.prototype.destroyed = function () {
        interface_vue_.emitter.off('letterCreated', this.letterCreated);
        interface_vue_.emitter.off('letterUpdated', this.letterUpdated);
        interface_vue_.emitter.off('letterDeleted', this.letterDeleted);
    };
    Object.defineProperty(LetterList.prototype, "columns", {
        get: function () {
            return [
                {
                    data: 'date',
                    name: this.$t('communication.letter.list.date'),
                    render: 'date'
                },
                {
                    data: 'address',
                    name: this.$t('communication.letter.list.address'),
                    render: 'textarea',
                    visible: false
                },
                {
                    data: 'customer.name',
                    name: this.$t('communication.letter.list.tiers'),
                    visible: false
                },
                {
                    data: 'contact.fullname',
                    name: this.$t('communication.letter.list.contact'),
                    visible: false
                },
                {
                    data: 'subject',
                    name: this.$t('communication.letter.list.subject'),
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    render: 'datetime'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LetterList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('interface.download'),
                    variant: 'secondary',
                    click: this.downloadLetter
                },
                {
                    label: this.$t('interface.edit'),
                    variant: 'primary',
                    click: function (letter) {
                        if (letter === void 0) { letter = null; }
                        _this.edited = letter !== null && letter !== void 0 ? letter : {};
                    }
                },
                {
                    label: this.$t('interface.delete'),
                    variant: 'secondary',
                    click: function (letter) {
                        _this.deleteLetter = letter;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    LetterList.prototype.rowClick = function (row) {
        this.show = row;
    };
    LetterList.prototype.letterCreated = function (letter) {
        var table = this.$refs.table;
        table.addRow(letter);
    };
    LetterList.prototype.letterUpdated = function (event) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            table.updateRow(index, event.new);
        }
        else {
            table.addRow(event.new);
        }
    };
    LetterList.prototype.letterDeleted = function (letter) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === letter.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    LetterList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                LetterItem: LetterItem_LetterItem,
                LetterForm: LetterForm_LetterForm,
                LetterDelete: LetterDelete_LetterDelete,
                KTable: table_vue_.KTable,
                BOverlay: external_bootstrap_vue_.BOverlay
            }
        })
    ], LetterList);
    return LetterList;
}((0,lib/* Mixins */.Xe)(mixins_LetterDownloadMixin)));
/* harmony default export */ var LetterListvue_type_script_lang_ts_external = (LetterList);

;// ./src/components/LetterList/LetterList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var LetterList_LetterListvue_type_script_lang_ts_external = (LetterListvue_type_script_lang_ts_external); 
;// ./src/components/LetterList/LetterList.vue





/* normalize component */
;
var LetterList_component = (0,componentNormalizer/* default */.A)(
  LetterList_LetterListvue_type_script_lang_ts_external,
  LetterListvue_type_template_id_71645275_render,
  LetterListvue_type_template_id_71645275_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LetterList_LetterList = (LetterList_component.exports);
// EXTERNAL MODULE: ./src/components/LetterParams/LetterParams.vue + 3 modules
var LetterParams = __webpack_require__(5341);
// EXTERNAL MODULE: ./src/components/LibraryDelete/LibraryDelete.vue + 3 modules
var LibraryDelete = __webpack_require__(6463);
// EXTERNAL MODULE: ./src/components/LibraryForm/LibraryForm.vue + 3 modules
var LibraryForm = __webpack_require__(3852);
// EXTERNAL MODULE: ./src/components/LibraryList/LibraryList.vue + 3 modules
var LibraryList = __webpack_require__(3176);
// EXTERNAL MODULE: ./src/components/LibraryListButton/LibraryListButton.vue + 3 modules
var LibraryListButton = __webpack_require__(8546);
// EXTERNAL MODULE: ./src/components/ModelDelete/ModelDelete.vue + 3 modules
var ModelDelete = __webpack_require__(4326);
// EXTERNAL MODULE: ./src/components/ModelForm/ModelForm.vue + 5 modules
var ModelForm = __webpack_require__(9129);
// EXTERNAL MODULE: ./src/components/ModelList/ModelList.vue + 3 modules
var ModelList = __webpack_require__(9031);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ReportList/ReportList.vue?vue&type=template&id=12cd2997
var ReportListvue_type_template_id_12cd2997_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-table',{ref:"table",attrs:{"url":"/communication/report","ajaxDatas":{ include: 'customer,recipients,attachments' },"columns":_vm.columns,"rowClick":_vm.rowClick,"rowActions":_vm.rowActions,"bordered":"","exportable":"reports"}}),(_vm.show)?_c('ReportItem',{attrs:{"modal":_vm.show !== null},on:{"hidden":function($event){_vm.show = null}},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}}):_vm._e(),_c('ReportForm',{attrs:{"element":_vm.edited ? _vm.edited.element : null,"customer":_vm.edited ? _vm.edited.customer : null,"modalState":_vm.edited !== null},on:{"hidden":function($event){_vm.edited = null}},model:{value:(_vm.edited),callback:function ($$v) {_vm.edited=$$v},expression:"edited"}}),_c('ReportDelete',{attrs:{"element":"modal","modal":_vm.deleteReport !== null},on:{"closed":function($event){_vm.deleteReport = null}},model:{value:(_vm.deleteReport),callback:function ($$v) {_vm.deleteReport=$$v},expression:"deleteReport"}})],1)
}
var ReportListvue_type_template_id_12cd2997_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/ReportList/ReportList.ts?vue&type=script&lang=ts&external







var ReportList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ReportList, _super);
    function ReportList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.show = null;
        _this.edited = null;
        _this.deleteReport = null;
        return _this;
    }
    ReportList.prototype.mounted = function () {
        interface_vue_.emitter.on('reportCreated', this.reportCreated);
        interface_vue_.emitter.on('reportUpdated', this.reportUpdated);
        interface_vue_.emitter.on('reportDeleted', this.reportDeleted);
    };
    ReportList.prototype.destroyed = function () {
        interface_vue_.emitter.off('reportCreated', this.reportCreated);
        interface_vue_.emitter.off('reportUpdated', this.reportUpdated);
        interface_vue_.emitter.off('reportDeleted', this.reportDeleted);
    };
    Object.defineProperty(ReportList.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    data: 'date',
                    name: this.$t('communication.report.list.date'),
                    render: 'datetime'
                },
                {
                    data: 'type',
                    name: this.$t('communication.report.list.type'),
                    render: function (data) { return _this.$t('communication.report.type.' + data); }
                },
                {
                    data: 'recipients',
                    name: this.$t('communication.report.list.recipients'),
                    render: function (recipients) { return recipients.map(function (recipient) { return recipient.label; }).join(', '); }
                },
                {
                    data: 'customer.name',
                    name: this.$t('communication.report.list.customer'),
                    visible: false
                },
                {
                    data: 'subject',
                    name: this.$t('communication.report.list.subject')
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    render: 'datetime'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ReportList.prototype.rowClick = function (row) {
        this.show = row;
    };
    Object.defineProperty(ReportList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('interface.edit'),
                    variant: 'primary',
                    click: function (report) {
                        if (report === void 0) { report = null; }
                        _this.edited = report !== null && report !== void 0 ? report : {};
                    }
                },
                {
                    label: this.$t('interface.delete'),
                    variant: 'secondary',
                    click: function (report) {
                        _this.deleteReport = report;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    ReportList.prototype.reportCreated = function (report) {
        var table = this.$refs.table;
        table.addRow(report);
    };
    ReportList.prototype.reportUpdated = function (event) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === event.new.id; });
        if (index >= 0) {
            table.updateRow(index, event.new);
        }
        else {
            table.addRow(event.new);
        }
    };
    ReportList.prototype.reportDeleted = function (report) {
        var table = this.$refs.table;
        var index = table.getDatas().findIndex(function (data) { return data.id === report.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    ReportList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                ReportForm: ReportForm_ReportForm,
                ReportDelete: ReportDelete_ReportDelete,
                ReportItem: ReportItem_ReportItem,
                KTable: table_vue_.KTable
            }
        })
    ], ReportList);
    return ReportList;
}(lib/* Vue */.lD));
/* harmony default export */ var ReportListvue_type_script_lang_ts_external = (ReportList);

;// ./src/components/ReportList/ReportList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var ReportList_ReportListvue_type_script_lang_ts_external = (ReportListvue_type_script_lang_ts_external); 
;// ./src/components/ReportList/ReportList.vue





/* normalize component */
;
var ReportList_component = (0,componentNormalizer/* default */.A)(
  ReportList_ReportListvue_type_script_lang_ts_external,
  ReportListvue_type_template_id_12cd2997_render,
  ReportListvue_type_template_id_12cd2997_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReportList_ReportList = (ReportList_component.exports);
// EXTERNAL MODULE: ./src/components/SendEmail/SendEmail.vue + 4 modules
var SendEmail = __webpack_require__(808);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SendEmailsArea/SendEmailsArea.vue?vue&type=template&id=7e44d42c
var SendEmailsAreavue_type_template_id_7e44d42c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"send-email-area"},[_c('b-row',{staticClass:"flex-row-reverse flex-nowrap",attrs:{"align-v":"end"}},_vm._l((_vm.mailForms),function(mail,i){return _c('b-col',{key:i,class:{
        'mail-fullscreen': _vm.mailForms[i].mode === 'fullscreen'
      },attrs:{"cols":"auto","order":_vm.mailForms[i].mode === 'collapsed' ? 1 : 0}},[(_vm.mailForms[i].mode === 'fullscreen')?_c('div',{staticClass:"mail-modal-overlay"}):_vm._e(),_c('SendEmail',{attrs:{"value":_vm.mailForms[i],"preload":_vm.mailForms[i].preload},on:{"close":function($event){return _vm.closeMailForm(i)},"input":val => _vm.saveMailForm({ index: i, mail: val })}})],1)}),1)],1)
}
var SendEmailsAreavue_type_template_id_7e44d42c_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SendEmailsArea/SendEmailsArea.ts?vue&type=script&lang=ts&external





var SendEmailsArea = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SendEmailsArea, _super);
    function SendEmailsArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SendEmailsArea = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('communication', ['mailForms'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['closeMailForm', 'saveMailForm'])),
            components: {
                SendEmail: SendEmail/* default */.A,
                BRow: external_bootstrap_vue_.BRow,
                BCol: external_bootstrap_vue_.BCol
            }
        })
    ], SendEmailsArea);
    return SendEmailsArea;
}(lib/* Vue */.lD));
/* harmony default export */ var SendEmailsAreavue_type_script_lang_ts_external = (SendEmailsArea);

;// ./src/components/SendEmailsArea/SendEmailsArea.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SendEmailsArea_SendEmailsAreavue_type_script_lang_ts_external = (SendEmailsAreavue_type_script_lang_ts_external); 
;// ./src/components/SendEmailsArea/SendEmailsArea.vue





/* normalize component */
;
var SendEmailsArea_component = (0,componentNormalizer/* default */.A)(
  SendEmailsArea_SendEmailsAreavue_type_script_lang_ts_external,
  SendEmailsAreavue_type_template_id_7e44d42c_render,
  SendEmailsAreavue_type_template_id_7e44d42c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SendEmailsArea_SendEmailsArea = (SendEmailsArea_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SenderDelete/SenderDelete.vue?vue&type=template&id=6472087a
var SenderDeletevue_type_template_id_6472087a_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"title":_vm.$t('interface.deleteConfirmation'),"cancel-title":_vm.$t('interface.cancel'),"ok-title":_vm.$t('interface.delete'),"busy":_vm.loading,"hide-header-close":_vm.loading,"no-close-on-esc":_vm.loading,"no-close-on-backdrop":_vm.loading},on:{"ok":_vm.onOk,"cancel":_vm.onCancel},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('b-overlay',{attrs:{"show":_vm.loading,"rounded":"sm","variant":"white","opacity":.8,"blur":"5px"}},[_vm._v(" "+_vm._s(_vm.$t('communication.senders.deleteMsg'))+" ")])],1)
}
var SenderDeletevue_type_template_id_6472087a_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SenderDelete/SenderDelete.ts?vue&type=script&lang=ts&external




var SenderDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SenderDelete, _super);
    function SenderDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showModal = false;
        _this.loading = false;
        return _this;
    }
    Object.defineProperty(SenderDelete.prototype, "apiUrl", {
        get: function () {
            var _a;
            return '/mail/sender/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id);
        },
        enumerable: false,
        configurable: true
    });
    SenderDelete.prototype.watchValue = function (value) {
        this.value = value;
        this.showModal = value !== null;
    };
    SenderDelete.prototype.onCancel = function () {
        return null;
    };
    SenderDelete.prototype.onOk = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.delete(this.apiUrl)
                                .then(function () {
                                if (_this.value) {
                                    _this.deleteSender(_this.value);
                                }
                                _this.$emit('deleted');
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], SenderDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], SenderDelete.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('input')
    ], SenderDelete.prototype, "onCancel", null);
    SenderDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['deleteSender']))
        })
    ], SenderDelete);
    return SenderDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var SenderDeletevue_type_script_lang_ts_external = (SenderDelete);

;// ./src/components/SenderDelete/SenderDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SenderDelete_SenderDeletevue_type_script_lang_ts_external = (SenderDeletevue_type_script_lang_ts_external); 
;// ./src/components/SenderDelete/SenderDelete.vue





/* normalize component */
;
var SenderDelete_component = (0,componentNormalizer/* default */.A)(
  SenderDelete_SenderDeletevue_type_script_lang_ts_external,
  SenderDeletevue_type_template_id_6472087a_render,
  SenderDeletevue_type_template_id_6472087a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SenderDelete_SenderDelete = (SenderDelete_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SenderForm/SenderForm.vue?vue&type=template&id=10c44e9f
var SenderFormvue_type_template_id_10c44e9f_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{ref:"modal",attrs:{"title":_vm.title,"visible":_vm.show,"size":"lg","scrollable":"","busy":_vm.loadingValidation,"hide-header-close":_vm.loadingValidation,"no-close-on-backdrop":_vm.loadingValidation,"no-close-on-esc":_vm.loadingValidation},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[(_vm.loadingValidation)?_c('Spinner'):[(_vm.errorMsg)?_c('b-alert',{staticClass:"mb-4",attrs:{"variant":"danger","show":""}},[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")]):(_vm.validationSend)?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.confirmationSend'))+" ")]):(_vm.localValue.id && !_vm.localValue.is_validated)?_c('b-alert',{staticClass:"mb-4",attrs:{"variant":"warning","show":""}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.waitValidation'))+" ")]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.resendValidation.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.resendValidation'))+" ")])],1):_vm._e(),_c('k-form',{staticClass:"sender-form",attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete,"submitError":_vm.submitError}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.name')}},[_c('k-form-input',{attrs:{"name":"name","placeholder":_vm.user.fullname},model:{value:(_vm.localValue.name),callback:function ($$v) {_vm.$set(_vm.localValue, "name", $$v)},expression:"localValue.name"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.mail')}},[(!_vm.localValue.id)?[_c('k-form-input',{attrs:{"type":"email","name":"address","required":""},model:{value:(_vm.localValue.address),callback:function ($$v) {_vm.$set(_vm.localValue, "address", $$v)},expression:"localValue.address"}}),(!_vm.localValue.id)?_c('b-alert',{staticClass:"mt-2",attrs:{"variant":"warning","show":""}},[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.validationExplain1'))+" "+_vm._s(_vm.$t('communication.senders.form.validationExplain2'))+" ")]):_vm._e()]:[_vm._v(" "+_vm._s(_vm.localValue.address)+" ")]],2),_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.useDefault')}},[_c('b-form-radio-group',{attrs:{"name":"use_default"},model:{value:(_vm.localValue.use_default),callback:function ($$v) {_vm.$set(_vm.localValue, "use_default", $$v)},expression:"localValue.use_default"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.configType')}},[(_vm.localValue.type === 'default' || _vm.localValue.type === 'smtp')?_c('b-form-radio-group',{attrs:{"name":"type","stacked":""},model:{value:(_vm.localValue.type),callback:function ($$v) {_vm.$set(_vm.localValue, "type", $$v)},expression:"localValue.type"}},[_c('b-form-radio',{staticClass:"mt-1",attrs:{"value":"default"}},[_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.defaultServer'))+" ")]),_c('small',[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.defaultExplain'))+" ")])]),_c('b-form-radio',{staticClass:"mt-1",attrs:{"value":"smtp"}},[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.smtp'))+" ")])],1):[_vm._v(" "+_vm._s(_vm.$t('communication.senders.type.' + _vm.localValue.type))+" ")]],2),(_vm.localValue.type === 'smtp')?_c('div',{staticClass:"auth-part mb-4"},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.serverAddress')}},[_c('k-form-input',{attrs:{"name":"smtp[server]","required":"","validate":"url","size":"sm"},model:{value:(_vm.localValue.smtp.server),callback:function ($$v) {_vm.$set(_vm.localValue.smtp, "server", $$v)},expression:"localValue.smtp.server"}})],1)],1),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.serverPort')}},[_c('k-form-number',{attrs:{"name":"smtp[port]","maxDecimal":0,"min":1,"noDefaultValue":"","required":"","size":"sm"},model:{value:(_vm.localValue.smtp.port),callback:function ($$v) {_vm.$set(_vm.localValue.smtp, "port", $$v)},expression:"localValue.smtp.port"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.serverSecurity')}},[_c('k-form-select',{attrs:{"options":_vm.smtpSecurities,"name":"smtp[security]","reduce":opt => opt.value,"size":"sm"},model:{value:(_vm.localValue.smtp.security),callback:function ($$v) {_vm.$set(_vm.localValue.smtp, "security", $$v)},expression:"localValue.smtp.security"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.serverAuth')}},[_c('b-form-radio-group',{attrs:{"name":"smtp[authentification]"},model:{value:(_vm.localValue.smtp.authentification),callback:function ($$v) {_vm.$set(_vm.localValue.smtp, "authentification", $$v)},expression:"localValue.smtp.authentification"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(" "+_vm._s(_vm.$t('interface.yes'))+" ")]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(" "+_vm._s(_vm.$t('interface.no'))+" ")])],1)],1),(_vm.localValue.smtp.authentification)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.login')}},[_c('k-form-input',{attrs:{"name":"smtp[login]","required":"","size":"sm"},model:{value:(_vm.localValue.smtp.login),callback:function ($$v) {_vm.$set(_vm.localValue.smtp, "login", $$v)},expression:"localValue.smtp.login"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.password')}},[(_vm.localValue.id)?_c('k-form-checkbox',{attrs:{"size":"sm"},model:{value:(_vm.updatePassword),callback:function ($$v) {_vm.updatePassword=$$v},expression:"updatePassword"}},[_vm._v(" Modifier le mot de passe ")]):_vm._e(),_c('k-form-input',{attrs:{"type":"password","name":"smtp[password]","required":"","size":"sm","automaticRules":false,"disabled":_vm.localValue.id && !_vm.updatePassword},model:{value:(_vm.localValue.smtp.password),callback:function ($$v) {_vm.$set(_vm.localValue.smtp, "password", $$v)},expression:"localValue.smtp.password"}})],1)],1)],1):_vm._e()],1):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.tracking')}},[_c('input',{attrs:{"type":"hidden","name":"track_open"},domProps:{"value":_vm.localValue.track_open}}),_c('k-form-checkbox',{model:{value:(_vm.localValue.track_open),callback:function ($$v) {_vm.$set(_vm.localValue, "track_open", $$v)},expression:"localValue.track_open"}},[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.trackOpen'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"track_click"},domProps:{"value":_vm.localValue.track_click}}),_c('k-form-checkbox',{model:{value:(_vm.localValue.track_click),callback:function ($$v) {_vm.$set(_vm.localValue, "track_click", $$v)},expression:"localValue.track_click"}},[_vm._v(" "+_vm._s(_vm.$t('communication.senders.form.trackClick'))+" ")])],1),_c('b-form-group',{attrs:{"label":_vm.$t('communication.senders.form.share'),"description":_vm.$t('communication.senders.form.shareExplain')}},[_c('b-form-radio-group',{attrs:{"name":"share"},model:{value:(_vm.localValue.share),callback:function ($$v) {_vm.$set(_vm.localValue, "share", $$v)},expression:"localValue.share"}},[_c('b-form-radio',{attrs:{"value":true}},[_vm._v(_vm._s(_vm.$t('interface.yes')))]),_c('b-form-radio',{attrs:{"value":false}},[_vm._v(_vm._s(_vm.$t('interface.no')))])],1)],1),_c('b-form-group',{staticClass:"mt-5",attrs:{"label":_vm.$t('communication.senders.form.sign')}},[_c('k-form-editor',{attrs:{"name":"signature","config":_vm.editorConfig,"size":"sm"},model:{value:(_vm.localValue.signature),callback:function ($$v) {_vm.$set(_vm.localValue, "signature", $$v)},expression:"localValue.signature"}})],1)],1)]],2)
}
var SenderFormvue_type_template_id_10c44e9f_staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(2193);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/components/ModelForm/editorConfig.ts
var ModelForm_editorConfig = __webpack_require__(4074);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SenderForm/SenderForm.ts?vue&type=script&lang=ts&external








var SenderForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SenderForm, _super);
    function SenderForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = {
            type: 'default',
            use_default: false,
            track_open: true,
            share: false,
            smtp: {
                port: 25,
                authentification: false,
                security: 'none'
            }
        };
        _this.editorConfig = ModelForm_editorConfig/* default */.A;
        _this.loadingValidation = false;
        _this.validationSend = false;
        _this.errorMsg = null;
        _this.updatePassword = false;
        return _this;
    }
    Object.defineProperty(SenderForm.prototype, "smtpSecurities", {
        get: function () {
            return [
                { value: 'none', label: this.$t('communication.senders.form.none') },
                { value: 'tls', label: 'TLS' },
                { value: 'ssl', label: 'SSL' }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SenderForm.prototype, "formAction", {
        get: function () {
            var url = '/mail/sender';
            if (this.localValue.id) {
                url += '/' + this.localValue.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SenderForm.prototype, "formMethod", {
        get: function () {
            return this.localValue.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SenderForm.prototype, "title", {
        get: function () {
            var key = this.localValue.id ? 'edit' : 'create';
            return this.$t('communication.senders.' + key + 'Title');
        },
        enumerable: false,
        configurable: true
    });
    SenderForm.prototype.watchShow = function () {
        this.validationSend = false;
        this.errorMsg = null;
    };
    SenderForm.prototype.watchValue = function (value) {
        var defaultValue = {
            type: 'default',
            use_default: false,
            track_open: true,
            share: false
        };
        var localValue = isEmpty_default()(value) ? defaultValue : JSON.parse(JSON.stringify(value));
        if (!localValue.smtp) {
            localValue.smtp = {
                port: 25,
                authentification: false,
                security: 'none'
            };
        }
        this.localValue = localValue;
    };
    SenderForm.prototype.watchSmtpSecurity = function (security) {
        switch (security) {
            case 'tls':
                this.localValue.smtp.port = 587;
                break;
            case 'ssl':
                this.localValue.smtp.port = 465;
                break;
            case 'none':
                this.localValue.smtp.port = 25;
                break;
        }
    };
    SenderForm.prototype.submitComplete = function (response) {
        this.setSender(response.data);
        return response.data;
    };
    SenderForm.prototype.submitError = function (error) {
        var _a;
        this.errorMsg = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.message;
        var modal = this.$refs.modal;
        var body = modal === null || modal === void 0 ? void 0 : modal.$refs.body;
        body.scrollTop = 0;
    };
    SenderForm.prototype.resendValidation = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingValidation = true;
                        return [4 /*yield*/, this.$kwCommunication.axios.post(this.formAction + '/send-validation')
                                .then(function () {
                                _this.validationSend = true;
                                _this.watchValue(_this.value);
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loadingValidation = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], SenderForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], SenderForm.prototype, "show", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('show')
    ], SenderForm.prototype, "watchShow", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], SenderForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('localValue.smtp.security')
    ], SenderForm.prototype, "watchSmtpSecurity", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('submitted')
    ], SenderForm.prototype, "submitComplete", null);
    SenderForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FormModal: interface_vue_.FormModal,
                Spinner: interface_vue_.Spinner,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormNumber: form_vue_.KFormNumber, KFormSelect: form_vue_.KFormSelect, KFormCheckbox: form_vue_.KFormCheckbox, KFormEditor: form_vue_.KFormEditor,
                BAlert: external_bootstrap_vue_.BAlert, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup, BFormRadio: external_bootstrap_vue_.BFormRadio, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('communication', ['setSender'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('user', ['user']))
        })
    ], SenderForm);
    return SenderForm;
}(lib/* Vue */.lD));
/* harmony default export */ var SenderFormvue_type_script_lang_ts_external = (SenderForm);

;// ./src/components/SenderForm/SenderForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SenderForm_SenderFormvue_type_script_lang_ts_external = (SenderFormvue_type_script_lang_ts_external); 
;// ./src/components/SenderForm/SenderForm.vue





/* normalize component */
;
var SenderForm_component = (0,componentNormalizer/* default */.A)(
  SenderForm_SenderFormvue_type_script_lang_ts_external,
  SenderFormvue_type_template_id_10c44e9f_render,
  SenderFormvue_type_template_id_10c44e9f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SenderForm_SenderForm = (SenderForm_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SenderList/SenderList.vue?vue&type=template&id=06297b0e
var SenderListvue_type_template_id_06297b0e_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"page-title":_vm.$t('communication.senders.pageTitle'),"buttons":_vm.headerButtons}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t('communication.senders.list.explain'))+" ")]),_c('k-table',{ref:"table",attrs:{"url":"/mail/sender","ajaxDatas":{ filter: { status: 1 } },"columns":_vm.columns,"rowActions":_vm.rowActions,"bordered":"","stateKey":"senders-list"}}),_c('SenderForm',{attrs:{"show":_vm.edited !== null},on:{"submitted":_vm.submitted,"hidden":_vm.cancelEdited},model:{value:(_vm.edited),callback:function ($$v) {_vm.edited=$$v},expression:"edited"}}),_c('SenderDelete',{on:{"deleted":_vm.deleted},model:{value:(_vm.deleteSender),callback:function ($$v) {_vm.deleteSender=$$v},expression:"deleteSender"}})],1)
}
var SenderListvue_type_template_id_06297b0e_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/SenderList/SenderList.ts?vue&type=script&lang=ts&external






var SenderList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(SenderList, _super);
    function SenderList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.edited = null;
        _this.editedIndex = null;
        _this.deleteSender = null;
        _this.deleteIndex = null;
        return _this;
    }
    Object.defineProperty(SenderList.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('communication.senders.newLabel'),
                    click: function () {
                        _this.toEdit();
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SenderList.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    data: 'name',
                    name: this.$t('communication.senders.list.name'),
                },
                {
                    data: 'address',
                    name: this.$t('communication.senders.list.mail'),
                },
                {
                    data: 'track_open',
                    name: this.$t('communication.senders.list.trackOpen'),
                    render: 'boolean',
                    visible: false
                },
                {
                    data: 'track_click',
                    name: this.$t('communication.senders.list.trackLink'),
                    render: 'boolean',
                    visible: false
                },
                {
                    data: 'share',
                    name: this.$t('communication.senders.list.share'),
                    render: 'boolean'
                },
                {
                    data: 'is_validated',
                    name: this.$t('communication.senders.list.status'),
                    render: function (val) {
                        return _this.$t('communication.senders.list.' + (val ? 'statusActive' : 'statusWait'));
                    }
                },
                {
                    data: 'use_default',
                    name: this.$t('communication.senders.list.useDefault'),
                    render: 'boolean'
                },
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    render: 'datetime',
                    visible: false
                },
                {
                    data: 'updated_at',
                    name: this.$t('interface.list.updatedAt'),
                    render: 'datetime',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SenderList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('interface.edit'),
                    variant: 'primary',
                    click: function (sender, index) {
                        _this.toEdit(sender, index);
                    }
                },
                {
                    label: this.$t('interface.delete'),
                    variant: 'secondary',
                    click: function (sender, index) {
                        _this.deleteSender = sender;
                        _this.deleteIndex = index;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    SenderList.prototype.toEdit = function (sender, index) {
        if (sender === void 0) { sender = null; }
        if (index === void 0) { index = null; }
        this.edited = sender !== null && sender !== void 0 ? sender : {};
        this.editedIndex = index;
    };
    SenderList.prototype.submitted = function (sender) {
        var table = this.$refs.table;
        if (this.editedIndex !== null) {
            table.updateRow(this.editedIndex, sender);
            this.editedIndex = null;
        }
        else {
            table.addRow(sender);
        }
    };
    SenderList.prototype.cancelEdited = function () {
        this.editedIndex = null;
        this.edited = null;
    };
    SenderList.prototype.deleted = function () {
        if (this.deleteIndex !== null) {
            var table = this.$refs.table;
            table.deleteRow(this.deleteIndex);
            this.deleteIndex = null;
            this.deleteSender = null;
        }
    };
    SenderList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                SenderForm: SenderForm_SenderForm,
                SenderDelete: SenderDelete_SenderDelete,
                PageHeader: interface_vue_.PageHeader,
                KTable: table_vue_.KTable
            }
        })
    ], SenderList);
    return SenderList;
}(lib/* Vue */.lD));
/* harmony default export */ var SenderListvue_type_script_lang_ts_external = (SenderList);

;// ./src/components/SenderList/SenderList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var SenderList_SenderListvue_type_script_lang_ts_external = (SenderListvue_type_script_lang_ts_external); 
;// ./src/components/SenderList/SenderList.vue





/* normalize component */
;
var SenderList_component = (0,componentNormalizer/* default */.A)(
  SenderList_SenderListvue_type_script_lang_ts_external,
  SenderListvue_type_template_id_06297b0e_render,
  SenderListvue_type_template_id_06297b0e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SenderList_SenderList = (SenderList_component.exports);
// EXTERNAL MODULE: ./src/components/SenderValidation/SenderValidation.vue + 3 modules
var SenderValidation = __webpack_require__(7890);
// EXTERNAL MODULE: ./src/views/CommunicationParamsView.vue + 3 modules
var CommunicationParamsView = __webpack_require__(9052);
// EXTERNAL MODULE: ./src/views/LetterParamsView.vue + 3 modules
var LetterParamsView = __webpack_require__(2077);
// EXTERNAL MODULE: ./src/views/LibraryListView.vue + 3 modules
var LibraryListView = __webpack_require__(5294);
// EXTERNAL MODULE: ./src/views/ModelListView.vue + 3 modules
var ModelListView = __webpack_require__(9695);
// EXTERNAL MODULE: ./src/views/SenderValidationView.vue + 3 modules
var SenderValidationView = __webpack_require__(5090);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UserProfileView.vue?vue&type=template&id=49346330
var UserProfileViewvue_type_template_id_49346330_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('UserProfile'),_c('b-tabs',{staticClass:"tabs-card mt-5"},[_c('b-tab',{attrs:{"title":_vm.$t('communication.senders.label')}},[_c('SenderList')],1)],1)],1)
}
var UserProfileViewvue_type_template_id_49346330_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/UserProfileView.vue?vue&type=script&lang=ts





var UserProfileView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(UserProfileView, _super);
    function UserProfileView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProfileView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                UserProfile: interface_vue_.UserProfile,
                SenderList: SenderList_SenderList,
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab
            }
        })
    ], UserProfileView);
    return UserProfileView;
}(lib/* Vue */.lD));
/* harmony default export */ var UserProfileViewvue_type_script_lang_ts = (UserProfileView);

;// ./src/views/UserProfileView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_UserProfileViewvue_type_script_lang_ts = (UserProfileViewvue_type_script_lang_ts); 
;// ./src/views/UserProfileView.vue





/* normalize component */
;
var UserProfileView_component = (0,componentNormalizer/* default */.A)(
  views_UserProfileViewvue_type_script_lang_ts,
  UserProfileViewvue_type_template_id_49346330_render,
  UserProfileViewvue_type_template_id_49346330_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_UserProfileView = (UserProfileView_component.exports);
;// ./src/lang/en.ts
var communicationLang = {};
var agregateDatas = {};
/* harmony default export */ var en = ({
    communication: communicationLang,
    agregateDatas: agregateDatas
});

;// ./src/lang/fr.ts
var fr_communicationLang = {
    menuTitle: 'Communication',
    relation: 'Relation',
    files: {
        pageTitle: 'Bibliothèque de fichiers',
        menu: 'Bibliothèque',
        createTitle: 'Ajout d\'un fichier à la bibliothèque',
        editTitle: 'Modification d\'un fichier de la bibliothèque',
        form: {
            name: 'Nom du fichier',
            nameExplain: '(Facultatif) il n\'est utilisé que dans le logiciel afin d\'identifier plus facilement les fichiers.',
            file: 'Fichier :',
            fileIsRequired: 'Vous devez sélectionner un fichier'
        },
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce fichier ?',
        list: {
            name: 'Nom',
            filename: 'Nom du fichier',
            linkedElement: 'Élément lié'
        },
        newLabel: 'Nouveau fichier',
        fileAdded: 'Fichier ajouté',
        linkedType: 'Type d\'élément lié',
    },
    models: {
        pageTitle: 'Modèles d\'emails',
        menu: 'Modèles',
        createTitle: 'Création d\'un modèle',
        editTitle: 'Modification d\'un modèle',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
        form: {
            name: 'Nom du modèle',
            subject: 'Sujet',
            message: 'Message',
            files: 'Pièce(s) jointe(s) :',
            uploadBtn: 'Télécharger un fichier',
            libraryBtn: 'Bibliothèque de fichiers'
        },
        selectLabel: 'Modèles :',
        selectPlaceholder: 'Charger un modèle',
        list: {
            name: 'Nom du modèle'
        },
        newLabel: 'Nouveau modèle'
    },
    report: {
        report: 'Compte rendu',
        newTitle: 'Création d\'un compte-rendu',
        editTitle: 'Modification d\'un compte-rendu',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce compte-rendu ?',
        type: {
            1: 'Appel',
            2: 'Rendez-vous'
        },
        form: {
            type: 'Type de compte-rendu :',
            date: 'Date :',
            recipients: 'Correspondant(s) :',
            object: 'Sujet :',
            content: 'Description :',
            customer: 'Client',
            contact: 'Contact',
            user: 'Utilisateur'
        },
        list: {
            date: 'Date',
            type: 'Type',
            recipients: 'Participant(s)',
            customer: 'Tiers',
            subject: 'Sujet'
        },
        emptySubject: 'Aucun sujet',
        emptyContent: 'Aucune description'
    },
    reportType: {
        pageTitle: 'Gestion des types de comptes-rendus',
        menu: 'Comptes-rendus',
        label: 'Nom',
        new: 'Création d\'un type de compte-rendu',
        edit: 'Modification d\'un type de compte-rendu',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer le type de compte-rendu ?',
        cantDeleteMsg: 'Vous ne pouvez pas supprimer le type de compte-rendu car vous devez en avoir un au minimum'
    },
    letter: {
        newTitle: 'Création d\'une lettre',
        editTitle: 'Modification d\'une lettre',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette lettre ?',
        download: 'Télécharger la lettre',
        form: {
            date: 'Date :',
            address: 'Adresse du destinataire :',
            selectAddressPlaceholder: 'Selectionner une adresse',
            withAr: 'Recommandé avec accusé réception',
            subject: 'Object :',
            content: 'Message :',
            inGeneration: 'La lettre est en cours de génération',
            generated: 'Votre lettre a bien été générée.',
            generatingError: 'Une erreur est survenue lors de la génération de votre lettre',
            contactUpdated: 'Le contact a été mis à jour, voulez-vous réappliquer le modèle de lettre ?',
        },
        list: {
            date: 'Date',
            address: 'Adresse',
            tiers: 'Tiers',
            contact: 'Contact',
            subject: 'Object'
        },
        params: {
            explain: 'Vous avez la possibilité de personnaliser les lettres qui seront générées depuis le logiciel en utilisant un document Word.',
            model: 'Modèle de lettre',
            deleteMsg: 'Êtes-vous sûr de vouloir supprimer le modèle de lettre ?',
            fileType: 'Fichier word (.docx) ou Open Office (.odt) uniquement.',
            explain2: 'Si vous ne téléchargez pas de modèle personnalisé, c\'est le modèle par défaut qui est utilisé.',
            downloadDefault: 'Télécharger le modèle par défaut',
            variableExplain1: 'Liste des variables dynamiques qui peuvent être utilisées dans le document Word.',
            variableExplain2: 'Celles-ci seront automatiquement remplacées lors de la génération de la lettre.',
            variable: 'Variable',
            description: 'Désignation',
            userFirstname: 'Prénom de l\'utilisateur qui créer la lettre',
            userLastname: 'Nom de l\'utilisateur qui créer la lettre',
            userFullname: 'Prénom + Nom de l\'utilisateur qui créer la lettre',
            companyName: 'Nom de votre entreprise',
            companyAddress: 'Adresse de votre entreprise',
            companyTown: 'Ville de votre entreprise',
            address: 'Adresse de destination',
            contactCivility: 'Civilité du contact (Ex: Monsieur)',
            contactCivilityShort: 'Civilité abrégée du contact (Ex: M)',
            contactFirstname: 'Prénom du contact',
            contactLastname: 'Nom du contact',
            contactFullname: 'Prénom + Nom du contact',
            date: 'Date d\'envoi',
            subject: 'Sujet de la lettre',
            sendAr: 'Remplacer les XXX par votre phrase. Dans le cas d\'un envoi qui n\'est pas en accusé réception, la phrase sera supprimée.',
            content: 'Contenu de la lettre'
        },
        emptySubject: 'Aucun sujet',
        emptyContent: 'Aucun message'
    },
    params: {
        pageTitle: 'Paramètres par défaut',
        menu: 'Paramètres',
        explain: 'Vous pouvez choisir des modèles à utiliser par défaut. Ils seront alors préchargés lorsque vous envoyez un email depuis une fiche (devis ou clients par ex.).',
        fromProspect: 'Depuis une fiche prospect :',
        fromCustomer: 'Depuis une fiche client :',
        fromProvider: 'Depuis une fiche fournisseur :',
        fromSubcontractor: 'Depuis une fiche sous-traitant :',
        fromQuotation: 'Depuis une fiche devis :',
        fromCommand: 'Depuis une fiche bon de commande :',
        fromProforma: 'Depuis une fiche facture proforma :',
        fromDelivery: 'Depuis une fiche bon de livraison :',
        fromInvoice: 'Depuis une fiche facture :',
        fromCredit: 'Depuis une fiche avoir :',
        fromProviderCommand: 'Depuis une fiche commande fournisseur :'
    },
    letters: {
        pageTitle: 'Paramètres des lettres',
        menu: 'Lettres'
    },
    senders: {
        label: 'Expéditeurs',
        pageTitle: 'Gestion des expéditeurs des emails',
        createTitle: 'Création d\'un expéditeur',
        editTitle: 'Modification d\'un expéditeur',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cet expéditeur ?',
        newLabel: 'Nouvel expéditeur',
        form: {
            confirmationSend: 'L\'email de validation a été envoyé.',
            waitValidation: 'Expéditeur en attente de validation. Vous devez cliquer sur le lien qui a été envoyé par email.',
            resendValidation: 'Renvoyer l\'email de validation',
            name: 'Nom de l\'expéditeur :',
            mail: 'Adresse email :',
            validationExplain1: 'Un email avec un lien de validation sera envoyé afin de valider que vous êtes bien le propriétaire de cette adresse email.',
            validationExplain2: 'Vous ne pourrez utiliser cet email qu\'après la validation.',
            useDefault: 'Utiliser par défaut :',
            configType: 'Type de configuration :',
            defaultServer: 'Serveur d\'envoi par défaut',
            defaultExplain: 'L\'adresse email d\'expéditeur sera celle du logiciel mais l\'adresse email que vous avez indiquée sera utilisée lorsque votre destinataire vous répondra.',
            smtp: 'Serveur smtp personnalisé',
            serverAddress: 'Adresse du serveur :',
            serverPort: 'Port :',
            serverSecurity: 'Sécurité :',
            none: 'Non',
            serverAuth: 'Authentification :',
            login: 'Login :',
            password: 'Mot de passe :',
            tracking: 'Tracking des emails :',
            trackOpen: 'Traquer les ouvertures d\'email',
            trackClick: 'Traquer les clics sur les liens présents dans les emails',
            share: 'Partager cet expéditeur avec les autres utilisateurs :',
            shareExplain: 'Les autres utilisateurs pourront alors envoyer des emails via cet expéditeur.',
            sign: 'Signature :'
        },
        list: {
            explain: 'Vous avez la possibilité de configurer une ou plusieures adresses emails afin d\'envoyer vos emails depuis le logiciel.',
            name: 'Nom de l\'expéditeur',
            mail: 'Email',
            trackOpen: 'Suivi ouverture',
            trackLink: 'Suivi lien',
            share: 'Partagée',
            status: 'Statut',
            statusActive: 'Actif',
            statusWait: 'En attente de validation',
            useDefault: 'Par défaut'
        }
    },
    mail: {
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cet email ?',
        mail: 'Email',
        form: {
            tiers: 'Tiers',
            contact: 'Contact',
            user: 'Utilisateur',
            saveClose: 'Enregistrer et Fermer',
            from: 'De',
            to: 'À',
            cc: 'Cc',
            addCc: 'Ajouter des destinataires en copie',
            cci: 'Cci',
            addCci: 'Ajouter des destinataires en copie cachée',
            subject: 'Sujet',
            message: 'Message',
            send: 'Envoyer',
            addFiles: 'Joindre des fichiers',
            filesLibrary: 'Bibliothèque de fichiers',
            filesCustomer: 'Fichiers client',
            loadModel: 'Charger un modèle',
            contactUpdated: 'Le destinataire a été mis à jour, voulez-vous réappliquer le modèle d\'email ?',
            enlarge: 'Agrandir',
            reduce: 'Réduire',
            fullscreen: 'Plein écran',
            fullscreenOut: 'Sortir du plein écran',
            newMessage: 'Nouveau message',
            needValidSender: 'Vous devez valider votre adresse d\'expédition pour pouvoir envoyer des emails.',
            needAddSender: 'Vous devez ajouter une adresse d\'expédition pour envoyer des emails',
            validSender: 'Pour valider votre adresse email, vous devez cliquer dans le lien que vous avez reçu par email.',
            senderConfig: 'Gérer mes adresses d\'expédition',
            resend: 'Renvoyer l\'email',
            noModel: 'Aucun modèle',
            noSearchModel: 'Aucun résultat',
            searchModel: 'Rechercher...',
            limitExplain1: 'Vous avez atteint la limite d\'envoi. Vous devez patienter avant de pouvoir à nouveau envoyer des emails.',
            limitExplain2: 'Vous pouvez débloquer ce quota',
            limitExplain3: 'en créant un nouvel expéditeur',
            limitExplain4: 'En configuration votre serveur SMTP',
            limitExplain5: 'En connectant votre compte Gmail',
            limitExplain6: 'En connectant votre compte Outlook',
        },
        confirmSenderTitle: 'Validation d\'une adresse email',
        confirmSenderMessage: 'L\'adresse email "{email}" a bien été validée, vous pouvez maintenant l\'utiliser pour envoyer des emails.',
        confirm404Error: 'Aucune validation d\'email ne correspond. Soit l\'email a déjà été validé, soit le lien est incorrect.',
        sendError: 'Une erreur est survenue lors de l\'envoi de l\'email',
        read: 'Lu :',
        emptySubject: 'Aucun sujet',
        emptyContent: 'Aucun message'
    },
    attachmentDeleteMsg: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe ?',
    today: {
        days: {
            1: 'lundi',
            2: 'mardi',
            3: 'mercredi',
            4: 'jeudi',
            5: 'vendredi',
            6: 'samedi',
            7: 'dimanche'
        },
        months: {
            1: 'janvier',
            2: 'février',
            3: 'mars',
            4: 'avril',
            5: 'mai',
            6: 'juin',
            7: 'juillet',
            8: 'août',
            9: 'septembre',
            10: 'octobre',
            11: 'novembre',
            12: 'décembre'
        }
    },
    variables: {
        company: {
            title: 'Informations de votre entreprise',
            name: 'Nom de l\'entreprise',
            type: 'Type d\'entreprise',
            siret: 'N° SIRET',
            rcs: 'N° RCS',
            tva: 'N° TVA intracommunautaire',
            naf: 'Code NAF',
            capital: 'Capital'
        },
        customer: {
            title: 'Informations sur le client',
            name: 'Nom du client',
            code: 'Code du client'
        },
        contact: {
            title: 'Informations sur le contact',
            fullname: 'Nom complet',
            civility: 'Civilité abrégée (Ex: M.)',
            civilityFull: 'Civilité complète (Ex: Monsieur)',
            firstname: 'Prénom',
            lastname: 'Nom de famille',
            function: 'Fonction'
        },
        document: {
            title: 'Informations sur le document',
            reference: 'Numéro du document',
            date: 'Date',
            expDate: 'Date d\'expiration',
            customerCommand: 'N° du bon de commande client',
            invoiceAddress: 'Adresse de facturation',
            deliveryAddress: 'Adresse de livraison',
            documentTitle: 'Titre',
            depositAmount: 'Montant de l\'acompte',
            escompte: 'Escompte',
            escompteHt: 'Montant escompte HT',
            escompteTva: 'Montant escompte TVA',
            escompteTtc: 'Montant escompte TTC',
            penalty: 'Taux de pénalité',
            paymentTerm: 'Conditions de paiement',
            totalHt: 'Total HT',
            totalTva: 'Total TVA',
            totalTtc: 'Total TTC',
            toPaid: 'Montant à payer',
            alreadyPaid: 'Montant déjà payé',
            stayToPaid: 'Montant restant à payé',
            paymentLink: 'Lien de paiement',
            tracking: 'N° de suivi de la livraison'
        },
        date: {
            title: 'Date du jour',
            today: 'Date au format DD-MM-AAAA',
            todayNumber: 'Jour (lundi, mardi...)',
            dayNumber: 'Numéro du jour (1, 2, 3...)',
            monthNumber: 'Numéro du mois (1, 2, 3...)',
            month: 'Mois (janvier, février...)',
            year: 'Année'
        },
        signatureTitle: 'Signature électronique',
        signatureLink: 'Lien pour signer le document',
        construction: {
            title: 'Information sur le chantier',
            reference: 'Numéro du chantier',
            constructionTitle: 'Titre du chantier',
            contact: 'Contact du chantier',
            address: 'Adresse du chantier',
            begin: 'Début de la planification',
            end: 'Fin de la planification'
        },
        senderTitle: 'Informations sur l\'expéditeur',
        road: 'Adresse - rue',
        road2: 'Adresse - rue 2',
        road3: 'Adresse - rue 3',
        postal: 'Code postal',
        town: 'Ville',
        country: 'Pays',
        phone: 'Téléphone fixe',
        mobile: 'Téléphone portable',
        fax: 'Fax',
        email: 'Email',
        website: 'Site internet'
    },
    mailbox: {
        pageTitle: 'Boîte mail'
    }
};
var fr_agregateDatas = {
    loadMore: 'Charger plus d\'éléments',
    noDatas: 'Aucune donnée à afficher',
    newElement: 'Nouvel élément',
    file: 'Fichier',
    files: 'Fichiers',
    filesList: 'Liste des fichiers :',
    noFile: 'Aucun fichier',
    comment: 'Note',
    comments: 'Notes',
    task: 'Tâche',
    tasks: 'Tâches',
    report: 'Compte-rendu',
    reports: 'Compte-rendus',
    letter: 'Lettre',
    letters: 'Lettres',
    mails: 'Mails',
    history: 'Historique',
    appointment: 'Rendez-vous',
    appointments: 'Rendez-vous',
    commentBy: 'Commentaire par {name}',
    fileAdded: 'Ajout d\'un fichier',
    mailSendBy: '{name} a envoyé un email :',
    paymentLinkSendBy: '{name} a envoyé un lien de paiement pour un montant de {amount} à',
    paymentLink: 'Envoi d\'un lien de paiement pour un montant de {amount} à',
    paymentLinkExpired: 'À expiré le {datetime}',
    paymentLinkCanceled: 'Annulé le {datetime}',
    paymentLinkPaid: 'Payé le {datetime}',
    see: 'Voir',
    letterSend: 'Envoi d\'une lettre par {name}',
    render: 'Compte rendu : {type} par {name}'
};
/* harmony default export */ var fr = ({
    communication: fr_communicationLang,
    agregateDatas: fr_agregateDatas
});

;// ./src/lang/index.ts


var Lang = {
    en: en,
    fr: fr
};
/* harmony default export */ var lang = (Lang);

;// ./src/router/configRoutes.ts
var configRoutes_LibraryListView = function () { return Promise.all(/* import() | communication */[__webpack_require__.e(708), __webpack_require__.e(1)]).then(__webpack_require__.bind(__webpack_require__, 5294)); };
var configRoutes_LetterParamsView = function () { return Promise.all(/* import() | communication */[__webpack_require__.e(708), __webpack_require__.e(1)]).then(__webpack_require__.bind(__webpack_require__, 2077)); };
var configRoutes_ModelListView = function () { return Promise.all(/* import() | communication */[__webpack_require__.e(708), __webpack_require__.e(1)]).then(__webpack_require__.bind(__webpack_require__, 9695)); };
var configRoutes_CommunicationParamsView = function () { return Promise.all(/* import() | communication */[__webpack_require__.e(708), __webpack_require__.e(1)]).then(__webpack_require__.bind(__webpack_require__, 9052)); };
var ReportTypesView = function () { return Promise.all(/* import() | communication */[__webpack_require__.e(708), __webpack_require__.e(1)]).then(__webpack_require__.bind(__webpack_require__, 1579)); };
var routes = function (i18n) { return ([
    {
        name: 'communication-files',
        path: 'communication/files',
        component: configRoutes_LibraryListView,
        meta: {
            title: i18n.t('communication.files.pageTitle'),
            pageHeader: false
        }
    },
    {
        name: 'communication-letters',
        path: 'communication/letters',
        component: configRoutes_LetterParamsView,
        meta: {
            title: i18n.t('communication.letters.pageTitle'),
            appModule: 'communication-letters'
        }
    },
    {
        name: 'communication-models',
        path: 'communication/models',
        component: configRoutes_ModelListView,
        meta: {
            title: i18n.t('communication.models.pageTitle'),
            pageHeader: false
        }
    },
    {
        name: 'communication-params',
        path: 'communication/params',
        component: configRoutes_CommunicationParamsView,
        meta: {
            title: i18n.t('communication.params.pageTitle')
        }
    },
    {
        name: 'communication-report-types',
        path: 'communication/report-types',
        component: ReportTypesView,
        meta: {
            title: i18n.t('communication.reportType.pageTitle')
        }
    }
]); };
/* harmony default export */ var configRoutes = (routes);

;// ./src/router/routes.ts
var routes_SenderValidationView = function () { return Promise.all(/* import() | communication */[__webpack_require__.e(708), __webpack_require__.e(1)]).then(__webpack_require__.bind(__webpack_require__, 5090)); };
var MailboxView = function () { return Promise.all(/* import() | communication */[__webpack_require__.e(708), __webpack_require__.e(1)]).then(__webpack_require__.bind(__webpack_require__, 8061)); };
var routes_routes = function (i18n) { return ([
    {
        name: 'communication-sender-validation',
        path: '/mail/sender/validation/:token',
        component: routes_SenderValidationView,
        meta: {
            title: i18n.t('communication.mail.confirmSenderTitle'),
            pageHeader: false
        }
    },
    {
        name: 'mailbox',
        path: '/mailbox',
        component: MailboxView,
        meta: {
            title: i18n.t('communication.mailbox.pageTitle'),
            pageHeader: false,
            sidebarMode: 2
        }
    },
    {
        name: 'mailbox-folder',
        path: '/mailbox/:folder',
        component: MailboxView,
        meta: {
            title: i18n.t('communication.mailbox.pageTitle'),
            pageHeader: false,
            sidebarMode: 2
        }
    },
    {
        name: 'mailbox-mail',
        path: '/mailbox/mail/:id',
        component: MailboxView,
        meta: {
            title: i18n.t('communication.mailbox.pageTitle'),
            pageHeader: false,
            sidebarMode: 2
        }
    },
    {
        name: 'mailbox-folder-mail',
        path: '/mailbox/:folder/:id',
        component: MailboxView,
        meta: {
            title: i18n.t('communication.mailbox.pageTitle'),
            pageHeader: false,
            sidebarMode: 2
        }
    }
]); };
/* harmony default export */ var router_routes = (routes_routes);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
;// ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var esm_config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!esm_config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

;// ./src/store/modules/CommunicationStore.ts



var CommunicationStore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommunicationStore, _super);
    function CommunicationStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modelsLoaded = false;
        _this.models = [];
        _this.sendersLoaded = false;
        _this.senders = [];
        _this.mailForms = [];
        _this.reportTypesLoaded = false;
        _this.reportTypes = [];
        _this.mailLabelsLoaded = false;
        _this.mailLabels = [];
        return _this;
    }
    // CLEAR STORE STATE
    CommunicationStore.prototype.clearStore = function () {
        var _this = this;
        var elements = ['Models', 'Senders'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
        this.context.commit('clearMailForm');
    };
    CommunicationStore.prototype.setModelsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.modelsLoaded = state;
    };
    CommunicationStore.prototype.setModels = function (models) {
        this.models = models;
    };
    CommunicationStore.prototype.updateModel = function (model) {
        if (!this.modelsLoaded) {
            return;
        }
        var index = this.models.findIndex(function (cat) { return cat.id === model.id; });
        if (index >= 0) {
            external_vue_default().set(this.models, index, model);
        }
        else {
            this.models.push(model);
        }
    };
    CommunicationStore.prototype.removeModel = function (model) {
        if (!this.modelsLoaded) {
            return;
        }
        var index = this.models.findIndex(function (cat) { return cat.id === model.id; });
        if (index !== undefined) {
            external_vue_default()["delete"](this.models, index);
        }
    };
    CommunicationStore.prototype.loadModels = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.modelsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCommunication.axios.get('/mail/model', {
                                params: {
                                    per_page: 500,
                                    sort: 'name:asc'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setModels', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setModelsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CommunicationStore.prototype.setModel = function (model) {
        this.context.commit('updateModel', model);
    };
    CommunicationStore.prototype.deleteModel = function (model) {
        this.context.commit('removeModel', model);
    };
    Object.defineProperty(CommunicationStore.prototype, "defaultSender", {
        // Return defaut sender to use or the first
        get: function () {
            var validatedSenders = this.senders.filter(function (sender) { return sender.status.active && sender.is_validated; });
            var sender = validatedSenders.find(function (sender) { return sender.use_default; });
            if (sender) {
                return sender;
            }
            return validatedSenders.length > 0 ? validatedSenders[1] : undefined;
        },
        enumerable: false,
        configurable: true
    });
    CommunicationStore.prototype.setSendersLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.sendersLoaded = state;
    };
    CommunicationStore.prototype.setSenders = function (senders) {
        this.senders = senders;
    };
    CommunicationStore.prototype.updateSender = function (sender) {
        if (!this.sendersLoaded) {
            return;
        }
        var index = this.senders.findIndex(function (cat) { return cat.id === sender.id; });
        if (index >= 0) {
            external_vue_default().set(this.senders, index, sender);
        }
        else {
            this.senders.push(sender);
        }
    };
    CommunicationStore.prototype.removeSender = function (sender) {
        if (!this.sendersLoaded) {
            return;
        }
        var index = this.senders.findIndex(function (cat) { return cat.id === sender.id; });
        if (index !== undefined) {
            external_vue_default()["delete"](this.senders, index);
        }
    };
    CommunicationStore.prototype.loadSenders = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.sendersLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCommunication.axios.get('/mail/sender?per_page=500&with_shared=1')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setSenders', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setSendersLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CommunicationStore.prototype.setSender = function (sender) {
        this.context.commit('updateSender', sender);
    };
    CommunicationStore.prototype.deleteSender = function (sender) {
        this.context.commit('removeSender', sender);
    };
    // Open a new mail form
    CommunicationStore.prototype.addMailForm = function (mail) {
        this.mailForms.push(mail);
    };
    // Update an existing mail form
    CommunicationStore.prototype.updateMailForm = function (data) {
        external_vue_default().set(this.mailForms, data.index, data.mail);
    };
    // Delete a stored mail form
    CommunicationStore.prototype.removeMailForm = function (index) {
        this.mailForms.splice(index, 1);
    };
    // Delete all stored mail forms
    CommunicationStore.prototype.clearMailForm = function () {
        this.mailForms = [];
    };
    // Check if some mail form need to be collapsed
    CommunicationStore.prototype.checkOpenedForm = function (exclude) {
        var mails = this.mailForms.map(function (mail, index) { return ({ index: index, mail: mail }); });
        var opens = mails.filter(function (data) { return data.mail.mode === 'normal' && (exclude === undefined || exclude !== data.index); });
        var max = exclude === undefined ? 2 : 1;
        for (var i = 0; i < (opens.length - max); i++) {
            var mail = JSON.parse(JSON.stringify(opens[i].mail));
            mail.mode = 'collapsed';
            external_vue_default().set(this.mailForms, opens[i].index, mail);
        }
    };
    // open a new mail form
    CommunicationStore.prototype.openMailForm = function (mail) {
        var mailInit = Object.assign({
            mode: 'normal',
            mail: {}
        }, mail);
        this.context.commit('addMailForm', mailInit);
        this.context.commit('checkOpenedForm');
    };
    // Save an existing mail form
    CommunicationStore.prototype.saveMailForm = function (data) {
        var needCheckOpened = this.mailForms[data.index].mode !== data.mail.mode && data.mail.mode === 'normal';
        this.context.commit('updateMailForm', data);
        if (needCheckOpened) {
            this.context.commit('checkOpenedForm', data.index);
        }
    };
    // Close a mail form
    CommunicationStore.prototype.closeMailForm = function (index) {
        this.context.commit('removeMailForm', index);
    };
    CommunicationStore.prototype.setReportTypesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.reportTypesLoaded = state;
    };
    CommunicationStore.prototype.setReportTypes = function (types) {
        this.reportTypes = types;
    };
    CommunicationStore.prototype.updateReportType = function (type) {
        if (!this.reportTypesLoaded) {
            return;
        }
        var index = this.reportTypes.findIndex(function (cat) { return cat.id === type.id; });
        if (index >= 0) {
            external_vue_default().set(this.reportTypes, index, type);
        }
        else {
            this.reportTypes.push(type);
        }
    };
    CommunicationStore.prototype.removeReportType = function (type) {
        if (!this.reportTypesLoaded) {
            return;
        }
        var index = this.reportTypes.findIndex(function (cat) { return cat.id === type.id; });
        if (index !== undefined) {
            external_vue_default()["delete"](this.reportTypes, index);
        }
    };
    CommunicationStore.prototype.loadReportTypes = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.reportTypesLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCommunication.axios.get('/communication/report/type', {
                                params: {
                                    per_page: 500,
                                    sort: 'label:asc'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setReportTypes', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setReportTypesLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CommunicationStore.prototype.setReportType = function (type) {
        this.context.commit('updateReportType', type);
    };
    CommunicationStore.prototype.deleteReportType = function (type) {
        this.context.commit('removeReportType', type);
    };
    CommunicationStore.prototype.setMailLabelsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.mailLabelsLoaded = state;
    };
    CommunicationStore.prototype.setMailLabels = function (labels) {
        this.mailLabels = labels;
    };
    CommunicationStore.prototype.updateMailLabel = function (label) {
        if (!this.mailLabelsLoaded) {
            return;
        }
        var index = this.mailLabels.findIndex(function (cat) { return cat.id === label.id; });
        if (index >= 0) {
            external_vue_default().set(this.mailLabels, index, label);
        }
        else {
            this.mailLabels.push(label);
        }
    };
    CommunicationStore.prototype.removeMailLabel = function (label) {
        if (!this.mailLabels) {
            return;
        }
        var index = this.mailLabels.findIndex(function (cat) { return cat.id === label.id; });
        if (index !== undefined) {
            external_vue_default()["delete"](this.mailLabels, index);
        }
    };
    CommunicationStore.prototype.loadMailLabels = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.mailLabelsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwCommunication.axios.get('/mail/label', {
                                params: {
                                    per_page: 500,
                                    sort: 'label:asc'
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setMailLabels', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setMailLabelsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CommunicationStore.prototype.setMailLabel = function (type) {
        this.context.commit('updateMailLabel', type);
    };
    CommunicationStore.prototype.deleteMailLabel = function (type) {
        this.context.commit('removeMailLabel', type);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "setModelsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "setModels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "updateModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "removeModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "loadModels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "setModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "deleteModel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "setSendersLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "setSenders", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "updateSender", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "removeSender", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "loadSenders", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "setSender", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "deleteSender", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "addMailForm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "updateMailForm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "removeMailForm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "clearMailForm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "checkOpenedForm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "openMailForm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "saveMailForm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "closeMailForm", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "setReportTypesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "setReportTypes", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "updateReportType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "removeReportType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "loadReportTypes", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "setReportType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "deleteReportType", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "setMailLabelsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "setMailLabels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "updateMailLabel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], CommunicationStore.prototype, "removeMailLabel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "loadMailLabels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "setMailLabel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], CommunicationStore.prototype, "deleteMailLabel", null);
    CommunicationStore = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], CommunicationStore);
    return CommunicationStore;
}(VuexModule));
/* harmony default export */ var modules_CommunicationStore = (CommunicationStore);

;// ./src/broadcasts/team.ts

/* harmony default export */ var team = (function (store) { return ([
    {
        name: '.MailModelCreated',
        callback: function (model) {
            store.dispatch('communication/setModel', model);
        }
    },
    {
        name: '.MailModelUpdated',
        callback: function (model) {
            store.dispatch('communication/setModel', model);
        }
    },
    {
        name: '.MailModelDeleted',
        callback: function (model) {
            store.dispatch('communication/deleteModel', model);
        }
    },
    {
        name: '.SenderCreated',
        callback: function (sender) {
            store.dispatch('communication/setSender', sender);
        }
    },
    {
        name: '.SenderUpdated',
        callback: function (sender) {
            store.dispatch('communication/setSender', sender);
        }
    },
    {
        name: '.SenderDeleted',
        callback: function (sender) {
            store.dispatch('communication/deleteSender', sender);
        }
    },
    {
        name: '.ReportCreated',
        callback: function (report) {
            interface_vue_.emitter.emit('reportCreated', report);
        }
    },
    {
        name: '.ReportUpdated',
        callback: function (report) {
            interface_vue_.emitter.emit('reportUpdated', { new: report, old: null });
        }
    },
    {
        name: '.ReportDeleted',
        callback: function (report) {
            interface_vue_.emitter.emit('reportDeleted', report);
        }
    },
    {
        name: '.LetterCreated',
        callback: function (letter) {
            interface_vue_.emitter.emit('letterCreated', letter);
        }
    },
    {
        name: '.LetterUpdated',
        callback: function (letter) {
            interface_vue_.emitter.emit('letterUpdated', { new: letter, old: null });
        }
    },
    {
        name: '.LetterDeleted',
        callback: function (letter) {
            interface_vue_.emitter.emit('letterDeleted', letter);
        }
    },
    {
        name: '.MailSent',
        callback: function (event) {
            interface_vue_.emitter.emit('mailSent', event);
        }
    },
    {
        name: '.MailAttachmentsLoaded',
        callback: function (event) {
            interface_vue_.emitter.emit('mailAttachmentsLoaded', event);
        }
    }
]); });

;// ./src/broadcasts/teamUser.ts
/* harmony default export */ var teamUser = (function (store) { return ([
    {
        name: '.SenderCreated',
        callback: function (sender) {
            store.dispatch('communication/setSender', sender);
        }
    },
    {
        name: '.SenderUpdated',
        callback: function (sender) {
            store.dispatch('communication/setSender', sender);
        }
    },
    {
        name: '.SenderDeleted',
        callback: function (sender) {
            store.dispatch('communication/deleteSender', sender);
        }
    }
]); });

;// ./src/install.ts







var KwixeoCommunication = {
    install: function (Vue, options) {
        // Install lang
        this.installLang(options);
        Vue.prototype.$kwCommunication = options;
        // Install VueX
        this.installVueX(options);
        // Install routes
        this.installRoutes(options);
        __webpack_require__(7192);
        // Initialize broadcasts
        this.installBroadcasts(Vue, options);
    },
    installVueX: function (options) {
        var store = options.store;
        // Register VueX modules
        var modules = {
            communication: modules_CommunicationStore
        };
        forEach_default()(modules, function (module, key) {
            if (!store.hasModule(key)) {
                store.registerModule(key, module);
            }
        });
    },
    installRoutes: function (options) {
        var router = options.router;
        var i18n = options.i18n;
        router_routes(i18n).forEach(function (route) {
            router.addRoute(route);
        });
        configRoutes(i18n).forEach(function (route) {
            router.addRoute('configuration', route);
        });
    },
    installLang: function (options) {
        var i18n = options.i18n;
        forEach_default()(lang, function (messages, locale) {
            i18n.mergeLocaleMessage(locale, messages);
        });
    },
    installBroadcasts: function (Vue, options) {
        var broadcast = Vue.prototype.$broadcast;
        if (!broadcast) {
            return;
        }
        broadcast.registerListeners('team', team(options.store));
        broadcast.registerListeners('teamUser', teamUser(options.store));
    }
};
/* harmony default export */ var install = (KwixeoCommunication);

;// ./src/validate.ts

var validationRules = {
    mailRecipient: function (value, options, key, attributes, globalOptions) {
        return (0,form_vue_.email)(value.mail, options, key, attributes, globalOptions);
    }
};
/* harmony default export */ var validate = (validationRules);

;// ./src/index.ts





















































;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=communication.common.js.map